<template>
  <div id="workorder" class="workorder-page">
    <!-- 顶部业务切换：保持原 workorder.vue 的 tabs 风格 -->
    <div class="tabs-box clearfix">
      <div v-for="item in tabs" :key="item.value" :class="{ active: activeTab === item.value }"
        @click="switchTab(item.value)">
        <span>{{ item.label }}</span>
      </div>
    </div>

    <div class="workorder-body">
      <!-- ==================== 工单管理 ==================== -->
      <template v-if="activeTab === 'workorder'">
        <div class="toolbar workorder-toolbar clearfix">
          <el-button type="primary" class="add-btn" @click="openWorkorderDialog()" :disabled="!functionList.includes('workorderNew')||$store.state.isLook">
            新建工单
          </el-button>

          <div class="search-box">
            <span>工单类型：</span>
            <el-select v-model="workorderQuery.type" clearable placeholder="全部">
              <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <span>工单状态：</span>
            <el-select v-model="workorderQuery.status" clearable placeholder="全部">
              <el-option v-for="item in statusOptions" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>

            <el-input v-model.trim="workorderQuery.keyword" class="keyword-input" clearable placeholder="输入名称"
              @keyup.enter.native="filterWorkorders">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" @click="filterWorkorders">搜索</el-button>
          </div>
        </div>

        <div class="company-list clearfix">
          <ul class="list-title workorder-list-title">
            <li class="wo-customer">客户</li>
            <li class="wo-type">类型</li>
            <li class="wo-subject">事项</li>
            <li class="wo-status">状态</li>
            <li class="wo-duration">状态存续时间</li>
            <li class="wo-user">发起人</li>
            <li class="wo-user">审批人</li>
            <li class="wo-user">执行人</li>
            <li class="wo-operate">操作</li>
          </ul>

          <div class="scroll workorder-scroll">
            <ul class="list-details workorder-row" v-for="item in filteredWorkorders" :key="item.id">
              <li class="wo-customer" :title="item.customerName">
                <a href="javascript:;" @click="openCustomerDetailById(item.customerId)">
                  {{ item.customerName }}
                </a>
              </li>
              <li class="wo-type">{{ getWorkorderTypeName(item.typeName) }}</li>
              <li class="wo-subject" :title="item.subject">{{ item.subject }}</li>
              <li class="wo-status">
                <span :class="'status-' + item.status">{{ item.statusName }}</span>
              </li>
              <li class="wo-duration">{{ item.duration }}</li>
              <li class="wo-user" :title="item.applicant">{{ item.applicant }}</li>
              <li class="wo-user" :title="item.approver">{{ item.approver || '-' }}</li>
              <li class="wo-user" :title="item.executor">{{ item.executor || '-' }}</li>
              <li class="wo-operate operate">
                <span @click="openWorkorderDetail(item)">查看</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" v-if="canEditWorkorder(item)" @click="openWorkorderDialog(item)">编辑</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" v-if="canAssign(item)" @click="openAssignDialog(item)">指派</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" v-if="canSuspend(item)" @click="suspendWorkorder(item)">挂起</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" v-if="canResume(item)" @click="resumeWorkorder(item)">恢复</span>
                <span :class="{'disabled':$store.state.isLook}" v-if="canOpenForm(item)" @click="openFormDialog(item)">执行</span>
                <span :class="{'disabled':$store.state.isLook}" v-if="canComplete(item)" @click="openCompleteDialog(item)">完成</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" v-if="canDelete(item)" @click="confirmDeleteWorkorder(item)">删除</span>

              </li>
            </ul>

            <div class="nullDataBox" v-show="filteredWorkorders.length === 0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
            </div>
          </div>
        </div>

        <Pagination @setSize="setSize" @setNum="setNum" :totalCount="workorderTotalCount" :setNumber="pageNumber">
        </Pagination>
        <!-- 分页 -->
      </template>

      <!-- ==================== 客户管理 ==================== -->
      <template v-else-if="activeTab === 'customer'">
        <div class="toolbar clearfix">
          <el-button type="primary" class="add-btn" @click="openCustomerDialog()" :disabled="!functionList.includes('customerEdit')||$store.state.isLook">
            新建客户
          </el-button>

          <div class="simple-search">
            <div style="margin-right: 10px;">
              <span>客户类型：</span>
              <el-select v-model="customerQuery.type" clearable placeholder="全部" style="width: 150px;">
                <el-option v-for="item in customerTypeOptions" :key="item.value" :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </div>
            <el-input v-model.trim="customerQuery.keyword" class="keyword-input" clearable placeholder="输入编号或名称"
              @keyup.enter.native="filterCustomers">
              <i slot="suffix" class="el-input__icon el-icon-search"></i>
            </el-input>
            <el-button type="primary" @click="filterCustomers">搜索</el-button>
          </div>
        </div>

        <div class="company-list clearfix">
          <ul class="list-title customer-list-title">
            <!-- <li>编号</li> -->
            <li>名称</li>
            <li>全称</li>
            <li>关联云端企业</li>
            <li>客户类型</li>
            <li>服务期限</li>
            <li>关联用户</li>
            <li class="customer-operate">操作</li>
          </ul>

          <div class="scroll customer-scroll">
            <ul class="list-details customer-row" v-for="(item, index) in filteredCustomers" :key="item.id">
              <!-- <li>{{ item.code }}</li> -->
              <li>{{ item.name }}</li>
              <li :title="item.fullName">{{ item.fullName }}</li>
              <li>{{ item.cloudCompany }}</li>
              <li>{{ getCurrentTypeName(item.type) }}</li>
              <li>
                <span :class="{ 'service-expired': isExpired(item.serviceEnd) }">
                  {{ item.serviceEnd }}
                </span>
              </li>
              <li>{{ item.relatedUser }}</li>
              <li class="customer-operate operate">
                <span @click="openCustomerDetail(item)">详情</span>
                <span :class="{'disabled':!functionList.includes('customerEdit')||$store.state.isLook}" @click="openCustomerDialog(item, index)">编辑</span>
                <span :class="{'disabled':!functionList.includes('customerEdit')||$store.state.isLook}" @click="confirmDeleteCustomer(item)">删除</span>
              </li>
            </ul>

            <div class="nullDataBox" v-show="filteredCustomers.length === 0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
            </div>
          </div>
        </div>

        <Pagination @setSize="setCustomerSize" @setNum="setCustomerNum" :totalCount="customerTotalCount"
          :setNumber="pageNumber">
        </Pagination>
      </template>

      <!-- ==================== 模板管理 ==================== -->
      <template v-else>
        <div class="toolbar clearfix">
          <el-button type="primary" class="add-btn" @click="openTemplateDialog()" :disabled="!functionList.includes('workorderEdit')||$store.state.isLook">
            新建模板
          </el-button>
        </div>

        <div class="company-list clearfix">
          <ul class="list-title">
            <li class="col-name">名称</li>
            <li class="col-remark">标题</li>
            <li class="col-time">创建时间</li>
            <li class="col-time">最后编辑</li>
            <li class="col-operate">操作</li>
          </ul>

          <div class="scroll">
            <ul class="list-details" v-for="(item, index) in templateList" :key="item.id">
              <li class="col-name" :title="item.name">{{ item.name }}</li>
              <li class="col-remark" :title="item.formTitle">{{ item.formTitle }}</li>
              <li class="col-time">{{ item.createTime }}</li>
              <li class="col-time">{{ item.updateTime }}</li>
              <li class="col-operate operate">
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" @click="openTemplateDialog(item, index)">编辑</span>
                <span @click="openTemplatePreview(item)">预览</span>
                <span :class="{'disabled':!functionList.includes('workorderEdit')||$store.state.isLook}" @click="openDeleteDialog(item, index)">删除</span>
              </li>
            </ul>

            <div class="nullDataBox" v-show="templateList.length === 0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
            </div>
          </div>
        </div>

        <Pagination @setSize="setTemplateSize" @setNum="setTemplateNum" :totalCount="templateTotalCount"
          :setNumber="pageNumber">
        </Pagination>
      </template>
    </div>

    <!-- ==================== 弹窗 ==================== -->
    <div class="popup">
      <!-- 新建/编辑工单 -->
      <div class="popup-workorder" v-show="workorderDialogShow">
        <div class="popup-title">
          {{ currentWorkorder.id ? '编辑工单' : '新建工单' }}{{ customerDetailShow && currentCustomer.name ? ' - ' + currentCustomer.name : '' }}
          <i :class="customerDetailShow ? 'el-icon-back close' : 'el-icon-circle-close close'" @click="closeWorkorderDialog"></i>
        </div>

        <el-form :model="workorderForm" :rules="workorderRules" ref="workorderForm" class="workorder-form" :disabled="$store.state.isLook">
          <div class="form-column">
            <el-form-item label="关联客户：" prop="customerId" class="required-label">
              <el-autocomplete v-model="workorderForm.customerName" class="full-width"
                :fetch-suggestions="queryCustomer" placeholder="请输入客户名称" @select="handleCustomerSelect">
                <template slot-scope="{ item }">
                  <span>{{ item.name }}</span>
                </template>
              </el-autocomplete>
            </el-form-item>

            <el-form-item label="事项：" prop="subject" class="required-label">
              <el-input v-model="workorderForm.subject"></el-input>
            </el-form-item>

            <el-form-item label="联系人：" prop="contact" class="required-label">
              <el-input v-model="workorderForm.contact"></el-input>
            </el-form-item>

            <el-form-item label="期望派工时间：" prop="dispatchDate" class="required-label">
              <el-date-picker v-model="workorderForm.dispatchDate" type="datetime" placeholder="选择日期时间"
                format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
              </el-date-picker>
            </el-form-item>


            <el-form-item label="详细描述：" prop="description" class="required-label">
              <el-input type="textarea" class="workorder-remark" v-model="workorderForm.description" maxlength="256"
                show-word-limit placeholder="请输入内容">
              </el-input>
            </el-form-item>
          </div>

          <div class="form-column right-column">
            <el-form-item label="工单类型：" prop="type" class="required-label">
              <el-select v-model="workorderForm.type" placeholder="请选择">
                <el-option v-for="item in orderTypeOptions" :key="item.value" :label="item.label" :value="item.value" v-if="item.value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="执行方式：" prop="executeMode" class="required-label execute-item">
              <el-tooltip content="自主执行：由申请人直接开始执行工单，无需审批、立即执行" placement="top" effect="light">
                <i class="el-icon-question execute-tip"></i>
              </el-tooltip>
              <el-radio-group v-model="workorderForm.executeMode">
                <el-radio label="apply">申请</el-radio>
                <el-radio label="self" :disabled="!functionList.includes('workorderAuto')">自主执行</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="联系电话：" prop="phone" class="required-label">
              <el-input v-model="workorderForm.phone"></el-input>
            </el-form-item>

            <el-form-item label="相关图片及视频：" class="media-upload-stacked">
              <div class="media-list">
                <div class="media-thumb media-real media-upload-item" v-for="(item, index) in workorderForm.mediaList" :key="item.uid">
                  <img v-if="item.url && item.type.indexOf('image/') === 0" :src="item.url">
                  <i v-else class="el-icon-video-camera"></i>
                  <div v-if="isLargeMedia(item) && item.uploading" class="media-progress-mask">
                    <el-progress :percentage="Number(item.progress || 0)" :stroke-width="5" :show-text="true"></el-progress>
                  </div>
                  <span class="media-upload-status" v-if="item.uploading && isLargeMedia(item)">上传中 {{ Number(item.progress || 0) }}%</span>
                  <span class="media-remove" @click="removeMedia(index)">×</span>
                </div>

                <el-upload v-show="workorderForm.mediaList.length < 9" class="inline-upload" action="#"
                  :show-file-list="false" :auto-upload="false" accept="image/*,video/*"
                  :on-change="handleWorkorderMedia">
                  <span class="add-media">{{workorderForm.mediaList.length?"继续添加":"添加"}}</span>
                </el-upload>
              </div>
              <div class="media-help">最多 9 个，单次总大小不超过 50MB</div>

            </el-form-item>
          </div>
        </el-form>

        <p class="popup-btn-box">
          <el-button type="primary" :disabled="!functionList.includes('workorderEdit')||$store.state.isLook || isMediaUploading(workorderForm.mediaList)" @click="saveWorkorder">确定</el-button>
          <el-button @click="closeWorkorderDialog">取消</el-button>
        </p>
      </div>

      <!-- 新建/编辑客户：按原型采用左右双列布局 -->
      <div class="popup-customer" v-show="customerDialogShow">
        <div class="popup-title">
          {{ customerEditIndex === null ? '新建客户' : '编辑客户' }}
          <i class="el-icon-circle-close close" @click="closeCustomerDialog"></i>
        </div>

        <el-form :model="customerForm" :rules="customerRules" ref="customerForm" label-width="72px"
          class="customer-form customer-form-prototype" :disabled="$store.state.isLook">
          <div class="customer-form-grid">
            <!-- 左列 -->
            <div class="customer-form-col customer-form-left">
              <el-form-item label="名称：" prop="name">
                <el-input v-model="customerForm.name" placeholder="请输入名称"></el-input>
              </el-form-item>

              <el-form-item label="联系人：" prop="contact">
                <el-input v-model="customerForm.contact" placeholder="请输入联系人"></el-input>
              </el-form-item>

              <el-form-item label="地址：" prop="address">
                <el-input v-model="customerForm.address" placeholder="请输入地址"></el-input>
              </el-form-item>


              <el-form-item label="服务到期时间：" prop="serviceEnd" class="customer-date-item">
                <el-date-picker v-model="customerForm.serviceEnd" type="date" format="yyyy-MM-dd"
                  value-format="yyyy-MM-dd" placeholder="选择服务到期日">
                </el-date-picker>
              </el-form-item>

              <el-form-item label="客户类型：" prop="type">
                <el-select v-model="customerForm.type" clearable filterable placeholder="请选择">
                  <el-option v-for="item in customerTypeOptions" :key="item.value" :label="item.label"
                    v-if="item.value" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="关联云端企业：">
                <el-select v-model="customerForm.cloudEnterpriseId" clearable filterable placeholder="请选择"
                  @change="handleCustomerCompanyChange">
                  <el-option v-for="item in companyOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="备注：">
                <el-input type="textarea" :rows="3" maxlength="256" v-model="customerForm.remark" placeholder="请输入内容"></el-input>
              </el-form-item>
            </div>

            <!-- 右列 -->
            <div class="customer-form-col customer-form-right">
              <el-form-item label="全称：" prop="fullName">
                <el-input v-model="customerForm.fullName" placeholder="请输入全称"></el-input>
              </el-form-item>

              <el-form-item label="联系电话：" prop="phone">
                <el-input v-model="customerForm.phone" placeholder="请输入联系电话"></el-input>
              </el-form-item>

              <el-form-item label="关联业务员：" prop="salesman">
                <el-select v-model="customerForm.salesman" clearable multiple filterable collapse-tags
                  placeholder="请选择">
                  <el-option v-for="item in userOptions" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item label="客户简介：" class="customer-introduction-item">
                <el-input v-model="customerForm.introduction" type="textarea" :rows="3" maxlength="256" show-word-limit
                  placeholder="请输入内容">
                </el-input>
              </el-form-item>

              <el-form-item label="相关图片及视频：" class="customer-media-item media-upload-stacked">
                <div class="media-list customer-media-list customer-media-prototype" :style="{ minHeight: customerForm.mediaList.length?'86px':'0'}">
                  <div class="media-thumb media-real media-upload-item" v-for="(item, index) in customerForm.mediaList" :key="item.uid">
                    <img v-if="item.url && item.type.indexOf('image/') === 0" :src="item.url">
                    <i v-else class="el-icon-video-camera"></i>
                    <div v-if="isLargeMedia(item) && item.uploading" class="media-progress-mask">
                      <el-progress :percentage="Number(item.progress || 0)" :stroke-width="5" :show-text="true"></el-progress>
                    </div>
                    <span class="media-upload-status" v-if="item.uploading && isLargeMedia(item)">上传中 {{ Number(item.progress || 0) }}%</span>
                    <span class="media-remove" @click="removeCustomerMedia(index)">×</span>
                  </div>

                  <el-upload v-show="customerForm.mediaList.length < 9" class="inline-upload" action="#"
                    :show-file-list="false" :auto-upload="false" accept="image/*,video/*"
                    :on-change="handleCustomerMedia">
                    <span class="add-media">{{customerForm.mediaList.length?"继续添加":"添加"}}</span>
                  </el-upload>
                </div>
                <div class="media-help customer-media-help">最多 9 个，单次总大小不超过 50MB</div>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <p class="popup-btn-box customer-popup-btn-box">
          <el-button type="primary" :disabled="!functionList.includes('customerEdit')||$store.state.isLook || isMediaUploading(customerForm.mediaList)" @click="saveCustomer">确定</el-button>
          <el-button @click="closeCustomerDialog">取消</el-button>
        </p>
      </div>

      <!-- 客户详情 -->
      <div class="popup-detail popup-large" v-show="customerDetailShow">
        <div class="popup-title">
          {{ currentCustomer.name || '客户详情' }}
          <i class="el-icon-circle-close close" @click="closeCustomerDetail"></i>
        </div>

        <div class="detail-tabs">
          <span v-for="item in customerDetailTabs" :key="item.value"
            :class="{ active: customerDetailTab === item.value }" @click="switchCustomerDetailTab(item.value)">
            {{ item.label }}
          </span>
        </div>

        <div v-show="customerDetailTab === 'basic'" class="detail-content customer-basic">
          <div class="detail-grid">
            <!-- <div><label>编号</label><span>{{ currentCustomer.code }}</span></div> -->
            <div><label>名称</label><span>{{ currentCustomer.name }}</span></div>
            <div><label>全称</label><span>{{ currentCustomer.fullName }}</span></div>
            <div><label>联系人</label><span>{{ currentCustomer.contact }}</span></div>
            <div><label>联系电话</label><span>{{ currentCustomer.phone }}</span></div>
            <div><label>地址</label><span>{{ currentCustomer.address }}</span></div>
            <div><label>关联云端企业</label><span>{{ currentCustomer.cloudCompany }}</span></div>
            <div><label>客户类型</label><span>{{ getCurrentTypeName(currentCustomer.type) }}</span></div>
            <div><label>服务期限</label><span>{{ currentCustomer.serviceEnd }}</span></div>
            <div><label>关联用户</label><span>{{ currentCustomer.relatedUser }}</span></div>
            <div class="detail-wide"><label>简介</label><span>{{ currentCustomer.introduction }}</span></div>
            <div class="detail-wide"><label>备注</label><span>{{ currentCustomer.remark }}</span></div>
          </div>

          <div class="detail-media">
            <div class="detail-section-title">相关图片及视频</div>
            <div class="detail-media-grid">
              <div v-for="item in currentCustomer.mediaList" :key="item.uid" class="detail-media-item detail-media-clickable" @click="openMediaPreview(item)">
                <img v-if="isImageMedia(item)" :src="buildMediaUrl(item.url)">
                <video v-else-if="isVideoMedia(item)" :src="buildMediaUrl(item.url)" muted preload="metadata"></video>
                <i v-else class="el-icon-document"></i>
                <span v-if="isVideoMedia(item)" class="detail-video-play"><i class="el-icon-video-play"></i></span>
              </div>
            </div>
          </div>
        </div>

        <div v-show="customerDetailTab === 'device'" class="detail-content" style="height: 520px;">
          <div class="sub-toolbar">
            <el-button type="primary" size="small" @click="openDeviceDialog()" :disabled="!functionList.includes('customerEdit')||$store.state.isLook">新建设备</el-button>
            <el-input v-model.trim="deviceQuery.keyword" class="sub-search" clearable placeholder="设备名称/序列号">
            </el-input>
            <el-button size="small" @click="filterDevices">搜索</el-button>
          </div>

          <div class="inner-table" style="height: 425px; margin-bottom: 16px;">
            <ul class="inner-table-head">
              <li class="w-120">设备名称</li>
              <li class="w-120">云端设备</li>
              <li class="w-120">序列号</li>
              <li style="width: 210px;">备注</li>
              <!-- <li>规格参数</li> -->
              <!-- <li>相关文件</li> -->
              <li style="width: 210px;">操作</li>
            </ul>
            <div style="height:400px; overflow: auto;">
              <ul class="inner-table-row" v-for="item in customerDevices" :key="item.id">
                <li class="w-120" :title="item.name">{{ item.name }}</li>
                <li class="w-120" :title="item.cloudEquipmentName">{{ item.cloudEquipmentName || '-' }}</li>
                <li class="w-120" :title="item.serialNo">{{ item.serialNo ||'-' }}</li>
                <li style="width: 210px;" :title="item.remark">{{ item.remark || '-' }}</li>
                <!-- <li :title="formatSpecParams(item.specParams)">{{ formatSpecParams(item.specParams) }}</li> -->
                <!-- <li>{{ getFileUrlList(item.fileUrl).length ? getFileUrlList(item.fileUrl).length + ' 个' : '-' }}</li> -->
                <li class="operate" style="width: 210px;">
                  <span @click="openDeviceDetail(item.id,1)">详情</span>
                  <span :class="{'disabled':!functionList.includes('customerEdit')||$store.state.isLook}" @click="openDeviceDialog(item)">编辑</span>
                  <span :class="{'disabled':!functionList.includes('customerEdit')||$store.state.isLook}" @click="confirmDeleteDevice(item)">删除</span>
                  <span :class="{'disabled':!functionList.includes('customerEdit')||$store.state.isLook}" @click="openDeviceMaintenance(item)">维保记录</span>
                </li>
              </ul>
              <!-- <div class="inner-empty" v-show="customerDevices.length === 0">暂无设备档案</div> -->
              <div class="nullDataBox" v-show="customerDevices.length === 0">
                <img :src="nullData" class="nullData">
                <span>什么东西都没有找到...</span>
              </div>
            </div>
          </div>
          <Pagination v-if="deviceTotalCount > 0" @setSize="setDeviceSize" @setNum="setDeviceNum"
            :totalCount="deviceTotalCount" :setNumber="devicePageNumber">
          </Pagination>
        </div>

        <div v-show="customerDetailTab === 'maintenance'" class="detail-content">
          <div class="sub-toolbar">
            <el-button type="primary" size="small" @click="exportCustomerMaintenance" :disabled="!functionList.includes('customerEdit')||$store.state.isLook">导出</el-button>
            <el-input v-model.trim="maintenanceQuery.keyword" class="sub-search" clearable placeholder="设备名称/维保内容">
            </el-input>
            <el-button size="small" @click="filterCustomerMaintenance">搜索</el-button>
          </div>

          <div class="inner-table" style="height: 425px; margin-bottom: 16px;">
            <ul class="inner-table-head">
              <li class="w-120">关联工单</li>
              <li style="width: 210px;">设备</li>
              <li style="width: 210px;">维保内容</li>
              <li class="w-120">维保时间</li>
              <li class="w-120">执行人</li>
              <!-- <li>备注</li> -->
            </ul>
            <div style="height: 400px; overflow: auto;">
            <ul class="inner-table-row" v-for="item in customerMaintenance" :key="item.id">
              <li class="w-120">
                <a v-if="item.workorderId" href="javascript:;" @click="openWorkorderById(item.workorderId)">
                  {{ item.workorderId }}
                </a>
                <span v-else>-</span>
              </li>
               <li style="width: 210px;">
                <div style="line-height: 28px;" v-for="id,i in item.equipmentId.split(',')" :key="i">
                  <a href="javascript:;" @click="openDeviceDetail(id,1)">{{ item.equipmentName.split(',')[i] }}</a>
                </div>
               </li>
              <li style="width: 210px;" :title="item.maintContent">{{ item.maintContent || '-' }}</li>
              <li class="w-120">{{ item.maintDate || '-' }}</li>
              <li class="w-120">{{ item.executor || '-' }}</li>
              <!-- <li :title="item.remark">{{ item.remark || '-' }}</li> -->
            </ul>
            </div>
            <!-- <div class="inner-empty" v-show="customerMaintenance.length === 0">暂无维保记录</div> -->
            <div class="nullDataBox" v-show="customerMaintenance.length === 0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
            </div>
          </div>
          <Pagination v-if="maintenanceTotalCount > 0"
            @setSize="setMaintenanceSize" @setNum="setMaintenanceNum"
            :totalCount="maintenanceTotalCount" :setNumber="maintenancePageNumber">
          </Pagination>
        </div>

        <p class="popup-btn-box">
          <el-button type="primary" @click="closeCustomerDetail">确定</el-button>
        </p>
      </div>

      <!-- 设备新建/编辑 -->
      <div class="popup-device" v-show="deviceDialogShow">
        <div class="popup-title">
          {{ deviceEditId ? '编辑设备' : '新建设备' }}{{ customerDetailShow && currentCustomer.name ? ' - ' + currentCustomer.name : '' }}
          <i :class="customerDetailShow ? 'el-icon-back close' : 'el-icon-circle-close close'" @click="closeDeviceDialog"></i>
        </div>

        <el-form :model="deviceForm" :rules="deviceRules" ref="deviceForm" label-width="0"
          class="device-form-prototype" :disabled="$store.state.isLook">
          <div class="device-form-grid device-form-prototype-grid">
            <div class="device-form-col device-form-left">
              <el-form-item label="名称：" prop="name">
                <el-input v-model="deviceForm.name" placeholder="请输入设备名称"></el-input>
              </el-form-item>

              <el-form-item label="序列号：" prop="serialNo">
                <el-input v-model="deviceForm.serialNo" placeholder="请输入序列号"></el-input>
              </el-form-item>

              <el-form-item label="关联云端设备：">
                <el-select v-model="deviceForm.cloudEquipmentId" clearable filterable placeholder="请选择关联设备"
                  @change="handleCloudDeviceChange">
                  <el-option v-for="item in cloudDeviceOptions" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item v-if="deviceForm.cloudEquipmentId" label="设备key：" prop="equipmentKey">
                <el-input v-model.trim="deviceForm.equipmentKey" disabled placeholder="选择关联云端设备后自动获取"></el-input>
              </el-form-item>

              <el-form-item label="备注：" class="device-remark-item">
                <el-input v-model="deviceForm.remark" type="textarea" :rows="3" maxlength="256" show-word-limit
                  placeholder="请输入内容">
                </el-input>
              </el-form-item>

              <el-form-item label="相关图片及视频：" class="device-media-item media-upload-stacked">
                <div class="media-list device-media-list">
                  <div class="media-thumb media-real media-upload-item" v-for="(item, index) in deviceForm.mediaList" :key="item.uid">
                    <img v-if="item.url && item.type.indexOf('image/') === 0" :src="item.url">
                    <i v-else class="el-icon-video-camera"></i>
                    <div v-if="isLargeMedia(item) && item.uploading" class="media-progress-mask">
                      <el-progress :percentage="Number(item.progress || 0)" :stroke-width="5" :show-text="true"></el-progress>
                    </div>
                    <span class="media-upload-status" v-if="item.uploading && isLargeMedia(item)">上传中 {{ Number(item.progress || 0) }}%</span>
                    <span class="media-remove" @click="removeDeviceMedia(index)">×</span>
                  </div>

                  <el-upload v-show="deviceForm.mediaList.length < 9" class="inline-upload" action="#"
                    :show-file-list="false" :auto-upload="false" accept="image/*,video/*"
                    :on-change="handleDeviceMedia">
                    <span class="add-media">{{deviceForm.mediaList.length?"继续添加":"添加"}}</span>
                  </el-upload>
                </div>
                <div class="media-help device-media-help">最多 9 个，单次总大小不超过 50MB，选择后自动上传</div>
              </el-form-item>
            </div>

            <div class="device-form-col device-form-right">
              <el-form-item label="规格参数：" prop="specParams" class="device-params-item">
                <div class="device-params-list">
                  <div class="device-param-row" v-for="(param, index) in deviceForm.specParams"
                    :key="param.uid || index">
                    <el-input v-model.trim="param.title" placeholder="名称"
                      @blur="validateDeviceSpecParams"></el-input>
                    <el-input v-model.trim="param.content" placeholder="值"
                      @blur="validateDeviceSpecParams"></el-input>
                    <span class="device-param-delete" @click="removeDeviceParam(index)">删除</span>
                  </div>
                </div>
                <span class="add-device-param" @click="addDeviceParam">+新增规格参数</span>
              </el-form-item>
            </div>
          </div>
        </el-form>

        <p class="popup-btn-box">
          <el-button type="primary" :disabled="!functionList.includes('customerEdit')||$store.state.isLook || isMediaUploading(deviceForm.mediaList)" @click="saveDevice">确定</el-button>
          <el-button @click="closeDeviceDialog">取消</el-button>
        </p>
      </div>

      <!-- 设备详情 -->
      <div class="popup-device-detail popup-large" v-show="deviceDetailShow">
        <div class="popup-title">
          {{ showType == 2 ? '维保记录' : '设备详情' }}{{ customerDetailShow && currentCustomer.name ? ' - ' + currentCustomer.name : '' }}
          <i :class="customerDetailShow ? 'el-icon-back close' : 'el-icon-circle-close close'" @click="closeDeviceDetail"></i>
        </div>

        <div class="device-detail-body">
          <div class="device-info-grid" v-show="showType==1">
            <div><label>设备名称</label><span>{{ currentDevice.name }}</span></div>
            <div><label>序列号</label><span>{{ currentDevice.serialNo || '-' }}</span></div>
            <div><label>设备key</label><span>{{ currentDevice.equipmentKey }}</span></div>
            <div><label>云端设备</label><span>{{ currentDevice.cloudEquipmentName || '-' }}</span></div>
            <div class="detail-wide device-spec-detail">
              <label class="device-spec-title">规格参数</label>
              <div class="device-spec-table" v-if="currentDevice.specParams && currentDevice.specParams.length">
                <div
                  class="device-spec-row"
                  v-for="(param, index) in currentDevice.specParams"
                  :key="param.uid || index">
                  <div class="device-spec-name">{{ param.title }}</div>
                  <div class="device-spec-value">{{ param.content }}</div>
                </div>
              </div>
              <div class="device-spec-empty" v-else>-</div>
            </div>
            <div class="detail-wide"><label>备注</label><span>{{ currentDevice.remark || '-' }}</span></div>
          </div>

          <div class="detail-section-title" v-show="showType==1">相关图片及视频</div>
          <div class="detail-media-grid" v-show="showType==1">
            <div v-for="item in currentDevice.mediaList" :key="item.uid" class="detail-media-item detail-media-clickable" @click="openMediaPreview(item)">
              <img v-if="isImageMedia(item)" :src="buildMediaUrl(item.url)">
              <video v-else-if="isVideoMedia(item)" :src="buildMediaUrl(item.url)" muted preload="metadata"></video>
              <i v-else class="el-icon-document"></i>
              <span v-if="isVideoMedia(item)" class="detail-video-play"><i class="el-icon-video-play"></i></span>
            </div>
            <div class="inner-empty" v-show="currentDevice.mediaList && currentDevice.mediaList.length === 0">暂无相关图片及视频</div>
          </div>

          <div class="detail-section-title" v-show="showType==2">维保记录</div>
          <div class="inner-table" v-show="showType==2" style="height: 425px; margin-bottom: 16px;">
            <ul class="inner-table-head">
              <li class="w-120">日期</li>
              <li style="width:210px">执行人</li>
              <li class="w-120">关联工单</li>
              <li class="w-120">关联设备</li>
              <li style="width:210px">维保内容</li>
              <!-- <li>备注</li> -->
              <!-- <li>记录ID</li> -->
            </ul>
            <div style="height: 400px; overflow: auto;">
            <ul class="inner-table-row" v-for="item in deviceMaintenance" :key="item.id">
              <li class="w-120">{{ item.maintDate || '-' }}</li>
              <li style="width:210px">{{ item.executor || '-' }}</li>
              <li class="w-120">
                <a v-if="item.workorderId" href="javascript:;" @click="openWorkorderById(item.workorderId)">
                  {{ item.workorderId }}
                </a>
                <span v-else>-</span>
              </li>
              <li class="w-120">{{ item.equipmentName || currentDevice.name }}</li>
              <li style="width:210px" :title="item.maintContent">{{ item.maintContent || '-' }}</li>
              <!-- <li :title="item.remark">{{ item.remark || '-' }}</li> -->
              <!-- <li>{{ item.id }}</li> -->
            </ul>
            </div>
            <!-- <div class="inner-empty" v-show="deviceMaintenance.length === 0">暂无维保记录</div> -->
            <div class="nullDataBox" v-show="deviceMaintenance.length === 0">
              <img :src="nullData" class="nullData">
              <span>什么东西都没有找到...</span>
            </div>
          </div>
        </div>

        <p class="popup-btn-box">
          <el-button type="primary" @click="closeDeviceDetail">确定</el-button>
        </p>
      </div>

      <!-- 新建维保记录 -->
      <!--
      <div class="popup-maintenance" v-show="maintenanceDialogShow">
        <div class="popup-title">
          新建维保记录
          <i class="el-icon-circle-close close" @click="closeMaintenanceDialog"></i>
        </div>

        <el-form :model="maintenanceForm" :rules="maintenanceRules" ref="maintenanceForm" label-width="100px">
          <el-form-item label="客户：" prop="customerId">
            <el-select v-model="maintenanceForm.customerId" disabled>
              <el-option v-for="item in customers" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="设备：" prop="deviceId">
            <el-select v-model="maintenanceForm.deviceId">
              <el-option v-for="item in customerDevices" :key="item.id" :label="item.name + ' / ' + item.serialNo"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保类型：" prop="type">
            <el-select v-model="maintenanceForm.type">
              <el-option label="保养" value="保养"></el-option>
              <el-option label="维修" value="维修"></el-option>
              <el-option label="巡检" value="巡检"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="维保时间：" prop="date">
            <el-date-picker v-model="maintenanceForm.date" type="datetime" format="yyyy-MM-dd HH:mm:ss"
              value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="执行人：">
            <el-input v-model="maintenanceForm.executor"></el-input>
          </el-form-item>
          <el-form-item label="关联工单：">
            <el-select v-model="maintenanceForm.workorderId" clearable>
              <el-option v-for="item in workorders" :key="item.id" :label="item.code + ' / ' + item.subject"
                :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="备注：">
            <el-input v-model="maintenanceForm.remark" type="textarea" :rows="4">
            </el-input>
          </el-form-item>
        </el-form>

        <p class="popup-btn-box">
          <el-button type="primary" @click="saveMaintenance">确定</el-button>
          <el-button @click="closeMaintenanceDialog">取消</el-button>
        </p>
      </div>
       -->

      <!-- 工单详情 -->
      <div class="popup-detail popup-large workorder-detail-dialog" :class="{'offset-dialog': customerDetailShow}" v-show="workorderDetailShow">
        <div class="popup-title">
          工单详情{{ customerDetailShow && currentCustomer.name ? ' - ' + currentCustomer.name : '' }}
          <i :class="customerDetailShow ? 'el-icon-back close' : 'el-icon-circle-close close'" @click="closeWorkorderDetail"></i>
        </div>
        <div class="detail-box">
        <div class="detail-grid">
          <div><label>类型</label><span>{{ currentWorkorder.typeName }}</span></div>
          <div><label>客户</label><span>{{ currentWorkorder.customerName }}</span></div>
          <div><label>联系人</label><span>{{ currentWorkorder.contact }}</span></div>
          <div><label>事项</label><span>{{ currentWorkorder.subject }}</span></div>
          <div><label>联系电话</label><span>{{ currentWorkorder.phone }}</span></div>
          <div><label>状态</label><span :class="'status-' + currentWorkorder.status">{{ currentWorkorder.statusName}}</span></div>
          <div><label>地址</label><span>{{ currentWorkorder.address }}</span></div>
          <div><label>状态持续时间</label><span>{{ currentWorkorder.duration }}</span></div>
          <div><label>申请人</label><span>{{ currentWorkorder.applicant }}</span></div>
          <div><label>执行人</label><span>{{ currentWorkorder.executor || '-' }}</span></div>
          <div><label>审批人</label><span>{{ currentWorkorder.approver || '-' }}</span></div>
          <div><label>期望派工时间</label><span>{{ currentWorkorder.dispatchDate || '-' }}</span></div>
          <div><label>关联设备</label><span>{{ currentWorkorder.equipmentName || '-' }}</span></div>
          <div class="detail-wide"><label>详细描述</label><span>{{ currentWorkorder.description || '-' }}</span></div>
        </div>

        <div class="detail-section-title">相关图片及视频</div>
        <div class="detail-media-grid">
          <div v-for="item in currentWorkorder.mediaList" :key="item.uid" class="detail-media-item detail-media-clickable" @click="openMediaPreview(item)">
            <img v-if="isImageMedia(item)" :src="buildMediaUrl(item.url)">
            <video v-else-if="isVideoMedia(item)" :src="buildMediaUrl(item.url)" muted preload="metadata"></video>
            <i v-else class="el-icon-document"></i>
            <span v-if="isVideoMedia(item)" class="detail-video-play"><i class="el-icon-video-play"></i></span>
          </div>
          <div class="inner-empty" v-show="!currentWorkorder.mediaList || currentWorkorder.mediaList.length === 0">暂无相关图片及视频</div>
        </div>

        <!-- 已完成工单的表单内容直接合并到详情弹窗中 -->
        <div v-if="workorderPreview && (workorderPreview.title || workorderPreview.name || (workorderPreview.shortFields || []).length || (workorderPreview.tableRows || []).length || (workorderPreview.longFields || []).length)" class="workorder-detail-form-section">
          <div class="detail-section-title">表单</div>
          <div id="workorder-detail-form-print-area" class="print-area workorder-detail-form-print-area">
            <h2>{{ workorderPreview.title || workorderPreview.name }}</h2>
            <div class="workorder-preview-meta">
              <span>工单事项：{{ workorderPreview.subject || currentWorkorder.subject || '-' }}</span>
              <span>客户：{{ workorderPreview.customerName || currentWorkorder.customerName || '-' }}</span>
              <span>关联设备：{{ workorderPreview.equipmentName || currentWorkorder.equipmentName || '-' }}</span>
            </div>

            <div v-for="field in (workorderPreview.shortFields || [])" :key="field.id" class="preview-field">
              <label>{{ field.label }}：</label>
              <span class="preview-submitted-value">{{ field.content || '-' }}</span>
            </div>

            <table class="print-table">
              <thead><tr><th>项目</th><th>标准</th><th>结果</th></tr></thead>
              <tbody>
                <tr v-for="row in (workorderPreview.tableRows || [])" :key="row.id">
                  <td>{{ row.project || '-' }}</td>
                  <td>{{ row.standard || '-' }}</td>
                  <td class="preview-result-cell">
                    <template v-for="part in getWorkorderPreviewParts(row)">
                      <span v-if="part.type === 'text'" :key="part.key">{{ part.text }}</span>
                      <span v-else-if="part.type === 'underline'" :key="part.key" class="preview-submitted-text">{{ getWorkorderPreviewValue(row, part) || '' }}</span>
                      <el-checkbox-group v-else-if="part.type === 'checkbox'" :key="part.key" v-model="workorderPreviewValues[part.key]" class="preview-option-group">
                        <el-checkbox v-for="option in part.options" :key="option" :label="option" disabled>{{ option }}</el-checkbox>
                      </el-checkbox-group>
                      <el-radio-group v-else-if="part.type === 'radio'" :key="part.key" v-model="workorderPreviewValues[part.key]" class="preview-option-group">
                        <el-radio v-for="option in part.options" :key="option" :label="option" disabled>{{ option }}</el-radio>
                      </el-radio-group>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>

            <div class="preview-image-title">{{ workorderPreview.imageTitle }}</div>
            <div v-if="workorderPreview.imageUrl" class="preview-image-grid">
              <div v-for="(url, index) in getPreviewImageUrls(workorderPreview.imageUrl)" :key="index" class="preview-image-item preview-media-clickable" @click="openMediaPreview({ url: url, type: getMediaType(url), name: getMediaFileName(url, index) })">
                <img v-if="isImageMedia({ url: url, type: getMediaType(url) })" :src="buildMediaUrl(url)">
                <video v-else-if="isVideoMedia({ url: url, type: getMediaType(url) })" :src="buildMediaUrl(url)" muted preload="metadata"></video>
                <i v-else class="el-icon-document"></i>
                <span v-if="isVideoMedia({ url: url, type: getMediaType(url) })" class="detail-video-play"><i class="el-icon-video-play"></i></span>
              </div>
            </div>

            <div v-for="(field, index) in (workorderPreview.longFields || [])" :key="field.id || index" class="preview-multiline">
              <div class="preview-multiline-title">{{ field.title }}</div>
              <div class="preview-text-box">{{ field.content || '' }}</div>
            </div>

            <div class="signature-table">
              <div>
                <span>客户签名：</span>
                <img v-if="workorderPreview.customerSignatureUrl" class="signature-preview print-signature-preview" :src="buildMediaUrl(workorderPreview.customerSignatureUrl)">
                <span v-else>未签名</span>
              </div>
              <div>
                <span>工程师签名：</span>
                <img v-if="workorderPreview.engineerSignatureUrl" class="signature-preview print-signature-preview" :src="buildMediaUrl(workorderPreview.engineerSignatureUrl)">
                <span v-else>未签名</span>
              </div>
            </div>
          </div>
        </div>
        </div>

        <p class="popup-btn-box">
          <el-button type="primary" @click="printWorkorderPreview" v-if="workorderPreview && (workorderPreview.title || workorderPreview.name)">打印</el-button>
          <el-button type="primary" @click="closeWorkorderDetail">确定</el-button>
        </p>
      </div>

      <!-- 指派工单：参照 userList.vue 选择角色弹窗的三列结构 -->
      <div class="popup-assign" v-show="assignDialogShow">
        <div class="popup-title">
          指派工单
          <i class="el-icon-circle-close close" @click="closeAssignDialog"></i>
        </div>
        <div class="assign-user-content-box roleTree tree">
          <div class="assign-user-column">
            <p class="assign-user-column-title">所属组织</p>
            <div class="assign-user-tree-box tree-box">
              <el-tree :indent="0" :data="assignOrganizationTree" node-key="id" :props="assignTreeProps"
                :default-expand-all="true" @node-click="handleAssignOrganizationClick">
                <span class="assign-tree-node" slot-scope="{ node, data }">
                  <i><img :src="data.type == 1 ? branch1 : data.type == 2 ? location1 : area1" class="tree-icon"></i>
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
          <div class="assign-user-column">
            <p class="assign-user-column-title">可选执行人</p>
            <div class="assign-user-list">
              <div v-for="user in filteredAssignUsers" :key="user.id" class="assign-user-option"
                @click="toggleAssignee(user)">
                <i class="el-icon-user"></i><span>{{ user.name }}</span>
                <span v-if="isAssigneeSelected(user.id)" class="assign-user-added">已添加</span>
                <i v-else class="el-icon-plus assign-user-add-icon"></i>
              </div>
              <div v-show="filteredAssignUsers.length === 0" class="assign-user-empty">暂无可选执行人</div>
            </div>
          </div>
          <div class="assign-user-column assign-user-selected-column">
            <p class="assign-user-column-title">已选执行人</p>
            <div class="assign-selected-list">
              <div v-for="user in selectedAssignees" :key="user.id" class="assign-selected-option">
                <i class="el-icon-user"></i><span>{{ user.name }}</span>
                <i class="el-icon-delete assign-user-del-icon" @click="removeAssignee(user)"></i>
              </div>
              <div v-show="selectedAssignees.length === 0" class="assign-user-empty">暂无已选执行人</div>
            </div>
          </div>
        </div>
        <p class="popup-btn-box">
          <el-button type="primary" :disabled="selectedAssignees.length === 0 || !functionList.includes('workorderEdit') || $store.state.isLook" @click="saveAssignment">确定</el-button>
          <el-button @click="closeAssignDialog">取消</el-button>
        </p>
      </div>

      <!-- 工单表单选择：先选择设备和模板，再进入模板填写 -->
      <div class="popup-form-select" v-show="formSelectDialogShow">
        <div class="popup-title">
          选择表单
          <i class="el-icon-circle-close close" @click="closeFormSelectDialog"></i>
        </div>
        <el-form ref="formSelectRef" :model="formSelectModel" :rules="formSelectRules" label-width="90px" class="form-select-el-form" :disabled="$store.state.isLook">
          <el-form-item label="关联设备：" prop="deviceIds">
            <el-select v-model="formSelectModel.deviceIds" multiple filterable clearable placeholder="请选择关联设备" style="width: 100%;">
              <el-option v-for="device in formSelectDevices" :key="device.id" :label="device.name + (device.serialNo ? ' / ' + device.serialNo : '')" :value="String(device.id)" />
            </el-select>
          </el-form-item>
          <el-form-item label="关联模板：" prop="templateId" required>
            <el-select v-model="formSelectModel.templateId" filterable clearable placeholder="请选择关联模板" style="width: 100%;">
              <el-option v-for="template in formSelectTemplates" :key="template.id" :label="template.name || template.formTitle || '-'" :value="String(template.id)" />
            </el-select>
          </el-form-item>
        </el-form>
        <p class="popup-btn-box">
          <el-button type="primary" :disabled="formSelectLoading||$store.state.isLook" @click="confirmFormSelection">下一步</el-button>
          <el-button @click="closeFormSelectDialog">取消</el-button>
        </p>
      </div>

      <!-- 工单表单 -->
      <div class="popup-form" v-show="formDialogShow">
        <div class="popup-title">
          表单
          <i class="el-icon-circle-close close" @click="closeFormDialog"></i>
        </div>

        <div class="form-meta">
          <span>工单编号：{{ currentWorkorder.code }}</span>
          <span>客户：{{ currentWorkorder.customerName }}</span>
          <span>事项：{{ currentWorkorder.subject }}</span>
        </div>

        <div class="dynamic-form">
          <!-- 1. 短文本输入 -->
          <div v-for="field in formFields.filter(item => item.type !== 'image' && item.type !== 'textarea')"
            :key="field.id" class="dynamic-field">
            <label>
              <span v-if="field.required" class="required-star">*</span>
              {{ field.label }}
            </label>

            <el-input v-if="field.type === 'text'" v-model="field.value"
              :placeholder="field.placeholder || '请输入'">
            </el-input>

            <el-radio-group v-else-if="field.type === 'radio'" v-model="field.value">
              <el-radio v-for="option in field.options" :key="option" :label="option">
                {{ option }}
              </el-radio>
            </el-radio-group>

            <el-checkbox-group v-else-if="field.type === 'checkbox'" v-model="field.value">
              <el-checkbox v-for="option in field.options" :key="option" :label="option">
                {{ option }}
              </el-checkbox>
            </el-checkbox-group>

            <el-date-picker v-else-if="field.type === 'date'" v-model="field.value" type="datetime"
              format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss">
            </el-date-picker>
          </div>

          <!-- 2. 表格 -->
          <div class="form-table-block" style="margin-bottom:16px;">
            <div class="detail-section-title">检查项目</div>
            <table class="inspection-table">
              <thead>
                <tr>
                  <th>项目</th>
                  <th>标准</th>
                  <th>结果</th>
                  <!-- <th width="70">操作</th> -->
                </tr>
              </thead>
              <tbody>
                <tr v-for="(row, index) in formTableRows" :key="row.id">
                  <td class="inspection-static-cell">{{ row.project || '-' }}</td>
                  <td class="inspection-static-cell">{{ row.standard || '-' }}</td>
                  <td class="form-table-result-cell">
                    <template v-for="part in getFormTableParts(row)">
                      <span v-if="part.type === 'text'" :key="part.key">{{ part.text }}</span>
                      <el-input v-else-if="part.type === 'underline'" :key="part.key"
                        v-model="row._controlValues[part.key]" class="form-result-text-input"
                        :style="{ width: Math.max(Number(part.length || 1) * 18, 80) + 'px' }"
                        placeholder="请输入"></el-input>
                      <el-checkbox-group v-else-if="part.type === 'checkbox'" :key="part.key"
                        v-model="row._controlValues[part.key]" class="preview-option-group form-result-option-group">
                        <el-checkbox v-for="option in part.options" :key="option" :label="option">{{ option }}</el-checkbox>
                      </el-checkbox-group>
                      <el-radio-group v-else-if="part.type === 'radio'" :key="part.key"
                        v-model="row._controlValues[part.key]" class="preview-option-group form-result-option-group">
                        <el-radio v-for="option in part.options" :key="option" :label="option">{{ option }}</el-radio>
                      </el-radio-group>
                    </template>
                  </td>
                  <!-- <td><span class="link-danger" @click="removeFormTableRow(index)">删除</span></td> -->
                </tr>
              </tbody>
            </table>
            <!-- <span class="add-row-link" @click="addFormTableRow">+新增行</span> -->
          </div>

          <!-- 3. 图片 -->
          <div v-for="field in formFields.filter(item => item.type === 'image')"
            :key="field.id" class="dynamic-field">
            <label>
              <span v-if="field.required" class="required-star">*</span>
              {{ field.label }}
            </label>

            <div class="field-image-box">
              <div v-for="(media, mediaIndex) in field.value" :key="media.uid" class="field-image-item field-image-upload-item">
                <img v-if="media.url" :src="media.url">
                <div v-if="isLargeMedia(media) && media.uploading" class="media-progress-mask">
                  <el-progress :percentage="Number(media.progress || 0)" :stroke-width="5" :show-text="true"></el-progress>
                </div>
                <span class="media-upload-status" v-if="media.uploading && isLargeMedia(media)">上传中 {{ Number(media.progress || 0) }}%</span>
                <i class="el-icon-delete" @click="field.value.splice(mediaIndex, 1)"></i>
              </div>
              <el-upload action="#" :show-file-list="false" :auto-upload="false" accept="image/*"
                :on-change="handleFormImage.bind(this, field)">
                <div class="field-upload">点击上传</div>
              </el-upload>
            </div>
          </div>

          <!-- 4. 多行文本 -->
          <div v-for="field in formFields.filter(item => item.type === 'textarea')"
            :key="field.id" class="dynamic-field">
            <label>
              <span v-if="field.required" class="required-star">*</span>
              {{ field.label }}
            </label>
            <el-input v-model="field.value" type="textarea" :rows="field.rows || 3"
              :placeholder="field.placeholder || '请输入'">
            </el-input>
          </div>

          <!-- 5. 签名 -->
          <div class="signature-block">
            <div class="detail-section-title">签名控件</div>
            <div class="signature-table">
              <div>
                <span>客户签名</span>
                <span class="signature-link" @click="openSignatureDialog('customer')">
                  {{ formSignature.customerSignatureUrl ? '重新签名' : '点击签名' }}
                </span>
                <img v-if="formSignature.customerSignatureUrl" class="signature-preview"
                  :src="formSignature.customerSignatureUrl">
              </div>
              <div>
                <span>工程师签名</span>
                <span class="signature-link" @click="openSignatureDialog('engineer')">
                  {{ formSignature.engineerSignatureUrl ? '重新签名' : '点击签名' }}
                </span>
                <img v-if="formSignature.engineerSignatureUrl" class="signature-preview"
                  :src="formSignature.engineerSignatureUrl">
              </div>
            </div>
          </div>
        </div>

        <p class="popup-btn-box">
          <el-button type="primary" :disabled="$store.state.isLook || isFormImageUploading()" @click="saveForm">保存</el-button>
          <!-- <el-button @click="openPrintPreview">打印预览</el-button> -->
          <el-button @click="closeFormDialog">取消</el-button>
        </p>
      </div>

      <!-- 手写签名 -->
      <div class="popup-signature" v-show="signatureDialogShow">
        <div class="popup-title">
          {{ signatureType === 'customer' ? '客户签名' : '工程师签名' }}
          <i class="el-icon-circle-close close" @click="closeSignatureDialog"></i>
        </div>
        <div class="signature-canvas-wrap">
          <canvas
            ref="signatureCanvas"
            width="620"
            height="360"
            class="signature-canvas"
            @mousedown="startSignature"
            @mousemove="drawSignature"
            @mouseup="endSignature"
            @mouseleave="endSignature"
            @touchstart.prevent="startSignature"
            @touchmove.prevent="drawSignature"
            @touchend.prevent="endSignature">
          </canvas>
          <div class="signature-hint" v-if="!signatureHasContent">请在上方区域手写签名</div>
        </div>
        <p class="popup-btn-box">
          <el-button type="primary" :loading="signatureUploading" :disabled="$store.state.isLook"  @click="confirmSignature">确定</el-button>
          <el-button @click="closeSignatureDialog">取消</el-button>
        </p>
      </div>

      <!-- 打印预览 -->
      <!-- <div class="popup-print" v-show="printPreviewShow">
        <div class="popup-title">
          表单-打印预览
          <i class="el-icon-circle-close close" @click="closePrintPreview"></i>
        </div>

        <div class="print-toolbar">
          <el-button type="primary" size="small" @click="printForm">打印</el-button>
        </div>

        <div id="print-area" class="print-area">
          <h2>{{ currentWorkorder.templateName || '服务报告' }}</h2>
          <div class="print-base-info">
            <span>工单编号：{{ currentWorkorder.code }}</span>
            <span>客户名称：{{ currentWorkorder.customerName }}</span>
            <span>设备型号：{{ currentWorkorder.deviceName || '-' }}</span>
            <span>事项：{{ currentWorkorder.subject }}</span>
          </div>

          <table class="print-table">
            <thead>
              <tr>
                <th>项目</th>
                <th>标准</th>
                <th>结果</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="row in formTableRows" :key="row.id">
                <td>{{ row.project }}</td>
                <td>{{ row.standard }}</td>
                <td>{{ row.result }}</td>
              </tr>
            </tbody>
          </table>

          <div class="print-fields">
            <div v-for="field in formFields" :key="field.id">
              <label>{{ field.label }}</label>
              <span v-if="field.type !== 'image'">{{ displayFieldValue(field) }}</span>
              <span v-else>图片 {{ field.value.length }} 张</span>
            </div>
          </div>

          <div class="print-signature">
            <div>客户签名：________________</div>
            <div>工程师签名：________________</div>
          </div>
        </div>
      </div> -->

      <!-- 新建/编辑模板 -->
      <div class="popup-template-builder" v-show="templateDialogShow">
        <div class="popup-title">
          {{ templateEditIndex === null ? '新建模板' : '编辑模板' }}
          <i class="el-icon-circle-close close" @click="closeTemplateDialog"></i>
        </div>

        <el-form :model="templateForm" :rules="templateRules" ref="templateForm" label-width="90px" :disabled="$store.state.isLook">
          <div class="template-basic-row">
            <el-form-item label="模板名称：" prop="name">
              <el-input v-model="templateForm.name" placeholder="请输入模板名称"></el-input>
            </el-form-item>
            <el-form-item label="表单标题：" prop="title">
              <el-input v-model="templateForm.title" placeholder="请输入表单标题"></el-input>
            </el-form-item>
          </div>
        </el-form>

        <div class="template-scroll">
          <div class="template-control-title">短文本输入</div>
          <div class="template-short-fields">
            <div v-for="(field, index) in templateForm.shortFields" :key="field.id" class="short-field">
              <el-checkbox v-model="field.required">必填</el-checkbox>
              <el-input v-model="field.label" placeholder="字段标题"></el-input>
              <el-input disabled placeholder="文本输入框"></el-input>
              <span class="operate-link" @click="removeTemplateShortField(index)">删除</span>
            </div>
          </div>
          <span class="add-row-link" @click="addTemplateShortField">+新增字段</span>

          <div class="template-control-title">表格
            <span v-pre title="表格中可使用控件表达式来表达控件，支持文本输入框、单选、复选3种，表达式中出现的号和逗号皆为英文格式。文本输入框:{{文本:3}}其中3表示输入框的长度为3个字符，单选:{{单选:选项1,选项2}}，复选:{{复选:选项1,选项2,选项3}}"><i class="el-icon-question"></i></span>
          </div>

          <table class="template-table">
            <thead>
              <tr>
                <th>项目</th>
                <th>标准</th>
                <th>结果</th>
                <th width="70">操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(row, index) in templateForm.tableRows" :key="row.id">
                <td><el-input v-model="row.project"></el-input></td>
                <td><el-input v-model="row.standard"></el-input></td>
                <td><el-input v-model="row.result"></el-input></td>
                <td><span class="link-danger" @click="removeTemplateTableRow(index)">删除</span></td>
              </tr>
            </tbody>
          </table>
          <span class="add-row-link" @click="addTemplateTableRow">+新增行</span>

          <div class="template-control-title image-title-row">
            <span>图片控件标题</span>
            <el-input v-model="templateForm.imageTitle" placeholder="请输入图片标题"></el-input>
          </div>

          <div class="template-control-title">多行文本控件</div>
          <div class="template-long-fields">
            <div v-for="(field, index) in templateForm.longFields" :key="field.id" class="long-field">
              <div class="long-field-header">
                <span class="long-field-index">多行文本 {{ index + 1 }}</span>
                <span class="operate-link" @click="removeTemplateLongField(index)">删除</span>
              </div>
              <div class="long-field-config">
                <label>标题</label>
                <el-input v-model="field.title" placeholder="请输入标题"></el-input>
                <label>行数</label>
                <el-input-number v-model="field.rows" :min="1" :max="20" size="small">
                </el-input-number>
              </div>
              <el-input v-model="field.content" class="template-textarea" type="textarea" :rows="field.rows"
                placeholder="多行文本输入框">
              </el-input>
            </div>
          </div>
          <span class="add-row-link" @click="addTemplateLongField">+新增多行文本控件</span>

          <div class="signature-block">
            <div class="detail-section-title">签名控件</div>
            <div class="signature-table">
              <div><span>客户签名</span> <span></span>  </div>
              <div><span>工程师签名</span><span></span></div>
            </div>
          </div>
        </div>

        <p class="popup-btn-box">
          <el-button type="primary" :disabled="!functionList.includes('workorderEdit') || $store.state.isLook"  @click="saveTemplate">保存</el-button>
          <el-button @click="closeTemplateDialog">取消</el-button>
        </p>
      </div>

      <!-- 模板预览：与工单表单样式保持一致，所有表单控件只读/禁用 -->
      <div class="popup-form template-form-preview-dialog" v-show="templatePreviewShow">
        <div class="popup-title">
          表单预览
          <i class="el-icon-circle-close close" @click="closeTemplatePreview"></i>
        </div>

        <div class="form-meta">
          <span>模板名称：{{ previewTemplate.name || '-' }}</span>
          <span>表单标题：{{ previewTemplate.title || '-' }}</span>
        </div>

        <div class="dynamic-form">
          <div v-for="field in (previewTemplate.shortFields || [])" :key="field.id" class="dynamic-field">
            <label><span v-if="field.required" class="required-star">*</span>{{ field.label }}</label>
            <el-input :value="field.content || ''" disabled :placeholder="field.placeholder || '文本输入框'"></el-input>
          </div>

          <div class="form-table-block" style="margin-bottom:16px;">
            <div class="detail-section-title">检查项目</div>
            <table class="inspection-table">
              <thead><tr><th>项目</th><th>标准</th><th>结果</th></tr></thead>
              <tbody>
                <tr v-for="row in (previewTemplate.tableRows || [])" :key="row.id">
                  <td class="inspection-static-cell">{{ row.project || '-' }}</td>
                  <td class="inspection-static-cell">{{ row.standard || '-' }}</td>
                  <td class="form-table-result-cell">
                    <template v-for="part in parseTemplateResult(row.result)">
                      <span v-if="part.type === 'text'" :key="part.key">{{ part.text }}</span>
                      <el-input v-else-if="part.type === 'underline'" :key="part.key" disabled class="form-result-text-input" :style="{ width: Math.max(Number(part.length || part.text && part.text.length || 1) * 18, 80) + 'px' }"></el-input>
                      <el-checkbox-group v-else-if="part.type === 'checkbox'" :key="part.key" v-model="previewSelections[part.key]" class="preview-option-group form-result-option-group">
                        <el-checkbox v-for="option in part.options" :key="option" :label="option" disabled>{{ option }}</el-checkbox>
                      </el-checkbox-group>
                      <el-radio-group v-else-if="part.type === 'radio'" :key="part.key" v-model="previewSelections[part.key]" class="preview-option-group form-result-option-group">
                        <el-radio v-for="option in part.options" :key="option" :label="option" disabled>{{ option }}</el-radio>
                      </el-radio-group>
                    </template>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div class="dynamic-field">
            <label>{{ previewTemplate.imageTitle || '现场照片' }}</label>
            <div class="field-image-box template-preview-image-box">
              <div v-for="(url, index) in getPreviewImageUrls(previewTemplate.imageUrl)" :key="index" class="field-image-item field-image-upload-item">
                <img :src="buildMediaUrl(url)">
              </div>
              <div v-if="!previewTemplate.imageUrl" class="template-preview-empty">暂无图片</div>
            </div>
          </div>

          <div v-for="(field, index) in (previewTemplate.longFields || [])" :key="field.id || index" class="dynamic-field">
            <label>{{ field.title }}</label>
            <el-input :value="field.content || ''" type="textarea" :rows="field.rows || 3" disabled></el-input>
          </div>

          <div class="signature-block">
            <div class="detail-section-title">签名控件</div>
            <div class="signature-table">
              <div>
                <span>客户签名</span>
                <el-button size="small" disabled>点击签名</el-button>
                <img v-if="previewTemplate.customerSignatureUrl" class="signature-preview" :src="buildMediaUrl(previewTemplate.customerSignatureUrl)">
              </div>
              <div>
                <span>工程师签名</span>
                <el-button size="small" disabled>点击签名</el-button>
                <img v-if="previewTemplate.engineerSignatureUrl" class="signature-preview" :src="buildMediaUrl(previewTemplate.engineerSignatureUrl)">
              </div>
            </div>
          </div>
        </div>

        <p class="popup-btn-box">
          <el-button @click="closeTemplatePreview">关闭</el-button>
        </p>
      </div>

      <!-- 图片/视频预览 -->
      <div class="popup-media-preview" v-show="mediaPreviewShow">
        <div class="popup-title">
          {{ currentMediaPreview && currentMediaPreview.name ? currentMediaPreview.name : '媒体预览' }}
          <i class="el-icon-circle-close close" @click="closeMediaPreview"></i>
        </div>
        <div class="media-preview-content">
          <img v-if="currentMediaPreview && isImageMedia(currentMediaPreview)"
            :src="buildMediaUrl(currentMediaPreview.url)" class="media-preview-image">
          <video v-else-if="currentMediaPreview && isVideoMedia(currentMediaPreview)"
            :src="buildMediaUrl(currentMediaPreview.url)" class="media-preview-video"
            controls autoplay playsinline preload="metadata"></video>
          <div v-else class="media-preview-unsupported">
            <i class="el-icon-document"></i>
            <span>当前文件类型暂不支持预览</span>
          </div>
        </div>
        <p class="popup-btn-box">
          <el-button @click="closeMediaPreview">关闭</el-button>
        </p>
      </div>

      <!-- 删除确认 -->
      <div class="popup-delete" v-show="deleteDialogShow">
        <div class="popup-title">
          {{ deleteType === 'customer' ? '删除客户' : deleteType === 'workorder' ? '删除工单' : '删除模板' }}
          <i class="el-icon-circle-close close" @click="closeDeleteDialog"></i>
        </div>
        <div class="popup-lab">
          系统将删除“{{ deleteTarget.name || deleteTarget.subject || deleteTarget.code }}”，是否继续？
        </div>
        <p class="popup-btn-box">
          <el-button type="primary" :disabled="deleteType=='customer'&&!functionList.includes('customerEdit')||deleteType != 'customer'&&!functionList.includes('workorderEdit') || $store.state.isLook"  @click="doDelete">确定</el-button>
          <el-button @click="closeDeleteDialog">取消</el-button>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Pagination from "@/components/PublicAssembly/pagination"

export default {
  name: "Workorder",
  components: {
    Pagination,
  },
  data() {
    return {
      activeTab: "workorder",
      tabs: [
        { label: "工单管理", value: "workorder" },
        { label: "客户管理", value: "customer" },
        { label: "模板管理", value: "template" },
      ],

      pageNumber: 1,
      pageSize: 100,
      workorderDetailShow: false,

      nullData: require("@/assets/image/index/nullData.png"),
      area1:require('@/assets/image/company/qyzu.png'),
      branch1:require('@/assets/image/company/ptzu.png'),
      location1:require('@/assets/image/company/jczu.png'),

      /* ---------------- 工单 ---------------- */
      workorderQuery: {
        type: null,
        status: null,
        keyword: "",
      },
      orderTypeOptions: [
        { label: "全部", value: null }
      ],
      statusOptions: [
        { label: "全部", value: null },
        { label: "待审批", value: 0 },
        { label: "待执行", value: 1 },
        { label: "执行中", value: 2 },
        { label: "挂起", value: 3 },
        { label: "已完成", value: 4 },
      ],
      workorders: [],
      workorderTotalCount: 0,
      workorderDialogShow: false,
      currentWorkorder: {},
      workorderForm: this.getDefaultWorkorderForm(),
      workorderRules: {
        customerId: [
          { required: true, message: "请选择关联客户", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择工单类型", trigger: "change" },
        ],
        subject: [
          { required: true, message: "请输入事项", trigger: "change" },
          { validator: (rule, value, callback) => {
            if (!String(value || "").trim()) {
              callback(new Error("请输入事项"))
              return
            }
            callback()
          }, trigger: "blur" },
        ],
        contact: [
          { required: true, message: "请输入联系人", trigger: "change" },
          { validator: (rule, value, callback) => {
            if (!String(value || "").trim()) {
              callback(new Error("请输入联系人"))
              return
            }
            callback()
          }, trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: "请输入正确的联系电话", trigger: "blur" },
        ],
        dispatchDate: [
          { required: true, message: "请选择期望派工时间", trigger: "change" },
        ],
        description: [
          { required: true, message: "请输入详细描述", trigger: "blur" },
          { validator: (rule, value, callback) => {
            if (!String(value || "").trim()) {
              callback(new Error("请输入详细描述"))
              return
            }
            callback()
          }, trigger: "blur" },
        ],
        executeMode: [
          { required: true, message: "请选择执行方式", trigger: "change" },
        ],
      },

      /* ---------------- 客户 ---------------- */
      customerQuery: {
        keyword: "",
        type: null,
      },
      customerTypeOptions: [
        { label: "全部", value: null }
      ],
      companyOptions: [],
      userOptions: [],
      customers: [],
      // 工单关联客户专用：保存全部客户，不受客户管理分页影响
      workorderCustomerList: [],
      customerTotalCount: 0,
      customerEditIndex: null,
      customerDialogShow: false,
      customerForm: this.getDefaultCustomerForm(),
      customerRules: {
        name: [
          { required: true, message: "请输入客户名称", trigger: "change" },
          { min: 1, max: 64, message: "名称长度为 1 到 64 个字符", trigger: "blur" },
        ],
        fullName: [
          { required: true, message: "请输入客户全称", trigger: "change" },
          { min: 1, max: 128, message: "客户全称长度不能超过 128 个字符", trigger: "blur" },
        ],
        contact: [
          { required: true, message: "请输入联系人", trigger: "change" },
          { min: 1, max: 32, message: "联系人长度不能超过 32 个字符", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "change" },
          { pattern: /^(?:(?:\+|00)86)?1[3-9]\d{9}$/, message: "请输入正确的联系电话", trigger: "blur" },
        ],
        address: [
          { required: true, message: "请输入地址", trigger: "change" },
          { min: 1, max: 256, message: "地址长度不能超过 256 个字符", trigger: "blur" },
        ],
        salesman: [
          { required: true, type: "array", min: 1, message: "请选择关联业务员", trigger: "change" },
        ],
        serviceEnd: [
          { required: true, message: "请选择服务到期时间", trigger: "change" },
        ],
        type: [
          { required: true, message: "请选择客户类型", trigger: "change" },
        ],
      },

      /* ---------------- 客户详情 / 设备 / 维保 ---------------- */
      customerDetailShow: false,
      currentCustomer: {},
      customerDetailTab: "basic",
      customerDetailTabs: [
        { label: "基本信息", value: "basic" },
        { label: "设备档案", value: "device" },
        { label: "维保记录", value: "maintenance" },
      ],
      deviceQuery: {
        keyword: "",
      },
      maintenanceQuery: {
        keyword: "",
      },
      maintenanceTotalCount: 0,
      maintenancePageNumber: 1,
      maintenancePageSize: 10,
      // 客户详情维保记录独立保存，避免与设备详情的 /equipment/listEqptMaintRecord 数据互相覆盖
      customerMaintenanceRecords: [],
      devices: [],
      deviceTotalCount: 0,
      devicePageNumber: 1,
      devicePageSize: 10,
      cloudDeviceOptions: [],
      deviceDialogShow: false,
      deviceEditId: null,
      currentDevice: {},
      deviceDetailShow: false,
      showType:1,
      deviceForm: this.getDefaultDeviceForm(),
      deviceRules: {
        name: [
          { required: true, message: "请输入设备名称", trigger: "change" },
          { min: 1, max: 128, message: "设备名称长度不能超过 128 个字符", trigger: "blur" },
        ],
        serialNo: [
          { max: 128, message: "序列号长度不能超过 128 个字符", trigger: "blur" },
        ],
        equipmentKey: [
          { max: 128, message: "设备key长度不能超过 128 个字符", trigger: "blur" },
        ],
        specParams: [
          { validator: (rule, value, callback) => {
            const params = Array.isArray(value) ? value : []
            if (!params.length) {
              callback(new Error("请至少添加一项规格参数"))
              return
            }
            const invalid = params.some(item =>
              !String(item.title || "").trim() || !String(item.content || "").trim()
            )
            if (invalid) {
              callback(new Error("规格参数名称和值均不能为空"))
              return
            }
            callback()
          }, trigger: "change" },
        ],
      },
      maintenanceDialogShow: false,
      maintenanceForm: this.getDefaultMaintenanceForm(),
      maintenanceRules: {},
      maintenanceRecords: [],
      maintenanceExporting: false,

      /* ---------------- 指派 ---------------- */
      assignDialogShow: false,
      assignTemplateType: "all",
      assignKeyword: "",
      assignWorkorder: null,
      assignSelectedIds: [],
      assignSelectedUsers: [],
      assignOrganizationTree: [],
      assignActiveOrganizationId: null,
      assignUsers: [],
      assignTreeProps: { label: "name", children: "children" },
      userGroups: [],
      /* ---------------- 工单表单 ---------------- */
      formDialogShow: false,
      formFields: [],
      formTableRows: [],
      formTemplateDetail: null,
      printPreviewShow: false,
      formSelectDialogShow: false,
      formSelectDevices: [],
      formSelectTemplates: [],
      formSelectedDeviceIds: [],
      formSelectedTemplateId: null,
      formSelectModel: { deviceIds: [], templateId: "" },
      formSelectRules: {
        deviceIds: [{ type: "array", required: false}],
        templateId: [{ required: true, message: "请选择关联模板", trigger: "change" }],
      },
      formSelectWorkorder: null,
      formSelectLoading: false,
      formSignature: {
        customerSignatureUrl: "",
        engineerSignatureUrl: "",
      },
      signatureDialogShow: false,
      signatureType: "customer",
      signatureDrawing: false,
      signatureHasContent: false,
      signatureUploading: false,
      signatureCanvasContext: null,

      /* ---------------- 模板 ---------------- */
      templateList: [],
      templateTotalCount: 0,
      templateDialogShow: false,
      templateEditIndex: null,
      templateForm: this.getDefaultTemplateForm(),
      templateRules: {
        name: [
          { required: true, message: "请输入模板名称", trigger: "change" },
          { min: 1, max: 32, message: "模板名称长度为 1 到 32 个字符", trigger: "blur" },
        ],
        title: [
          { required: true, message: "请输入表单标题", trigger: "change" },
        ],
      },
      templatePreviewShow: false,
      previewTemplate: {},
      workorderPreviewShow: false,
      workorderPreview: {},
      workorderPreviewValues: {},
      // 模板预览中 {{复选:...}} / {{单选:...}} 的选中状态
      previewSelections: {},

      /* ---------------- 图片/视频查看 ---------------- */
      mediaPreviewShow: false,
      currentMediaPreview: null,

      /* ---------------- 删除 ---------------- */
      deleteDialogShow: false,
      deleteType: "",
      deleteTarget: {},
      deleteIndex: null,
    }
  },

  computed: {
    functionList(){
      return this.$store.state.functionList || []
    },
    filteredWorkorders() {
      return this.workorders
    },
    getCurrentTypeName(){
      return (type)=>{
        var typeObj = this.customerTypeOptions.find(item=>item.value==type)
        return typeObj?typeObj.label:type
      }
    },
    filteredCustomers() {
      return this.customers
    },

    workorderDeviceOptions() {
      if (!this.workorderForm.customerId) {
        return this.devices
      }
      return this.devices.filter(item => item.customerId === this.workorderForm.customerId)
    },

    customerDevices() {
      return this.devices
    },

    customerMaintenance() {
      // 客户维保记录来自 /custMaintRecord/pageCustMaintRecord，接口本身已按客户分页，
      // 这里不能再使用设备详情的 maintenanceRecords，也不能再次按客户过滤分页结果。
      return this.customerMaintenanceRecords
    },

    deviceMaintenance() {
      return this.maintenanceRecords.filter(item =>
        String(item.equipmentId) === String(this.currentDevice.id)
      )
    },

    filteredUserGroups() {
      return this.userGroups
    },

    filteredAssignUsers() {
      const keyword = String(this.assignKeyword || "").trim().toLowerCase()
      if (!keyword) return this.assignUsers
      return this.assignUsers.filter(user =>
        String(user.name || "").toLowerCase().indexOf(keyword) > -1 ||
        String(user.userName || "").toLowerCase().indexOf(keyword) > -1 ||
        String(user.code || "").toLowerCase().indexOf(keyword) > -1
      )
    },

    selectedAssignees() {
      return this.assignSelectedUsers
    },
  },

  created() {
    this.$store.state.activeIndex = "/Workorder"
    this.$store.state.mask = false
    this.pageSize = this.$store.state.userConfig.rowsPerPage;
    this.getWorkorderType()
    this.getCustomerType()
    this.getWorkorders()
  },
  mounted(){
    // 工单页面挂载后立即获取全部客户，避免未进入“客户管理”页时关联客户为空
    this.getWorkorderCustomerList()
    console.log(this.functionList)
  },
  methods: {
    // 获取用户列表
    getUserList() {
      this.get("/User/getList",{code:this.$store.state.userData.groupCode}).then(res => {
        if (res.success) {
          res.result.forEach(item => {
            if(item.userName!='100000'){
              this.userOptions.push({
                label: item.displayName,
                value: item.id
              })
            }
          })

        } else {
          this.$message({
            message: `获取用户列表失败：${res.message}`,
            type: 'warning'
          })
        }
      })
    },
    // 获取企业列表
    getCompanyList() {
      this.get("/Company/getList").then(res => {
        if (res.success) {
          this.companyOptions = (res.result || []).map(item => ({
            label: item.shortName,
            value: item.id
          }))
        } else {
          this.$message({
            message: `获取企业列表失败：${res.message}`,
            type: 'warning'
          })
        }
      })
    },
    // 获取工单类型
    getWorkorderType() {
      this.get("/Category/getList", { type: 6 }).then(res => {
        if (res.success) {
          this.orderTypeOptions = this.orderTypeOptions.concat(res.result.map(item => ({
            label: item.name,
            value: item.id
          })))
        } else {
          this.$message({
            message: `获取工单类型失败：${res.message}`,
            type: 'warning'
          })
        }
      })
    },

    // 获取客户类型
    getCustomerType() {
      this.get("/Category/getList", { type: 7 }).then(res => {
        if (res.success) {
          this.customerTypeOptions = this.customerTypeOptions.concat(res.result.map(item => ({
            label: item.name,
            value: item.id
          })))
        } else {
          this.$message({
            message: `获取客户类型失败：${res.message}`,
            type: 'warning'
          })
        }
      })
    },

    /* ==========================================================
     * 基础工具
     * ========================================================== */
    getDefaultWorkorderForm() {
      return {
        customerId: "",
        customerName: "",
        type: "",
        subject: "",
        executeMode: "apply",
        contact: "",
        phone: "",
        dispatchDate: "",
        description: "",
        mediaList: [],
      }
    },

    getDefaultCustomerForm() {
      return {
        id: null,
        name: "",
        fullName: "",
        contact: "",
        phone: "",
        address: "",
        cloudCompany: "",
        cloudEnterpriseId: "",
        cloudEnterpriseName: "",
        type: "",
        serviceEnd: "",
        relatedUser: "",
        salesman: [],
        businessPersonId: "",
        businessPersonName: "",
        introduction: "",
        remark: "",
        mediaList: [],
      }
    },

    getDefaultDeviceForm() {
      return {
        id: null,
        customerId: "",
        name: "",
        serialNo: "",
        equipmentKey: "",
        cloudEquipmentId: "",
        cloudEquipmentName: "",
        remark: "",
        specParams: [{ uid: "param-" + Date.now(), title: "", content: "" }],
        fileUrl: "",
        mediaList: [],
      }
    },

    getDefaultMaintenanceForm() {
      return {
        customerId: "",
        deviceId: "",
        workorderId: "",
        type: "保养",
        date: "",
        executor: "",
        remark: "",
      }
    },

    getDefaultTemplateForm() {
      const now = Date.now()
      return {
        id: null,
        name: "",
        title: "",
        shortFields: [
          { id: now + 1, label: "", placeholder: "文本输入框", required: true, content: "" },
        ],
        longFields: [
          { id: now + 2, title: "故障分析", rows: 6, content: "" },
        ],
        tableRows: [
          { id: now + 3, project: "", standard: "", result: "" },
        ],
        imageTitle: "故障图片",
        imageUrl: "",
        customerSignatureUrl: "",
        engineerSignatureUrl: "",
      }
    },

    formatDate(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, "0")
      const d = String(date.getDate()).padStart(2, "0")
      return y + "/" + m + "/" + d
    },

    formatDateTime(date) {
      const y = date.getFullYear()
      const m = String(date.getMonth() + 1).padStart(2, "0")
      const d = String(date.getDate()).padStart(2, "0")
      const h = String(date.getHours()).padStart(2, "0")
      const mm = String(date.getMinutes()).padStart(2, "0")
      const s = String(date.getSeconds()).padStart(2, "0")
      return y + "-" + m + "-" + d + " " + h + ":" + mm + ":" + s
    },

    nextCode(list) {
      let max = 0
      list.forEach(item => {
        const n = parseInt(item.code, 10)
        if (!isNaN(n) && n > max) max = n
      })
      return String(max + 1).padStart(6, "0")
    },

    openMask() {
      this.$store.state.mask = true
    },

    closeMask() {
      this.$store.state.mask = false
    },

    switchTab(tab) {
      this.activeTab = tab
      this.pageNumber = 1
      switch (tab) {
        case "workorder":
          this.filterWorkorders()
          break
        case "customer":
          this.filterCustomers()
          if(this.companyOptions.length==0){
            this.getCompanyList()
          }
          if(this.userOptions.length==0){
            this.getUserList()
          }
          break
        case "template":
          this.filterTemplates()
          break
      }
    },

    setSize(pageObj) {
      this.pageSize = pageObj.size
      this.pageNumber = pageObj.number
    },

    setNum(num) {
      this.pageNumber = num
    },

    setCustomerSize(pageObj) {
      this.pageSize = pageObj.size
      this.pageNumber = pageObj.number
      this.filterCustomers()
    },

    setCustomerNum(num) {
      this.pageNumber = num
      this.filterCustomers()
    },

    /* ==========================================================
     * 工单：列表 / 新建 / 查看 / 状态 / 指派
     * ========================================================== */
    filterWorkorders() {
      this.pageNumber = 1
      return this.getWorkorders()
    },

    getWorkorders() {
      const params = {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
        woType: this.workorderQuery.type === null || this.workorderQuery.type === "" ? null : this.workorderQuery.type,
        woStatus: this.workorderQuery.status === null || this.workorderQuery.status === "" ? null : this.workorderQuery.status,
        keyword: (this.workorderQuery.keyword || "").trim(),
      }

      return this.postNoJson("/workorder/pageWorkorder", params).then(res => {
        if (res && res.success && res.result) {
          const data = Array.isArray(res.result.data) ? res.result.data : []
          this.workorders = data.map(item => this.normalizeWorkorder(item))
          this.workorderTotalCount = Number(res.result.totalCount) || 0
          return this.workorders
        }

        this.workorders = []
        this.workorderTotalCount = 0
        this.$message.warning("获取工单列表失败：" + ((res && res.message) || "请求失败"))
        return []
      }).catch(() => {
        this.workorders = []
        this.workorderTotalCount = 0
        this.$message.warning("获取工单列表失败")
        return []
      })
    },

    setSize(pageObj) {
      this.pageSize = pageObj.size
      this.pageNumber = pageObj.number
      this.getWorkorders()
    },

    setNum(num) {
      this.pageNumber = num
      this.getWorkorders()
    },

    normalizeWorkorder(item) {
      const fileUrls = String(item.fileUrl || "")
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)

      return {
        id: item.id,
        customerId: item.customerId,
        customerName: item.customerName || "",
        address: item.address || "",
        equipmentId: item.equipmentId || "",
        equipmentName: item.equipmentName || "",
        templateId: item.templateId,
        templateRecordId: item.templateRecordId,
        type: item.woType === null || item.woType === undefined ? "" : item.woType,
        status: item.woStatus === null || item.woStatus === undefined ? "" : item.woStatus,
        lastStatus: item.woLastStatus,
        executeMode: this.toWorkorderExecuteMode(item.executeType),
        subject: item.subject || "",
        description: item.description || "",
        contact: item.contactPerson || "",
        phone: item.contactPhone || "",
        applicantId: item.applicantId,
        applicant: item.applicantName || "",
        approverId: item.approverId,
        approver: item.approverName || "",
        assigneeId: item.assigneeId || "",
        executor: item.assigneeName || "",
        dispatchDate: item.expectedDispatchTime || "",
        statusTime: item.statusTime || "",
        duration: item.statusDurationTime || "",
        approveTime: item.approveTime || "",
        executeTime: item.executeTime || "",
        fileUrl: fileUrls.join(","),
        createUser: item.createUser,
        createTime: item.createTime || "",
        templateVO: item.templateVO || null,
        typeName: this.getWorkorderTypeName(item.woType),
        statusName: this.getWorkorderStatusName(item.woStatus),
        mediaList: fileUrls.map((url, index) => ({
          uid: "workorder-file-" + String(item.id || Date.now()) + "-" + index,
          name: this.getMediaFileName(url, index),
          type: this.getMediaType(url),
          size: 0,
          url: url,
          uploaded: true,
        })),
        executeType:item.executeType,
        woStatus:item.woStatus,
        woLastStatus:item.woLastStatus
      }
    },

    toWorkorderExecuteMode(value) {
      if (value === 1 || value === "1" || value === "self") return "self"
      return "apply"
    },

    getWorkorderTypeName(type) {
      const item = this.orderTypeOptions.find(v => String(v.value) === String(type))
      return item ? item.label : (type === null || type === undefined ? "" : String(type))
    },

    getWorkorderStatusName(status) {
      const item = this.statusOptions.find(v => String(v.value) === String(status))
      return item ? item.label : (status === null || status === undefined ? "" : String(status))
    },

    canEditWorkorder(item) {
      return item.status==0
    },

    canAssign(item) {
      return item.status === 0
    },

    canDelete(item) {
      return true
    },

    canSuspend(item) {
      return item.status === 2 || item.status === "executing"
    },

    canResume(item) {
      return item.status === 3 || item.status === "suspended"
    },

    canOpenForm(item) {
      var assigneeIds = item.assigneeId.split(',').map(Number)
      return (item.status === 2 || item.status === 1 ) && assigneeIds.includes(this.$store.state.userData.id)
    },
    canComplete(item) {
      var assigneeIds = item.assigneeId.split(',').map(Number)
      return item.status === 2 &&item.templateRecordId && assigneeIds.includes(this.$store.state.userData.id)
    },

    openWorkorderDialog(item) {
      if(!this.functionList.includes('workorderNew')||this.$store.state.isLook) return
      this.currentWorkorder = item || {}
      if (item && item.id) {
        this.postNoJson("/workorder/detailWorkorder", { id: item.id, templateRecordId: item.templateRecordId }).then(res => {
          if (res && res.success && res.result) {
            const detail = this.normalizeWorkorder(res.result)
            this.workorderForm = Object.assign({}, this.getDefaultWorkorderForm(), {
              id: detail.id,
              customerId: detail.customerId,
              customerName: detail.customerName,
              type: detail.type,
              subject: detail.subject,
              executeMode: detail.executeMode,
              contact: detail.contact,
              phone: detail.phone,
              dispatchDate: detail.dispatchDate,
              templateId: detail.templateId,
              equipmentId: detail.equipmentId || "",
              description: detail.description,
              mediaList: detail.mediaList.slice(),
            })
            this.workorderDialogShow = true
            this.openMask()
            this.$nextTick(() => {
              if (this.$refs.workorderForm) this.$refs.workorderForm.clearValidate()
            })
          } else {
            this.$message.warning("获取工单详情失败：" + ((res && res.message) || "请求失败"))
          }
        }).catch(() => this.$message.warning("获取工单详情失败"))
        return
      }

      this.workorderForm = this.getDefaultWorkorderForm()
      this.workorderDialogShow = true
      this.openMask()
      this.$nextTick(() => {
        if (this.$refs.workorderForm) this.$refs.workorderForm.clearValidate()
      })
    },

    closeWorkorderDialog() {
      this.workorderDialogShow = false
      this.currentWorkorder = {}
      this.workorderForm = this.getDefaultWorkorderForm()
      this.closeMask()
    },

    queryCustomer(queryString, callback) {
      const keyword = (queryString || "").toLowerCase()
      const result = this.workorderCustomerList
        .filter(item =>
          !keyword ||
          String(item.name || "").toLowerCase().indexOf(keyword) > -1 ||
          String(item.fullName || "").toLowerCase().indexOf(keyword) > -1
        )
        .map(item => ({
          id: item.id,
          name: item.name,
          fullName: item.fullName,
        }))
      callback(result)
    },

    handleCustomerSelect(item) {
      const customer = this.workorderCustomerList.find(c => String(c.id) === String(item.id))
      if (!customer) return
      console.log(customer)
      this.workorderForm.customerId = customer.id
      this.workorderForm.customerName = customer.name
      this.workorderForm.contact = customer.contact || ""
      this.workorderForm.phone = customer.phone || ""
    },

    handleCustomerNameBlur() {
      const customer = this.workorderCustomerList.find(c => c.name === this.workorderForm.customerName)
      if (customer) this.handleCustomerSelect(customer)
    },

    buildWorkorderPayload() {
      const fileUrls = (this.workorderForm.mediaList || [])
        .map(item => item.url)
        .filter(Boolean)

      return {
        customerId: this.workorderForm.customerId,
        templateId: this.workorderForm.templateId || null,
        equipmentId: this.workorderForm.equipmentId || "",
        woType: this.workorderForm.type,
        executeType: this.workorderForm.executeMode === "self" ? 1 : 0,
        subject: String(this.workorderForm.subject || "").trim(),
        description: String(this.workorderForm.description || "").trim(),
        contactPerson: String(this.workorderForm.contact || "").trim(),
        contactPhone: String(this.workorderForm.phone || "").trim(),
        expectedDispatchTime: this.workorderForm.dispatchDate,
        fileUrl: fileUrls.join(","),
      }
    },

    saveWorkorder() {
      this.$refs.workorderForm.validate(valid => {
        if (!valid) return

        const media = this.workorderForm.mediaList || []
        if (media.some(item => item.uploading)) {
          this.$message.warning("图片/视频正在上传，请稍候再提交")
          return
        }
        if (media.some(item => !item.url)) {
          this.$message.warning("存在未完成上传的图片/视频，请重新上传")
          return
        }

        const payload = this.buildWorkorderPayload()
        const isEdit = !!(this.workorderForm.id || (this.currentWorkorder && this.currentWorkorder.id))
        if (isEdit) {
          payload.id = this.workorderForm.id || this.currentWorkorder.id
        }

        // 接口文档明确提供的是 saveWorkorder（新建）接口；文档未提供独立编辑接口。
        // 为保持现有“编辑工单”入口可用，编辑时沿用该接口并附带 id。
        this.postNoJson(payload.id?"/workorder/editWorkorder":"/workorder/saveWorkorder", payload).then(res => {
          if (res && res.success) {
            this.$message.success(isEdit ? "工单修改成功" : "工单保存成功")
            this.closeWorkorderDialog()
            this.filterWorkorders()
          } else {
            this.$message.warning((isEdit ? "修改工单失败：" : "保存工单失败：") + ((res && res.message) || "请求失败"))
          }
        }).catch(() => {
          this.$message.warning(isEdit ? "修改工单失败" : "保存工单失败")
        })
      })
    },

    getTemplateName(id) {
      const item = this.templateList.find(t => t.id === id)
      return item ? item.name : ""
    },

    openWorkorderDetail(item) {
      if (!item || !item.id) return
      const params = { id: item.id }
      if (Number(item.status) === 4 && item.templateRecordId) {
        params.templateRecordId = item.templateRecordId
      }
      this.postNoJson("/workorder/detailWorkorder", params).then(res => {
        if (res && res.success && res.result) {
          const detail = res.result
          this.currentWorkorder = this.normalizeWorkorder(detail)
          this.workorderPreview = {}
          this.workorderPreviewValues = {}

          if (Number(this.currentWorkorder.status) === 4 && detail.templateVO) {
            const normalized = this.normalizeTemplateDetail(detail.templateVO)
            this.workorderPreview = Object.assign({}, normalized, {
              subject: detail.subject || item.subject || "",
              customerName: detail.customerName || item.customerName || "",
              equipmentName: detail.equipmentName || item.equipmentName || "",
            })
            ;(normalized.tableRows || []).forEach(row => this.getWorkorderPreviewParts(row))
          }

          this.workorderDetailShow = true
          this.openMask()
        } else {
          this.$message.warning("获取工单详情失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => this.$message.warning("获取工单详情失败"))
    },

    closeWorkorderDetail() {
      this.workorderDetailShow = false
      this.currentWorkorder = {}
      this.workorderPreview = {}
      this.workorderPreviewValues = {}
      if(!this.deviceDetailShow&&!this.customerDetailShow){
        this.closeMask()
      }
    },

    openWorkorderById(id) {
      this.openWorkorderDetail({id:id})
    },

    suspendWorkorder(item) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook||!item || !item.id) return
      this.postNoJson("/workorder/suspendedWorkorder", {
        id: item.id,
        woStatus: item.woStatus,
      }).then(res => {
        if (res && res.success) {
          this.$message.success("工单已挂起")
          this.getWorkorders()
        } else {
          this.$message.warning("工单挂起失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => this.$message.warning("工单挂起失败"))
    },

    resumeWorkorder(item) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook||!item || !item.id) return
      this.postNoJson("/workorder/recoverWorkorder", {
        id: item.id,
        woLastStatus: item.lastStatus,
      }).then(res => {
        if (res && res.success) {
          this.$message.success("工单已恢复")
          this.getWorkorders()
        } else {
          this.$message.warning("工单恢复失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => this.$message.warning("工单恢复失败"))
    },

    confirmDeleteWorkorder(item) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook) return
      this.deleteType = "workorder"
      this.deleteTarget = item
      this.deleteIndex = this.workorders.indexOf(item)
      this.deleteDialogShow = true
      this.openMask()
    },

    /* ==========================================================
     * 工单指派
     * ========================================================== */
    openAssignDialog(item) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook||!item || !item.id) return
      this.assignWorkorder = item
      this.assignKeyword = ""
      this.assignSelectedIds = []
      this.assignSelectedUsers = []
      const ids = String(item.assigneeId || "").split(",").map(v => v.trim()).filter(Boolean)
      const names = String(item.executor || "").split(",").map(v => v.trim()).filter(Boolean)
      ids.forEach((id, index) => {
        this.assignSelectedIds.push(id)
        this.assignSelectedUsers.push({ id: id, name: names[index] || id })
      })
      this.assignOrganizationTree = []
      this.assignUsers = []
      this.assignActiveOrganizationId = null
      this.assignDialogShow = true
      this.openMask()
      this.getAssignOrganizationTree()
    },

    closeAssignDialog() {
      this.assignDialogShow = false
      this.assignWorkorder = null
      this.assignSelectedIds = []
      this.assignSelectedUsers = []
      this.assignUsers = []
      this.assignOrganizationTree = []
      this.assignActiveOrganizationId = null
      this.closeMask()
    },

    getAssignOrganizationTree() {
      return this.get("/Group/getOrganizationTree").then(res => {
        if (res && res.success) {
          this.assignOrganizationTree = res.result || []
          // 组织树只负责展示；用户列表在点击具体组织节点后再请求
        } else {
          this.$message.warning("获取组织树失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => this.$message.warning("获取组织树失败"))
    },

    handleAssignOrganizationClick(data) {
      if (!data || !data.id) return
      if (String(this.assignActiveOrganizationId) === String(data.id)) return
      this.assignActiveOrganizationId = data.id
      this.assignKeyword = ""
      return this.get("/User/getList", { id: data.id, code: data.code }).then(res => {
        if (res && res.success) {
          this.assignUsers = (res.result || []).filter(item => item.userName !== "100000").map(item => ({
            id: item.id,
            name: item.displayName || item.name || item.userName || "",
            userName: item.userName || "",
            code: item.code || "",
            groupId: data.id,
            groupName: data.name || "",
          }))
        } else {
          this.assignUsers = []
          this.$message.warning("获取可选执行人失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => {
        this.assignUsers = []
        this.$message.warning("获取可选执行人失败")
      })
    },

    isAssigneeSelected(id) {
      return this.assignSelectedIds.map(String).indexOf(String(id)) > -1
    },

    toggleAssignee(user) {
      if (!user || !user.id) return
      const index = this.assignSelectedIds.map(String).indexOf(String(user.id))
      if (index > -1) {
        this.assignSelectedIds.splice(index, 1)
        const selectedIndex = this.assignSelectedUsers.findIndex(item => String(item.id) === String(user.id))
        if (selectedIndex > -1) this.assignSelectedUsers.splice(selectedIndex, 1)
      } else {
        this.assignSelectedIds.push(user.id)
        this.assignSelectedUsers.push(Object.assign({}, user))
      }
    },

    removeAssignee(user) {
      if (!user) return
      const index = this.assignSelectedIds.map(String).indexOf(String(user.id))
      if (index > -1) this.assignSelectedIds.splice(index, 1)
      const selectedIndex = this.assignSelectedUsers.findIndex(item => String(item.id) === String(user.id))
      if (selectedIndex > -1) this.assignSelectedUsers.splice(selectedIndex, 1)
    },

    saveAssignment() {
      if (!this.assignWorkorder) return
      if (!this.selectedAssignees.length) {
        this.$message.warning("请选择至少一名执行人")
        return
      }
      const payload = {
        id: this.assignWorkorder.id,
        executeType: this.assignWorkorder.executeType === undefined
          ? (this.assignWorkorder.executeMode === "self" ? 1 : 0)
          : this.assignWorkorder.executeType,
        woStatus: this.assignWorkorder.status,
        assigneeId: this.selectedAssignees.map(item => item.id).join(","),
        assigneeName: this.selectedAssignees.map(item => item.name).join(","),
      }
      this.postNoJson("/workorder/assignWorkorder", payload).then(res => {
        if (res && res.success) {
          this.assignWorkorder.assigneeId = payload.assigneeId
          this.assignWorkorder.executor = payload.assigneeName
          this.$message.success("工单指派成功")
          this.closeAssignDialog()
          this.getWorkorders()
        } else {
          this.$message.warning("工单指派失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => this.$message.warning("工单指派失败"))
    },

    /* ==========================================================
     * 工单表单选择 / 表单填写 / 打印预览
     * ========================================================== */
    openFormDialog(item) {
      if(this.$store.state.isLook||!item || !item.id) return

      var assigneeIds = String(item.assigneeId || "").split(',').map(Number)
      if(item.status==1&&assigneeIds.includes(this.$store.state.userData.id)){
        this.postNoJson("/workorder/executeWorkorder", { id: item.id,executeType:item.executeType,woStatus:item.woStatus }).then(res => {
          if (res && res.success) {
            item.status=2
          } else {
            this.$message.warning(`工单执行失败：${res.message}`)
          }
        })
      }

      this.currentWorkorder = item
      this.formSelectWorkorder = item

      // 已保存过表单的工单：直接读取历史模板内容，跳过设备/模板选择。
      if (item.templateRecordId) {
        this.formSelectLoading = true
        this.openMask()
        this.postNoJson("/workorder/detailWorkorder", {
          id: item.id,
          templateRecordId: item.templateRecordId,
        }).then(res => {
          if (!(res && res.success && res.result)) {
            this.$message.warning("获取已保存表单内容失败：" + ((res && res.message) || "请求失败"))
            return
          }

          const detail = res.result
          if (!detail.templateVO) {
            this.$message.warning("该工单暂无已保存的表单内容")
            return
          }

          this.currentWorkorder = Object.assign({}, this.normalizeWorkorder(detail), {
            templateRecordId: detail.templateRecordId || item.templateRecordId,
          })
          this.buildWorkorderFormFromTemplate(detail.templateVO)
          this.formSelectDialogShow = false
          this.formDialogShow = true
          this.$nextTick(() => {
            this.closeMask()
            this.openMask()
          })
        }).catch(() => {
          this.$message.warning("获取已保存表单内容失败")
        }).finally(() => {
          this.formSelectLoading = false
        })
        return
      }

      // 没有历史表单时，保持原有“选择设备 -> 选择模板 -> 填写表单”流程。
      this.formSelectDevices = []
      this.formSelectTemplates = []
      this.formSelectedDeviceIds = String(item.equipmentId || "").split(",").map(v => v.trim()).filter(Boolean)
      this.formSelectedTemplateId = item.templateId || null
      this.formSelectModel = {
        deviceIds: this.formSelectedDeviceIds.slice(),
        templateId: this.formSelectedTemplateId ? String(this.formSelectedTemplateId) : "",
      }
      this.formSelectLoading = true
      this.formSelectDialogShow = true
      this.openMask()
      this.$nextTick(() => {
        if (this.$refs.formSelectRef) this.$refs.formSelectRef.clearValidate()
      })
      Promise.all([this.loadAllFormTemplates(), this.loadAllFormDevices(item.customerId)]).then(() => {
        const validDeviceIds = this.formSelectDevices.map(device => String(device.id))
        this.formSelectedDeviceIds = this.formSelectedDeviceIds.filter(id => validDeviceIds.indexOf(String(id)) > -1)
        if (!this.formSelectedTemplateId && this.formSelectTemplates.length === 1) {
          this.formSelectedTemplateId = this.formSelectTemplates[0].id
        }
      }).finally(() => { this.formSelectLoading = false })
    },

    // 完成工单
    openCompleteDialog(item){
      console.log(item)
      if(this.$store.state.isLook){ return }
      if(!item.templateRecordId){
        this.$message.warning("请先填写工单表单")
        return
      }
      this.postNoJson("/workorder/detailWorkorder", {
        id: item.id,
        templateRecordId: item.templateRecordId,
      }).then(res2 => {
        if(res2.success){
          if(res2.result.templateVO&&res2.result.templateVO.customerSignatureUrl){
            this.postNoJson("/workorder/completedWorkorder", {
              id: item.id,
              customerId:item.customerId,
              assigneeId:item.assigneeId,
              assigneeName:item.executor,
              subject:item.subject,
              description:item.description,
              equipmentId:item.equipmentId,
              equipmentName:item.equipmentName,
              woStatus:item.woStatus,
              executeType:item.executeType
            }).then(res => {
              if (res && res.success) {
                this.$message.success("工单已完成")
                this.getWorkorders()
              } else {
                this.$message.warning("工单完成失败：" + ((res && res.message) || "请求失败"))
              }
            }).catch(() => this.$message.warning("工单完成失败"))
          }else{
            this.$message.warning("该工单客户未签名，无法完成")
          }
        }else{
          this.$message.warning("获取工单详情失败：" + ((res2 && res2.message) || "请求失败"))
        }
      })
    },

    loadAllFormTemplates() {
      return this.postNoJson("/template/listTemplate", {}).then(res => {
        if (res && res.success) {
          this.formSelectTemplates = Array.isArray(res.result) ? res.result : []
          return this.formSelectTemplates
        }
        this.formSelectTemplates = []
        this.$message.warning("获取模板列表失败：" + ((res && res.message) || "请求失败"))
        return []
      }).catch(err => {
        this.formSelectTemplates = []
        this.$message.warning("获取模板列表失败：" + ((err && err.message) || "请求失败"))
        return []
      })
    },

    loadAllFormDevices(customerId) {
      if (!customerId) {
        this.formSelectDevices = []
        return Promise.resolve([])
      }
      return this.postNoJson("/equipment/listEquipment", { customerId: customerId }).then(res => {
        if (res && res.success) {
          this.formSelectDevices = (Array.isArray(res.result) ? res.result : []).map(item => this.normalizeDevice(item))
          return this.formSelectDevices
        }
        this.formSelectDevices = []
        this.$message.warning("获取客户设备失败：" + ((res && res.message) || "请求失败"))
        return []
      }).catch(err => {
        this.formSelectDevices = []
        this.$message.warning("获取客户设备失败：" + ((err && err.message) || "请求失败"))
        return []
      })
    },

    confirmFormSelection() {
      this.$refs.formSelectRef.validate(valid => {
        if (!valid) return

        this.formSelectedDeviceIds = (this.formSelectModel.deviceIds || []).slice()
        this.formSelectedTemplateId = this.formSelectModel.templateId
        this.formSelectLoading = true

        // 通过用户选择的模板ID获取模板详情，详情中的JSON才作为实际填写内容
        this.postNoJson("/template/detailTemplate", {
          id: this.formSelectedTemplateId,
        }).then(res => {
          if (!(res && res.success && res.result)) {
            this.$message.warning("获取模板详情失败：" + ((res && res.message) || "请求失败"))
            return
          }

          const templateDetail = res.result
          const selectedDevices = this.formSelectDevices.filter(device =>
            this.formSelectedDeviceIds.map(String).indexOf(String(device.id)) > -1
          )

          this.currentWorkorder = Object.assign({}, this.formSelectWorkorder, {
            templateId: templateDetail.id,
            templateName: templateDetail.name || templateDetail.formTitle || "",
            equipmentId: selectedDevices.map(device => device.id).join(","),
            equipmentName: selectedDevices.map(device => device.name).join(","),
            deviceName: selectedDevices.map(device => device.name).join(","),
          })

          this.buildWorkorderFormFromTemplate(templateDetail)
          this.formSelectDialogShow = false
          this.formDialogShow = true
          this.$nextTick(() => {
            this.closeMask()
            this.openMask()
          })
        }).catch(() => {
          this.$message.warning("获取模板详情失败")
        }).finally(() => {
          this.formSelectLoading = false
        })
      })
    },

    closeFormSelectDialog() {
      this.formSelectDialogShow = false
      this.formSelectWorkorder = null
      this.formSelectDevices = []
      this.formSelectTemplates = []
      this.formSelectedDeviceIds = []
      this.formSelectedTemplateId = null
      this.formSelectModel = { deviceIds: [], templateId: "" }
      this.formSelectLoading = false
      this.closeMask()
    },

    buildWorkorderFormFromTemplate(template) {
      const normalized = this.normalizeTemplateDetail(template || {})
      const imageUrls = String(normalized.imageUrl || "")
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)

      this.formTemplateDetail = normalized
      this.formFields = (normalized.shortFields || []).map(field => ({
        id: field.id,
        label: field.label,
        type: "text",
        required: field.required,
        placeholder: field.placeholder,
        value: field.content || this.getDefaultFieldValue(field.label),
      }))

      this.formFields.push({
        id: Date.now() + 100,
        label: normalized.imageTitle || "现场照片",
        type: "image",
        required: false,
        value: imageUrls.map((url, index) => ({
          uid: "template-image-" + index + "-" + Date.now(),
          name: this.getMediaFileName(url, index),
          type: "image/*",
          url: url,
          uploaded: true,
        })),
      })

      ;(normalized.longFields || []).forEach((field, index) => {
        this.formFields.push({
          id: field.id || (Date.now() + 101 + index),
          label: field.title || ("多行文本" + (index + 1)),
          type: "textarea",
          required: false,
          value: field.content || "",
          rows: Number(field.rows) || 3,
        })
      })

      this.formTableRows = (normalized.tableRows || []).map(row => {
        const target = Object.assign({}, row)
        target._controlValues = Object.assign({}, row.resultValues || {})
        this.initializeFormTableControlValues(target)
        return target
      })

      this.formSignature = {
        customerSignatureUrl: normalized.customerSignatureUrl || "",
        engineerSignatureUrl: normalized.engineerSignatureUrl || "",
      }
    },

    getDefaultFieldValue(label) {
      if (label.indexOf("客户") > -1) return this.currentWorkorder.customerName
      if (label.indexOf("设备型号") > -1) {
        const device = this.devices.find(d => d.id === this.currentWorkorder.deviceId)
        return device ? device.model : ""
      }
      if (label.indexOf("设备运行时间") > -1) return ""
      if (label.indexOf("温度") > -1) return ""
      return ""
    },

    handleFormImage(field, file) {
      if (!file || !file.raw) return
      if (field.value.length >= 9) {
        this.$message.warning("现场照片最多上传 9 个文件")
        return
      }
      if (file.raw.size > 50 * 1024 * 1024) {
        this.$message.warning("单个文件不能超过 50MB")
        return
      }

      const item = {
        uid: file.uid || ("form-image-" + Date.now()),
        name: file.name,
        type: file.raw.type || "image/*",
        url: "",
        uploading: true,
        uploaded: false,
        size: file.raw.size,
        progress: 0,
      }
      field.value.push(item)

      this.uploadPicAndVid(file.raw, percent => {
        const target = field.value.find(media => media.uid === item.uid)
        if (target && this.isLargeMedia(target)) target.progress = percent
      }).then(url => {
        const target = field.value.find(media => media.uid === item.uid)
        if (!target) return
        target.url = url
        target.uploading = false
        target.uploaded = true
        target.progress = 100
        this.$message.success("图片上传成功")
      }).catch(error => {
        const index = field.value.findIndex(media => media.uid === item.uid)
        if (index > -1) field.value.splice(index, 1)
        this.$message.warning(error && error.message ? error.message : "图片上传失败")
      })
    },

    getFormImageField() {
      return this.formFields.find(field => field.type === "image")
    },

    addFormTableRow() {
      this.formTableRows.push({
        id: Date.now(),
        project: "",
        standard: "",
        result: "",
      })
    },

    removeFormTableRow(index) {
      this.formTableRows.splice(index, 1)
    },

    openSignatureDialog(type) {
      this.signatureType = type === "engineer" ? "engineer" : "customer"
      this.signatureDialogShow = true
      this.signatureDrawing = false
      this.signatureHasContent = false
      this.signatureUploading = false
      this.openMask()

      this.$nextTick(() => {
        const canvas = this.$refs.signatureCanvas
        if (!canvas) return
        const ctx = canvas.getContext("2d")
        ctx.clearRect(0, 0, canvas.width, canvas.height)
        ctx.lineWidth = 3
        ctx.lineCap = "round"
        ctx.lineJoin = "round"
        ctx.strokeStyle = "#222"
        this.signatureCanvasContext = ctx
      })
    },

    closeSignatureDialog() {
      this.signatureDialogShow = false
      this.signatureDrawing = false
      this.signatureUploading = false
      this.signatureCanvasContext = null
      this.closeMask()
    },

    getSignaturePoint(event) {
      const canvas = this.$refs.signatureCanvas
      if (!canvas) return null
      const rect = canvas.getBoundingClientRect()
      const source = event.touches && event.touches.length ? event.touches[0] : event
      return {
        x: (source.clientX - rect.left) * (canvas.width / rect.width),
        y: (source.clientY - rect.top) * (canvas.height / rect.height),
      }
    },

    startSignature(event) {
      const point = this.getSignaturePoint(event)
      if (!point || !this.signatureCanvasContext) return
      this.signatureDrawing = true
      this.signatureHasContent = true
      this.signatureCanvasContext.beginPath()
      this.signatureCanvasContext.moveTo(point.x, point.y)
    },

    drawSignature(event) {
      if (!this.signatureDrawing || !this.signatureCanvasContext) return
      const point = this.getSignaturePoint(event)
      if (!point) return
      this.signatureCanvasContext.lineTo(point.x, point.y)
      this.signatureCanvasContext.stroke()
    },

    endSignature() {
      this.signatureDrawing = false
    },

    canvasToBlob(canvas) {
      return new Promise((resolve, reject) => {
        canvas.toBlob(blob => {
          if (blob) {
            resolve(blob)
          } else {
            reject(new Error("签名图片生成失败"))
          }
        }, "image/png")
      })
    },

    confirmSignature() {
      if (!this.signatureHasContent) {
        this.$message.warning("请先完成手写签名")
        return
      }

      const canvas = this.$refs.signatureCanvas
      if (!canvas) return

      this.signatureUploading = true
      this.canvasToBlob(canvas).then(blob => {
        const file = new File([blob], "signature-" + this.signatureType + "-" + Date.now() + ".png", {
          type: "image/png",
        })
        return this.uploadPicAndVid(file)
      }).then(url => {
        if (this.signatureType === "customer") {
          this.formSignature.customerSignatureUrl = url
        } else {
          this.formSignature.engineerSignatureUrl = url
        }
        this.$message.success("签名上传成功")
        this.closeSignatureDialog()
        this.openMask()
      }).catch(error => {
        this.$message.warning(error && error.message ? error.message : "签名上传失败")
      }).finally(() => {
        this.signatureUploading = false
      })
    },

    validateFormRequiredShortFields() {
      const requiredFields = (this.formFields || []).filter(field =>
        field && field.type === "text" && field.required
      )

      for (let i = 0; i < requiredFields.length; i++) {
        const field = requiredFields[i]
        const value = Array.isArray(field.value)
          ? field.value.filter(value => value !== null && value !== undefined && String(value).trim() !== "")
          : String(field.value === null || field.value === undefined ? "" : field.value).trim()

        const empty = Array.isArray(value) ? value.length === 0 : value === ""
        if (empty) {
          this.$message.warning("请填写必填项：" + (field.label || "短文本字段"))
          return false
        }
      }

      return true
    },

    saveForm() {
      if (!this.validateFormRequiredShortFields()) return

      const imageField = this.getFormImageField()
      const imageItems = imageField && Array.isArray(imageField.value) ? imageField.value : []

      if (imageItems.some(item => item.uploading || !item.url)) {
        this.$message.warning("请等待现场照片上传完成")
        return
      }

      const shortFields = (this.formFields || [])
        .filter(field => field.type !== "image" && field.type !== "textarea")
        .map(field => ({
          title: field.label,
          content: Array.isArray(field.value) ? field.value.join(",") : (field.value || ""),
          required: field.required === true,
        }))

      const longFields = (this.formFields || [])
        .filter(field => field.type === "textarea")
        .map(field => ({
          title: field.label,
          rows: Number(field.rows) || 3,
          content: field.value || "",
        }))

      const templatePayload = {
        name: this.formTemplateDetail ? this.formTemplateDetail.name : (this.currentWorkorder.templateName || ""),
        formTitle: this.formTemplateDetail ? this.formTemplateDetail.title : (this.currentWorkorder.templateName || ""),
        shortTextJson: JSON.stringify(shortFields),
        longTextJson: JSON.stringify(longFields),
        tableJson: JSON.stringify((this.formTableRows || []).map(row => ({
          project: row.project || "",
          standard: row.standard || "",
          result: row.result || "",
          resultValues: Object.assign({}, row._controlValues || {}),
        }))),
        imageTitle: imageField ? imageField.label : "",
        imageUrl: imageItems.map(item => item.url).filter(Boolean).join(","),
        customerSignatureUrl: this.formSignature.customerSignatureUrl || "",
        engineerSignatureUrl: this.formSignature.engineerSignatureUrl || "",
      }

      const payload = {
        id: this.currentWorkorder.id,
        customerId: this.currentWorkorder.customerId,
        executeType: this.currentWorkorder.executeType === undefined
          ? (this.currentWorkorder.executeMode === "self" ? 1 : 0)
          : this.currentWorkorder.executeType,
        woStatus: 2,
        assigneeid: this.currentWorkorder.assigneeId || "",
        assigneeName: this.currentWorkorder.executor || "",
        subject: this.currentWorkorder.subject || "",
        description: this.currentWorkorder.description || "",
        equipmentId: this.currentWorkorder.equipmentId || "",
        equipmentName: this.currentWorkorder.equipmentName || this.currentWorkorder.deviceName || "",
        // templateRecordId: this.currentWorkorder.templateId,
        template: templatePayload,
      }

      this.postNoJson("/workorder/tempStorWorkorder", payload).then(res => {
        if (res && res.success) {
          this.$message.success("工单表单保存成功")
          this.formDialogShow = false
          this.closeMask()
          this.getWorkorders()
        } else {
          this.$message.warning("工单表单保存失败：" + ((res && res.message) || "请求失败"))
        }
      }).catch(() => {
        this.$message.error("工单表单保存失败")
      })
    },

    closeFormDialog() {
      this.formDialogShow = false
      this.closeMask()
    },

    openPrintPreview() {
      this.printPreviewShow = true
      this.closeMask()
    },

    closePrintPreview() {
      this.printPreviewShow = false
      if (this.formDialogShow || this.templateDialogShow) {
        this.openMask()
      }
    },

    displayFieldValue(field) {
      if (Array.isArray(field.value)) return field.value.join("、")
      return field.value || "-"
    },

    printForm() {
      const area = document.getElementById("print-area")
      if (!area) return
      const win = window.open("", "_blank")
      if (!win) {
        this.$message.warning("浏览器阻止了打印窗口，请允许弹窗")
        return
      }
      win.document.write(
        "<html><head><title>打印预览</title>" +
        "<style>body{font-family:Arial,'Microsoft YaHei';padding:30px;color:#333}" +
        "table{width:100%;border-collapse:collapse}th,td{border:1px solid #666;padding:8px}" +
        "h2{text-align:center}.print-base-info{display:grid;grid-template-columns:1fr 1fr;gap:10px;margin-bottom:20px}" +
        "</style></head><body>" + area.innerHTML + "</body></html>"
      )
      win.document.close()
      win.focus()
      win.print()
      win.close()
    },

    /* ==========================================================
     * 客户：列表 / 新建 / 编辑 / 详情
     * ========================================================== */
    normalizeCustomer(item) {
      const ids = String(item.businessPersonId || "")
        .split(",")
        .map(Number)
        .filter(Boolean)
      const names = String(item.businessPersonName || "")
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)

      const fileUrls = String(item.fileUrl || "")
        .split(",")
        .map(v => v.trim())
        .filter(Boolean)

        // return
      return {
        id: item.id,
        name: item.name || "",
        fullName: item.fullName || "",
        introduction: item.introduction || "",
        contact: item.contactPerson || "",
        phone: item.contactPhone || "",
        address: item.address || "",
        remark: item.remark || "",
        businessPersonId: ids.join(","),
        businessPersonName: names.join(","),
        salesman: ids.slice(),
        relatedUser: names.join(","),
        cloudEnterpriseId: Number(item.cloudEnterpriseId) || "",
        cloudEnterpriseName: item.cloudEnterpriseName || "",
        cloudCompany: item.cloudEnterpriseName || "",
        type: item.type === null || item.type === undefined ? "" : item.type,
        serviceEnd: item.serviceExpireTime || "",
        fileUrl: fileUrls.join(","),
        mediaList: fileUrls.map((url, index) => ({
          uid: "customer-file-" + String(item.id || Date.now()) + "-" + index,
          name: this.getMediaFileName(url, index),
          type: this.getMediaType(url),
          size: 0,
          url: url,
          uploaded: true,
        })),
      }
    },

    getMediaFileName(url, index) {
      const cleanUrl = String(url || "").split("?")[0]
      const name = cleanUrl.substring(cleanUrl.lastIndexOf("/") + 1)
      return name || ("文件" + (index + 1))
    },

    getMediaType(url) {
      const cleanUrl = String(url || "").split("?")[0].toLowerCase()
      if (/\.(jpg|jpeg|png|gif|bmp|webp|svg)$/.test(cleanUrl)) return "image/*"
      if (/\.(mp4|mov|avi|wmv|mkv|webm|m4v)$/.test(cleanUrl)) return "video/*"
      return "application/octet-stream"
    },

    // 获取全部客户：仅供新建/编辑工单“关联客户”使用，不改变客户管理分页逻辑
    getWorkorderCustomerList(showError = false) {
      this.postNoJson("/customer/listCustomer", {}).then(res => {
        if (res && res.success) {
          const list = Array.isArray(res.result)
            ? res.result
            : (res.result && Array.isArray(res.result.data) ? res.result.data : [])
          this.workorderCustomerList = list.map(item => this.normalizeCustomer(item))
        } else {
          this.workorderCustomerList = []
          if (showError) {
            this.$message({
              message: "获取工单关联客户列表失败：" + ((res && res.message) || "请求失败"),
              type: "warning"
            })
          }
        }
      }).catch(() => {
        this.workorderCustomerList = []
        if (showError) {
          this.$message.warning("获取工单关联客户列表失败")
        }
      })
    },

    filterCustomers() {
      const params = {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
      }
      if (this.customerQuery.type !== null && this.customerQuery.type !== undefined && this.customerQuery.type !== "") {
        params.type = this.customerQuery.type
      }
      if ((this.customerQuery.keyword || "").trim()) {
        params.name = this.customerQuery.keyword.trim()
      }

      this.postNoJson("/customer/pageCustomer", params).then(res => {
        if (res.success && res.result) {
          this.customers = (res.result.data || []).map(item => this.normalizeCustomer(item))
          this.customerTotalCount = Number(res.result.totalCount || 0)
        } else {
          this.customers = []
          this.customerTotalCount = 0
          this.$message({
            message: "获取客户列表失败：" + (res.message || "请求失败"),
            type: "warning"
          })
        }
      }).catch(() => {
        this.customers = []
        this.customerTotalCount = 0
        this.$message({
          message: "获取客户列表失败",
          type: "warning"
        })
      })
    },

    openCustomerDialog(item, index) {
      if(!this.functionList.includes('customerEdit')||this.$store.state.isLook) return

      this.customerEditIndex = typeof index === "number" ? index : null

      if (!item) {
        this.customerForm = this.getDefaultCustomerForm()
        this.customerDialogShow = true
        this.openMask()
        this.$nextTick(() => {
          if (this.$refs.customerForm) this.$refs.customerForm.clearValidate()
        })
        return
      }

      this.postNoJson("/customer/detailCustomer", {
        id: item.id,
      }).then(res => {
        if (res.success && res.result) {
          const customer = this.normalizeCustomer(res.result)
          this.customerForm = Object.assign({}, this.getDefaultCustomerForm(), {
            id: customer.id,
            name: customer.name,
            fullName: customer.fullName,
            contact: customer.contact,
            phone: customer.phone,
            address: customer.address,
            cloudCompany: customer.cloudCompany,
            cloudEnterpriseId: customer.cloudEnterpriseId,
            cloudEnterpriseName: customer.cloudEnterpriseName,
            type: customer.type,
            serviceEnd: customer.serviceEnd,
            relatedUser: customer.relatedUser,
            salesman: customer.salesman.slice(),
            businessPersonId: customer.businessPersonId,
            businessPersonName: customer.businessPersonName,
            introduction: customer.introduction,
            remark: customer.remark,
            fileUrl: customer.fileUrl,
            mediaList: customer.mediaList.slice(),
          })
          this.customerDialogShow = true
          this.openMask()
          this.$nextTick(() => {
            if (this.$refs.customerForm) this.$refs.customerForm.clearValidate()
          })
        } else {
          this.$message({
            message: "获取客户详情失败：" + (res.message || "请求失败"),
            type: "warning"
          })
        }
      }).catch(() => {
        this.$message.warning("获取客户详情失败")
      })
    },

    closeCustomerDialog() {
      this.customerDialogShow = false
      this.customerEditIndex = null
      this.customerForm = this.getDefaultCustomerForm()
      this.closeMask()
    },

    handleCustomerCompanyChange(value) {
      const company = this.companyOptions.find(item => String(item.value) === String(value))
      this.customerForm.cloudEnterpriseName = company ? company.label : ""
      this.customerForm.cloudCompany = company ? company.label : ""
    },

    getCustomerBusinessPersonData() {
      const ids = Array.isArray(this.customerForm.salesman)
        ? this.customerForm.salesman.map(v => String(v)).filter(Boolean)
        : String(this.customerForm.salesman || "").split(",").map(v => v.trim()).filter(Boolean)
      const selected = ids.map(id => {
        return this.userOptions.find(item => String(item.value) === String(id))
      }).filter(Boolean)

      return {
        ids: ids.join(","),
        names: selected.map(item => item.label).join(","),
      }
    },

    buildCustomerPayload() {
      const business = this.getCustomerBusinessPersonData()
      const fileUrls = (this.customerForm.mediaList || [])
        .map(item => item.url)

      const company = this.companyOptions.find(item =>
        String(item.value) === String(this.customerForm.cloudEnterpriseId)
      )
      console.log(this.customerForm)
      return {
        name: (this.customerForm.name || "").trim(),
        fullName: (this.customerForm.fullName || "").trim(),
        introduction: this.customerForm.introduction || "",
        contactPerson: (this.customerForm.contact || "").trim(),
        contactPhone: (this.customerForm.phone || "").trim(),
        address: (this.customerForm.address || "").trim(),
        remark: this.customerForm.remark || "",
        businessPersonId: business.ids,
        businessPersonName: business.names,
        cloudEnterpriseId: this.customerForm.cloudEnterpriseId || "",
        cloudEnterpriseName: this.customerForm.cloudEnterpriseName || (company ? company.label : ""),
        type: this.customerForm.type,
        serviceExpireTime: this.customerForm.serviceEnd || "",
        fileUrl: fileUrls.join(","),
      }
    },

    saveCustomer() {
      this.$refs.customerForm.validate(valid => {
        if (!valid) return

        const uploading = (this.customerForm.mediaList || []).some(item => item.uploading)
        if (uploading) {
          this.$message.warning("图片/视频正在上传，请稍候再提交")
          return
        }
        const failedOrMissingUrl = (this.customerForm.mediaList || []).some(item => !item.url)
        if (failedOrMissingUrl) {
          this.$message.warning("存在未完成上传的图片/视频，请重新上传")
          return
        }

        const payload = this.buildCustomerPayload()
        const isEdit = !!this.customerForm.id && this.customerEditIndex !== null
        if (isEdit) payload.id = this.customerForm.id
        const url = isEdit ? "/customer/editCustomer" : "/customer/saveCustomer"
        this.postNoJson(url, payload).then(res => {
          if (res.success) {
            this.$message.success(isEdit ? "客户修改成功" : "客户保存成功")
            this.closeCustomerDialog()
            this.filterCustomers()
            // 新增/编辑客户成功后同步刷新工单关联客户数据
            this.getWorkorderCustomerList(true)
          } else {
            this.$message({
              message: (isEdit ? "修改客户失败：" : "保存客户失败：") + (res.message || "请求失败"),
              type: "warning"
            })
          }
        }).catch(() => {
          this.$message.error(isEdit ? "修改客户失败" : "保存客户失败")
        })
      })
    },

    confirmDeleteCustomer(item) {
      if(!this.functionList.includes('customerEdit')||this.$store.state.isLook) return
      this.deleteType = "customer"
      this.deleteTarget = item
      this.deleteIndex = this.customers.indexOf(item)
      this.deleteDialogShow = true
      this.openMask()
    },

    openCustomerDetail(item) {
      if (!item || !item.id) return
      this.postNoJson("/customer/detailCustomer", { id: item.id }).then(res => {
        if (res.success && res.result) {
          this.currentCustomer = this.normalizeCustomer(res.result)
          this.customerDetailTab = "basic"
          this.deviceQuery.keyword = ""
          this.devicePageNumber = 1
          this.devicePageSize = this.pageSize
          this.maintenanceQuery.keyword = ""
          this.maintenancePageNumber = 1
          this.maintenancePageSize = 10
          this.customerMaintenanceRecords = []
          this.maintenanceTotalCount = 0
          this.customerDetailShow = true
          this.openMask()
          this.getCustomerDevices()
        } else {
          this.$message.warning("获取客户详情失败：" + (res.message || "请求失败"))
        }
      }).catch(() => {
        this.$message.warning("获取客户详情失败")
      })
    },

    openCustomerDetailById(id) {
      this.openCustomerDetail({id:id})
    },

    switchCustomerDetailTab(tab) {
      this.customerDetailTab = tab
      if (tab === "device") {
        this.devicePageNumber = 1
        this.getCustomerDevices()
      } else if (tab === "maintenance") {
        this.maintenancePageNumber = 1
        this.getCustomerMaintenance()
      }
    },

    closeCustomerDetail() {
      this.customerDetailShow = false
      this.currentCustomer = {}
      this.closeMask()
    },

    isExpired(date) {
      if (!date) return false
      return new Date(date.replace(/-/g, "/")).getTime() < Date.now()
    },

    isMediaUploading(list) {
      return Array.isArray(list) && list.some(item => item && item.uploading)
    },

    isFormImageUploading() {
      return (this.formFields || []).some(field =>
        field && field.type === "image" && this.isMediaUploading(field.value)
      )
    },

    isLargeMedia(item) {
      return Number(item && item.size || 0) > 1024 * 1024
    },

    isImageMedia(item) {
      if (!item) return false
      const type = String(item.type || "").toLowerCase()
      if (type.indexOf("image/") === 0) return true
      const url = String(item.url || "").split("?")[0].toLowerCase()
      return /\\.(jpg|jpeg|png|gif|bmp|webp|svg)$/.test(url)
    },

    isVideoMedia(item) {
      if (!item) return false
      const type = String(item.type || "").toLowerCase()
      if (type.indexOf("video/") === 0) return true
      const url = String(item.url || "").split("?")[0].toLowerCase()
      return /\\.(mp4|mov|avi|wmv|mkv|webm|m4v|3gp|flv)$/.test(url)
    },

    openMediaPreview(item) {
      if (!item || !item.url) return
      this.currentMediaPreview = Object.assign({}, item, {
        type: item.type || this.getMediaType(item.url),
      })
      this.mediaPreviewShow = true
      this.openMask()
    },

    closeMediaPreview() {
      this.mediaPreviewShow = false
      this.currentMediaPreview = null
      // this.closeMask()
    },

    handleCustomerMedia(file) {
      if (!file || !file.raw) return
      const list = this.customerForm.mediaList
      if (list.length >= 9) {
        this.$message.warning("客户最多上传 9 个图片/视频")
        return
      }

      const currentTotal = list.reduce((sum, item) => sum + Number(item.size || 0), 0)
      if (file.raw.size > 50 * 1024 * 1024 || currentTotal + file.raw.size > 50 * 1024 * 1024) {
        this.$message.warning("图片及视频总大小不能超过 50MB")
        return
      }

      const item = {
        uid: file.uid || ("customer-" + Date.now()),
        name: file.name,
        size: file.raw.size,
        type: file.raw.type || "",
        url: "",
        uploading: true,
        uploaded: false,
        progress: 0,
      }
      list.push(item)

      this.uploadPicAndVid(file.raw, percent => {
        const target = list.find(media => media.uid === item.uid)
        if (target && this.isLargeMedia(target)) target.progress = percent
      }).then(url => {
        const target = list.find(media => media.uid === item.uid)
        if (!target) return
        target.url = url
        target.uploading = false
        target.uploaded = true
        target.progress = 100
        this.$message.success("文件上传成功")
      }).catch(error => {
        const index = list.findIndex(media => media.uid === item.uid)
        if (index > -1) list.splice(index, 1)
        this.$message.warning(error && error.message ? error.message : "图片/视频上传失败")
      })
    },

    uploadPicAndVid(rawFile, onProgress) {
      return new Promise((resolve, reject) => {
        const xhr = new XMLHttpRequest()
        const formData = new FormData()
        formData.append("file", rawFile)

        xhr.open("POST", this.baseURL + "/v1/file/uploadPicAndVid", true)
        xhr.withCredentials = true
        let url = ""

        // 只有文件超过 1MB 时才向界面展示上传进度。
        if (rawFile && rawFile.size > 1024 * 1024) {
          xhr.upload.onprogress = event => {
            if (!event.lengthComputable || typeof onProgress !== "function") return
            const percent = Math.min(100, Math.round(event.loaded / event.total * 100))
            onProgress(percent)
          }
        }

        xhr.onreadystatechange = () => {
          if (xhr.readyState !== 4) return
          if (xhr.status < 200 || xhr.status >= 300) {
            reject(new Error("图片/视频上传失败"))
            return
          }
          if (xhr.status === 200) {
            url = xhr.responseText
          }

          if (!url) {
            reject(new Error("图片/视频上传未返回URL"))
            return
          }

          if (rawFile && rawFile.size > 1024 * 1024 && typeof onProgress === "function") {
            onProgress(100)
          }
          resolve(url)
        }

        xhr.onerror = () => reject(new Error("图片/视频上传失败"))
        xhr.onabort = () => reject(new Error("图片/视频上传已取消"))
        xhr.send(formData)
      })
    },

    removeCustomerMedia(index) {
      this.customerForm.mediaList.splice(index, 1)
    },

    handleWorkorderMedia(file) {
      if (!file || !file.raw) return
      const list = this.workorderForm.mediaList
      if (list.length >= 9) {
        this.$message.warning("工单最多上传 9 个图片/视频")
        return
      }

      const currentTotal = list.reduce((sum, item) => sum + Number(item.size || 0), 0)
      if (file.raw.size > 50 * 1024 * 1024 || currentTotal + file.raw.size > 50 * 1024 * 1024) {
        this.$message.warning("图片及视频总大小不能超过 50MB")
        return
      }

      const item = {
        uid: file.uid || ("workorder-" + Date.now()),
        name: file.name,
        size: file.raw.size,
        type: file.raw.type || "",
        url: "",
        uploading: true,
        uploaded: false,
        progress: 0,
      }
      list.push(item)

      this.uploadPicAndVid(file.raw, percent => {
        const target = list.find(media => media.uid === item.uid)
        if (target && this.isLargeMedia(target)) target.progress = percent
      }).then(url => {
        const target = list.find(media => media.uid === item.uid)
        if (!target) return
        target.url = url
        target.uploading = false
        target.uploaded = true
        target.progress = 100
        this.$message.success("文件上传成功")
      }).catch(error => {
        const index = list.findIndex(media => media.uid === item.uid)
        if (index > -1) list.splice(index, 1)
        this.$message.warning(error && error.message ? error.message : "图片/视频上传失败")
      })
    },

    removeMedia(index) {
      this.workorderForm.mediaList.splice(index, 1)
    },

    /* ==========================================================
     * 设备档案
     * ========================================================== */
    filterDevices() {
      this.deviceQuery.keyword = (this.deviceQuery.keyword || "").trim()
      this.devicePageNumber = 1
      this.getCustomerDevices()
    },

    setDeviceSize(pageObj) {
      this.devicePageSize = pageObj.size
      this.devicePageNumber = pageObj.number
      this.getCustomerDevices()
    },

    setDeviceNum(num) {
      this.devicePageNumber = num
      this.getCustomerDevices()
    },

    getCustomerDevices() {
      if (!this.currentCustomer.id) {
        this.devices = []
        this.deviceTotalCount = 0
        return Promise.resolve()
      }

      return this.postNoJson("/equipment/pageEquipment", {
        pageNo: this.devicePageNumber,
        pageSize: this.devicePageSize,
        customerId: this.currentCustomer.id,
        keyword: this.deviceQuery.keyword || "",
      }).then(res => {
        if (res.success && res.result) {
          this.devices = (res.result.data || []).map(item => this.normalizeDevice(item))
          this.deviceTotalCount = Number(res.result.totalCount || 0)
        } else {
          this.devices = []
          this.deviceTotalCount = 0
          this.$message.warning("获取设备列表失败：" + (res.message || "请求失败"))
        }
      }).catch(() => {
        this.devices = []
        this.deviceTotalCount = 0
        this.$message.warning("获取设备列表失败")
      })
    },

    normalizeDevice(item) {
      const source = item || {}
      const specParams = this.parseSpecParams(source.specsParam)
      const fileUrls = this.getFileUrlList(source.fileUrl)
      return Object.assign({}, source, {
        customerId: source.customerId || this.currentCustomer.id,
        specParams: specParams.map((param, index) => Object.assign({
          uid: "param-" + String(source.id || Date.now()) + "-" + index
        }, param)),
        mediaList: fileUrls.map((url, index) => ({
          uid: "equipment-file-" + String(source.id || Date.now()) + "-" + index,
          name: this.getMediaFileName(url, index),
          type: this.getMediaType(url),
          size: 0,
          url: url,
          uploaded: true,
          uploading: false,
        })),
      })
    },

    parseSpecParams(value) {
      if (Array.isArray(value)) return value
      if (!value) return []
      try {
        const parsed = JSON.parse(value)
        return Array.isArray(parsed) ? parsed : []
      } catch (e) {
        return []
      }
    },

    getFileUrlList(value) {
      if (Array.isArray(value)) return value.filter(Boolean)
      return String(value || "").split(",").map(item => item.trim()).filter(Boolean)
    },

    formatSpecParams(value) {
      const params = this.parseSpecParams(value)
      return params.map(item => String(item.title || "") + ": " + String(item.content || "")).join("；") || "-"
    },

    buildDevicePayload() {
      return {
        customerId: this.currentCustomer.id,
        name: String(this.deviceForm.name || "").trim(),
        serialNo: String(this.deviceForm.serialNo || "").trim(),
        equipmentKey: String(this.deviceForm.equipmentKey || "").trim(),
        cloudEquipmentId: Number(this.deviceForm.cloudEquipmentId) || "",
        cloudEquipmentName: this.deviceForm.cloudEquipmentName || "",
        remark: this.deviceForm.remark || "",
        specsParam: JSON.stringify((this.deviceForm.specParams || []).map(param => ({
          title: String(param.title || "").trim(),
          content: String(param.content || "").trim(),
        }))),
        fileUrl: (this.deviceForm.mediaList || []).map(item => item.url).filter(Boolean).join(","),
      }
    },

    openDeviceDialog(item) {
      if(!this.functionList.includes('customerEdit')||this.$store.state.isLook||!this.currentCustomer.id) return
      this.deviceEditId = item ? item.id : null
      const prepareForm = form => {
        this.deviceForm = form
        if (this.$refs.deviceForm) this.$refs.deviceForm.clearValidate()
      }

      if (item && item.id) {
        this.postNoJson("/equipment/detailEquipment", { id: item.id }).then(res => {
          if (res.success && res.result) {
            res.result.cloudEquipmentId = Number(res.result.cloudEquipmentId) || ""
            const detail = this.normalizeDevice(res.result)
            prepareForm(Object.assign({}, this.getDefaultDeviceForm(), detail, {
              customerId: this.currentCustomer.id,
            }))
          } else {
            this.$message.warning("获取设备详情失败：" + (res.message || "请求失败"))
          }
        }).catch(() => {
          this.$message.warning("获取设备详情失败")
        })
      } else {
        prepareForm(Object.assign({}, this.getDefaultDeviceForm(), {
          customerId: this.currentCustomer.id,
        }))
      }

      if (this.currentCustomer.cloudEnterpriseId) {
        this.getDeviceListByCompany(this.currentCustomer.cloudEnterpriseId)
      }
      this.deviceDialogShow = true
      this.openMask()
      this.$nextTick(() => {
        if (this.$refs.deviceForm) this.$refs.deviceForm.clearValidate()
      })
    },

    handleCloudDeviceChange(value) {
      const selectedDevice = this.cloudDeviceOptions.find(item => String(item.value) === String(value))
      if (selectedDevice) {
        this.deviceForm.cloudEquipmentId = selectedDevice.value
        this.deviceForm.cloudEquipmentName = selectedDevice.label
        this.deviceForm.equipmentKey = selectedDevice.key || this.deviceForm.equipmentKey
      } else if (!value) {
        this.deviceForm.cloudEquipmentId = ""
        this.deviceForm.cloudEquipmentName = ""
        this.deviceForm.equipmentKey = ""
      }
    },

    getDeviceListByCompany(cid) {
      this.get('/Device/getList', { companyId: cid }).then(res => {
        if (res.success) {
          this.cloudDeviceOptions = (res.result || []).map(item => ({
            label: item.name,
            value: item.id,
            key: item.code,
          }))
        } else {
          this.$message.warning(`获取客户云端设备列表失败：${res.message || "请求失败"}`)
        }
      }).catch(() => {
        this.$message.warning("获取客户云端设备列表失败")
      })
    },

    closeDeviceDialog() {
      this.deviceDialogShow = false
      this.deviceEditId = null
      this.deviceForm = this.getDefaultDeviceForm()
    },

    addDeviceParam() {
      this.deviceForm.specParams.push({
        uid: "param-" + Date.now() + "-" + this.deviceForm.specParams.length,
        title: "",
        content: "",
      })
      this.$nextTick(() => this.$refs.deviceForm && this.$refs.deviceForm.validateField("specParams"))
    },

    removeDeviceParam(index) {
      if (this.deviceForm.specParams.length <= 1) {
        this.$message.warning("至少保留一项规格参数")
        return
      }
      this.deviceForm.specParams.splice(index, 1)
      this.$nextTick(() => this.$refs.deviceForm && this.$refs.deviceForm.validateField("specParams"))
    },

    validateDeviceSpecParams() {
      if (this.$refs.deviceForm) {
        this.$refs.deviceForm.validateField("specParams")
      }
    },

    handleDeviceMedia(file) {
      if (!file || !file.raw) return
      const list = this.deviceForm.mediaList
      if (list.length >= 9) {
        this.$message.warning("设备最多上传 9 个图片/视频")
        return
      }

      const currentTotal = list.reduce((sum, item) => sum + Number(item.size || 0), 0)
      if (file.raw.size > 50 * 1024 * 1024 || currentTotal + file.raw.size > 50 * 1024 * 1024) {
        this.$message.warning("图片及视频总大小不能超过 50MB")
        return
      }

      const item = {
        uid: file.uid || ("equipment-" + Date.now()),
        name: file.name,
        size: file.raw.size,
        type: file.raw.type || "",
        url: "",
        uploading: true,
        uploaded: false,
        progress: 0,
      }
      list.push(item)

      this.uploadPicAndVid(file.raw, percent => {
        const target = list.find(media => media.uid === item.uid)
        if (target && this.isLargeMedia(target)) target.progress = percent
      }).then(url => {
        const target = list.find(media => media.uid === item.uid)
        if (!target) return
        target.url = url
        target.uploading = false
        target.uploaded = true
        target.progress = 100
        this.$message.success("文件上传成功")
      }).catch(error => {
        const index = list.findIndex(media => media.uid === item.uid)
        if (index > -1) list.splice(index, 1)
        this.$message.warning(error && error.message ? error.message : "图片/视频上传失败")
      })
    },

    removeDeviceMedia(index) {
      this.deviceForm.mediaList.splice(index, 1)
    },

    saveDevice() {
      this.$refs.deviceForm.validate(valid => {
        if (!valid) return

        const uploading = (this.deviceForm.mediaList || []).some(item => item.uploading)
        if (uploading) {
          this.$message.warning("图片/视频正在上传，请稍候再提交")
          return
        }
        const failedOrMissingUrl = (this.deviceForm.mediaList || []).some(item => !item.url)
        if (failedOrMissingUrl) {
          this.$message.warning("存在未完成上传的图片/视频，请重新上传")
          return
        }

        const payload = this.buildDevicePayload()
        const isEdit = !!this.deviceEditId
        if (isEdit) payload.id = this.deviceEditId

        const url = isEdit ? "/equipment/editEquipment" : "/equipment/saveEquipment"
        this.postNoJson(url, payload).then(res => {
          if (res.success) {
            this.$message.success(isEdit ? "设备修改成功" : "设备保存成功")
            this.closeDeviceDialog()
            this.devicePageNumber = 1
            this.getCustomerDevices()
          } else {
            this.$message.warning((isEdit ? "修改设备失败：" : "保存设备失败：") + (res.message || "请求失败"))
          }
        }).catch(() => {
          this.$message.warning(isEdit ? "修改设备失败" : "保存设备失败")
        })
      })
    },

    confirmDeleteDevice(item) {
      if(!this.functionList.includes('customerEdit')||this.$store.state.isLook||!item || !item.id) return
      this.$confirm("确定删除该设备吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        return this.postNoJson("/equipment/removeEquipment", {
          id: item.id,
          cloudEquipmentId: item.cloudEquipmentId || "",
        })
      }).then(res => {
        if (res && res.success) {
          this.$message.success("设备删除成功")
          this.getCustomerDevices()
        } else if (res) {
          this.$message.warning("删除设备失败：" + (res.message || "请求失败"))
        }
      }).catch(() => {})
    },

    openDeviceDetail(id,type) {
      if (!id) return
      this.showType=type
      this.postNoJson("/equipment/detailEquipment", { id: id }).then(res => {
        if (res.success && res.result) {
          res.result.cloudEquipmentId = Number(res.result.cloudEquipmentId) || ""
          this.currentDevice = this.normalizeDevice(res.result)
          this.getDeviceMaintenance(res.result.id)
          this.deviceDetailShow = true
          this.openMask()
        } else {
          this.$message.warning("获取设备详情失败：" + (res.message || "请求失败"))
        }
      }).catch(() => {
        this.$message.warning("获取设备详情失败")
      })
    },

    // openDeviceDetailById(id) {
      // if (!id) return
      // const device = this.devices.find(item => String(item.id) === String(id))
      // if (device) {
        // this.openDeviceDetail(device.id)
        // return
      // }
      // this.postNoJson("/equipment/detailEquipment", { id: id }).then(res => {
        // if (res.success && res.result) {
          // res.result.cloudEquipmentId = Number(res.result.cloudEquipmentId) || ""
          // this.currentDevice = this.normalizeDevice(res.result)
          // this.getDeviceMaintenance(id)
          // this.deviceDetailShow = true
          // this.openMask()
        // }
      // })
    // },

    closeDeviceDetail() {
      this.deviceDetailShow = false
      this.currentDevice = {}
      this.showType=1
    },

    getDeviceSerial(id) {
      const device = this.devices.find(item => String(item.id) === String(id))
      return device ? String(device.serialNo || "") : ""
    },

    /* ==========================================================
     * 维保记录
     * ========================================================== */
    openDeviceMaintenance(device) {
      if(!this.functionList.includes('customerEdit')||this.$store.state.isLook||!device || !device.id) return
      this.openDeviceDetail(device.id,2)
    },

    getDeviceMaintenance(id) {
      if (!id) {
        this.maintenanceRecords = []
        return Promise.resolve([])
      }
      return this.postNoJson("/equipment/listEqptMaintRecord", { id: id }).then(res => {
        if (res.success) {
          this.maintenanceRecords = res.result || []
          return this.maintenanceRecords
        }
        this.maintenanceRecords = []
        this.$message.warning("获取维保记录失败：" + (res.message || "请求失败"))
        return []
      }).catch(() => {
        this.maintenanceRecords = []
        this.$message.warning("获取维保记录失败")
        return []
      })
    },

    filterCustomerMaintenance() {
      this.maintenanceQuery.keyword = (this.maintenanceQuery.keyword || "").trim()
      this.maintenancePageNumber = 1
      this.getCustomerMaintenance()
    },

    setMaintenanceSize(pageObj) {
      this.maintenancePageSize = pageObj.size
      this.maintenancePageNumber = pageObj.number
      this.getCustomerMaintenance()
    },

    setMaintenanceNum(num) {
      this.maintenancePageNumber = num
      this.getCustomerMaintenance()
    },

    getCustomerMaintenance() {
      const customerId = this.currentCustomer && this.currentCustomer.id
      if (!customerId) {
        this.customerMaintenanceRecords = []
        this.maintenanceTotalCount = 0
        return Promise.resolve([])
      }

      return this.postNoJson("/custMaintRecord/pageCustMaintRecord", {
        pageNo: this.maintenancePageNumber,
        pageSize: this.maintenancePageSize,
        customerId: customerId,
        keyword: this.maintenanceQuery.keyword || "",
      }).then(res => {
        if (res && res.success) {
          const result = res.result || {}
          this.customerMaintenanceRecords = Array.isArray(result.data) ? result.data : []
          this.maintenanceTotalCount = Number(result.totalCount) || 0
          return this.customerMaintenanceRecords
        }

        this.customerMaintenanceRecords = []
        this.maintenanceTotalCount = 0
        this.$message.warning("获取维保记录失败：" + ((res && res.message) || "请求失败"))
        return []
      }).catch(() => {
        this.customerMaintenanceRecords = []
        this.maintenanceTotalCount = 0
        this.$message.warning("获取维保记录失败")
        return []
      })
    },
exportCustomerMaintenance() {
  const customerId = this.currentCustomer && this.currentCustomer.id
  if (!customerId) {
    this.$message.warning("未获取到客户信息，无法导出维保记录")
    return
  }

  if (this.maintenanceExporting) return
  this.maintenanceExporting = true

  const xhr = new XMLHttpRequest()

  // JSON 请求参数
  const requestData = {
    customerId: customerId,
    keyword: this.maintenanceQuery.keyword || ""
  }

  xhr.open(
    "POST",
    this.baseURL + "/v1/custMaintRecord/exportCustMaintRecord",
    true
  )

  xhr.withCredentials = true

  // 设置请求头为 JSON
  xhr.setRequestHeader("Content-Type", "application/json;charset=UTF-8")
  xhr.setRequestHeader("Accept", "application/octet-stream")

  // 返回文件
  xhr.responseType = "blob"

  xhr.onreadystatechange = () => {
    if (xhr.readyState !== 4) return

    this.maintenanceExporting = false

    if (xhr.status < 200 || xhr.status >= 300) {
      this.$message.warning("维保记录导出失败")
      return
    }

    const blob = xhr.response

    if (!blob || !blob.size) {
      this.$message.warning("维保记录导出失败：未获取到文件")
      return
    }

    // 默认文件名
    let fileName = this.currentCustomer.name+"-维保记录.xlsx"

    // 下载文件
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement("a")

    link.href = url
    link.download = fileName

    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)

    window.URL.revokeObjectURL(url)

    this.$message.success("维保记录导出成功")
  }

  xhr.onerror = () => {
    this.maintenanceExporting = false
    this.$message.warning("维保记录导出失败")
  }

  // JSON 字符串发送
  xhr.send(JSON.stringify(requestData))
},


    openMaintenanceDialog() {
      this.$message.info("维保记录由工单产生，此处仅提供查询")
    },

    closeMaintenanceDialog() {},

    saveMaintenance() {},

    /* ==========================================================
     * 模板管理
     * ========================================================== */
    // 模板分页：接口 /template/pageTemplate，分页参数沿用现有 Pagination 组件
    filterTemplates() {
      this.postNoJson("/template/pageTemplate", {
        pageNo: this.pageNumber,
        pageSize: this.pageSize,
      }).then(res => {
        if (res.success && res.result) {
          this.templateList = res.result.data || []
          this.templateTotalCount = Number(res.result.totalCount || 0)
        } else {
          this.$message({
            message: `获取模板列表失败：${res.message || "请求失败"}`,
            type: "warning"
          })
        }
      }).catch(() => {
        this.$message({
          message: "获取模板列表失败",
          type: "warning"
        })
      })
    },

    setTemplateSize(pageObj) {
      this.pageSize = pageObj.size
      this.pageNumber = pageObj.number
      this.filterTemplates()
    },

    setTemplateNum(num) {
      this.pageNumber = num
      this.filterTemplates()
    },

    // 将后端 JSON 字段转换为模板编辑器使用的结构
    normalizeTemplateDetail(item) {
      console.log(item)
      const parseJson = (value, fallback) => {
        if (Array.isArray(value)) return value
        if (value === null || value === undefined || value === "") return fallback
        try {
          const parsed = JSON.parse(value)
          return Array.isArray(parsed) ? parsed : fallback
        } catch (e) {
          return fallback
        }
      }

      const shortList = parseJson(item.shortTextJson, [])
      const longList = parseJson(item.longTextJson, [])
      const tableList = parseJson(item.tableJson, [])

      return {
        id: item.id || null,
        name: item.name || "",
        title: item.formTitle || item.title || "",
        shortFields: shortList.map((field, index) => ({
          id: field.id || ("short-" + Date.now() + "-" + index),
          label: field.title || field.label || "",
          placeholder: "文本输入框",
          required: field.required !== false,
          content: field.content || "",
        })),
        longFields: longList.map((field, index) => ({
          id: field.id || ("long-" + Date.now() + "-" + index),
          title: field.title || "",
          rows: Math.max(Number(field.rows) || 1, 1),
          content: field.content || "",
        })),
        tableRows: tableList.map((row, index) => ({
          id: row.id || ("table-" + Date.now() + "-" + index),
          project: row.project || "",
          standard: row.standard || "",
          result: row.result || "",
          resultValues: row.resultValues && typeof row.resultValues === "object" ? row.resultValues : {},
        })),
        imageTitle: item.imageTitle || "",
        imageUrl: item.imageUrl || "",
        customerSignatureUrl: item.customerSignatureUrl || "",
        engineerSignatureUrl: item.engineerSignatureUrl || "",
        createTime: item.createTime || "",
        updateTime: item.updateTime || "",
      }
    },

    openTemplateDialog(item, index) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook) return
      this.templateEditIndex = typeof index === "number" ? index : null

      if (!item) {
        this.templateForm = this.getDefaultTemplateForm()
        this.templateDialogShow = true
        this.openMask()
        this.$nextTick(() => {
          if (this.$refs.templateForm) {
            this.$refs.templateForm.clearValidate()
          }
        })
        return
      }

      // 编辑时使用详情接口，避免列表字段与编辑结构不一致
      this.postNoJson("/template/detailTemplate", {
        id: item.id.toString(),
      }).then(res => {
        if (res.success && res.result) {
          this.templateForm = this.normalizeTemplateDetail(this.clone(res.result))
          console.log(this.templateForm)
          this.templateDialogShow = true
          this.openMask()
          this.$nextTick(() => {
            if (this.$refs.templateForm) {
              this.$refs.templateForm.clearValidate()
            }
          })
        } else {
          this.$message({
            message: `获取模板详情失败：${res.message || "请求失败"}`,
            type: "warning"
          })
        }
      }).catch(() => {
        this.$message({
          message: "获取模板详情失败",
          type: "warning"
        })
      })
    },

    closeTemplateDialog() {
      this.templateDialogShow = false
      this.templateEditIndex = null
      this.templateForm = this.getDefaultTemplateForm()
      this.closeMask()
    },

    buildTemplatePayload() {
      return {
        name: this.templateForm.name,
        formTitle: this.templateForm.title,
        shortTextJson: JSON.stringify((this.templateForm.shortFields || []).map(field => ({
          title: field.label || "",
          content: field.content || "",
          required: field.required === true,
        }))),
        longTextJson: JSON.stringify((this.templateForm.longFields || []).map(field => ({
          title: field.title || "",
          rows: Number(field.rows) || 1,
          content: field.content || "",
        }))),
        tableJson: JSON.stringify((this.templateForm.tableRows || []).map(row => ({
          project: row.project || "",
          standard: row.standard || "",
          result: row.result || "",
        }))),
        imageTitle: this.templateForm.imageTitle || "",
        imageUrl: this.templateForm.imageUrl || "",
        customerSignatureUrl: this.templateForm.customerSignatureUrl || "",
        engineerSignatureUrl: this.templateForm.engineerSignatureUrl || "",
      }
    },

    saveTemplate() {
      this.$refs.templateForm.validate(valid => {
        if (!valid) return

        const payload = this.buildTemplatePayload()
        const isEdit = this.templateEditIndex !== null && this.templateForm.id

        if (isEdit) {
          payload.id = this.templateForm.id
        }

        const url = isEdit ? "/template/editTemplate" : "/template/saveTemplate"
        console.log(url, isEdit, this.templateEditIndex, this.templateForm)
        // return
        this.postNoJson(url, payload).then(res => {
          if (res.success) {
            this.$message.success(isEdit ? "模板修改成功" : "模板保存成功")
            this.closeTemplateDialog()
            // 保存后重新请求当前页，确保分页总数和后端数据保持一致
            this.filterTemplates()
          } else {
            this.$message({
              message: `${isEdit ? "修改" : "保存"}模板失败：${res.message || "请求失败"}`,
              type: "warning"
            })
          }
        }).catch(() => {
          this.$message({
            message: `${isEdit ? "修改" : "保存"}模板失败`,
            type: "warning"
          })
        })
      })
    },

    addTemplateShortField() {
      this.templateForm.shortFields.push({
        id: Date.now(),
        label: "",
        placeholder: "文本输入框",
        required: true,
        content: "",
      })
    },

    removeTemplateShortField(index) {
      this.templateForm.shortFields.splice(index, 1)
    },

    addTemplateLongField() {
      this.templateForm.longFields.push({
        id: Date.now(),
        title: "",
        rows: 5,
        content: "",
      })
    },

    removeTemplateLongField(index) {
      this.templateForm.longFields.splice(index, 1)
    },

    addTemplateTableRow() {
      this.templateForm.tableRows.push({
        id: Date.now(),
        project: "",
        standard: "",
        result: "",
      })
    },

    removeTemplateTableRow(index) {
      this.templateForm.tableRows.splice(index, 1)
    },

    /**
     * 解析模板“结果”字段中的特殊语法：
     * {{复选:正常,需做4000H保养,需做8000H保养}}
     * {{单选:正常,有异响}}
     * {{文本:3}} => ______（长度 = 3 * 2 个下划线）
     * 普通文字与特殊控件可以混合使用。
     */
    parseTemplateResult(value) {
      const text = value == null ? '' : String(value)
      const result = []
      const reg = /\{\{\s*(复选|单选|文本)\s*:\s*([^{}]*?)\s*\}\}/g
      let lastIndex = 0
      let match
      let index = 0

      while ((match = reg.exec(text)) !== null) {
        if (match.index > lastIndex) {
          result.push({
            type: 'text',
            text: text.slice(lastIndex, match.index),
            key: 'text_' + index++
          })
        }

        const typeName = match[1]
        if (typeName === '文本') {
          const length = Math.max(parseInt(match[2].trim(), 10) || 0, 0)
          result.push({
            type: 'underline',
            text: '_'.repeat(length * 2),
            length: length,
            key: 'underline_' + index + '_' + match.index
          })
        } else {
          const type = typeName === '复选' ? 'checkbox' : 'radio'
          const options = match[2]
            .split(',')
            .map(item => item.trim())
            .filter(item => item !== '')

          result.push({
            type: type,
            options: options,
            key: type + '_' + index + '_' + match.index
          })
        }

        index++
        lastIndex = reg.lastIndex
      }

      if (lastIndex < text.length) {
        result.push({
          type: 'text',
          text: text.slice(lastIndex),
          key: 'text_' + index
        })
      }

      if (result.length === 0) {
        return [{ type: 'text', text: text, key: 'text_0' }]
      }
      return result
    },

    getFormTableParts(row) {
      if (!row) return []
      const parts = this.parseTemplateResult(row.result || "")
      if (!row._controlValues) {
        this.$set(row, "_controlValues", {})
      }
      parts.forEach(part => {
        if (part.type === "checkbox" && !Array.isArray(row._controlValues[part.key])) {
          this.$set(row._controlValues, part.key, [])
        } else if ((part.type === "radio" || part.type === "underline") && row._controlValues[part.key] === undefined) {
          this.$set(row._controlValues, part.key, "")
        }
      })
      return parts
    },

    initializeFormTableControlValues(row) {
      if (!row) return
      const parts = this.parseTemplateResult(row.result || "")
      if (!row._controlValues) this.$set(row, "_controlValues", {})
      parts.forEach(part => {
        if (part.type === "checkbox" && !Array.isArray(row._controlValues[part.key])) {
          this.$set(row._controlValues, part.key, [])
        } else if ((part.type === "radio" || part.type === "underline") && row._controlValues[part.key] === undefined) {
          this.$set(row._controlValues, part.key, "")
        }
      })
    },

    getWorkorderPreviewParts(row) {
      if (!row) return []
      const parts = this.parseTemplateResult(row.result || "")
      const values = row.resultValues && typeof row.resultValues === "object" ? row.resultValues : {}
      parts.forEach(part => {
        const originalKey = part.key
        part.originalKey = originalKey
        part.key = "row_" + String(row.id || "0") + "_" + originalKey
        if (part.type === "checkbox" && !Array.isArray(this.workorderPreviewValues[part.key])) {
          this.$set(this.workorderPreviewValues, part.key, Array.isArray(values[originalKey]) ? values[originalKey] : [])
        } else if ((part.type === "radio" || part.type === "underline") && this.workorderPreviewValues[part.key] === undefined) {
          this.$set(this.workorderPreviewValues, part.key, values[originalKey] !== undefined ? values[originalKey] : "")
        }
      })
      return parts
    },

    getWorkorderPreviewValue(row, part) {
      const values = row && row.resultValues ? row.resultValues : {}
      const key = part.originalKey || part.key
      return values[key] === undefined ? "" : values[key]
    },

    getPreviewImageUrls(value) {
      return String(value || "").split(",").map(v => v.trim()).filter(Boolean)
    },

    buildMediaUrl(url) {
      const value = String(url || "")
      if (!value) return ""
      if (/^https?:\/\//i.test(value)) return value
      return value
    },

    openWorkorderPreview(item) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook||!item || !item.id) return
      this.postNoJson("/workorder/detailWorkorder", {
        templateRecordId: item.templateRecordId,
        id: item.id,
      }).then(res => {
        if (!(res && res.success && res.result)) {
          this.$message.warning("获取工单表单内容失败：" + ((res && res.message) || "请求失败"))
          return
        }
        const detail = res.result
        if (!detail.templateVO) {
          this.$message.warning("该工单暂无已提交的表单内容")
          return
        }
        const normalized = this.normalizeTemplateDetail(detail.templateVO)
        this.workorderPreview = Object.assign({}, normalized, {
          subject: detail.subject || item.subject || "",
          customerName: detail.customerName || item.customerName || "",
          equipmentName: detail.equipmentName || item.equipmentName || "",
        })
        this.workorderPreviewValues = {}
        ;(normalized.tableRows || []).forEach(row => this.getWorkorderPreviewParts(row))
        this.workorderPreviewShow = true
        this.openMask()
      }).catch(() => {
        this.$message.warning("获取工单表单内容失败")
      })
    },

    closeWorkorderPreview() {
      this.workorderPreviewShow = false
      this.workorderPreview = {}
      this.workorderPreviewValues = {}
      this.closeMask()
    },

    printWorkorderPreview() {
      const area = document.getElementById("workorder-detail-form-print-area")
      if (!area) {
        this.$message.warning("未找到工单表单内容")
        return
      }

      /*
       * 打印方案：
       * 1. 不打开新标签页，始终使用当前窗口 window.print()
       * 2. 不直接打印 v-show 控制的原预览 DOM，避免浏览器打印时把
       *    display:none / 弹窗定位 / overflow 等状态带入打印结果导致空白。
       * 3. 将当前“预览内容”原样 clone 到 body 下的独立打印容器。
       *    clone 保留原有 class、data-v 属性和 Element UI 已渲染出来的状态，
       *    因此打印内容与当前预览保持一致。
       * 4. 打印完成（包括取消打印）后删除临时容器，不影响原页面。
       */
      const oldContainer = document.getElementById("workorder-print-container")
      if (oldContainer) {
        oldContainer.parentNode.removeChild(oldContainer)
      }

      const printContainer = document.createElement("div")
      printContainer.id = "workorder-print-container"
      printContainer.className = "workorder-print-container"

      // 保留 #workorder 上下文，使原有 #workorder 下的样式继续生效。
      const printRoot = document.createElement("div")
      printRoot.id = "workorder"
      printRoot.className = "workorder-page workorder-print-root"

      const printArea = area.cloneNode(true)
      printArea.id = "workorder-preview-print-area-print-copy"
      printArea.classList.add("workorder-preview-print-copy")

      // 打印副本只保留预览内容，不带预览弹窗标题和底部操作按钮。
      printRoot.appendChild(printArea)
      printContainer.appendChild(printRoot)
      document.body.appendChild(printContainer)

      const body = document.body
      const printClass = "workorder-printing"
      let cleaned = false

      const cleanup = () => {
        if (cleaned) return
        cleaned = true

        body.classList.remove(printClass)
        window.removeEventListener("afterprint", cleanup)

        const container = document.getElementById("workorder-print-container")
        if (container && container.parentNode) {
          container.parentNode.removeChild(container)
        }
      }

      body.classList.add(printClass)
      window.addEventListener("afterprint", cleanup)

      // 等浏览器完成 clone 的布局计算后再进入打印流程。
      this.$nextTick(() => {
        setTimeout(() => {
          // 某些浏览器在打印对话框打开瞬间还未完成 clone 的重排，
          // 再读取一次布局可确保打印内容已经真正参与页面布局。
          void printContainer.offsetHeight
          window.print()
        }, 80)
      })
    },

    initPreviewSelections(rows) {
      const selections = {}
        ; (rows || []).forEach(row => {
          this.parseTemplateResult(row.result).forEach(part => {
            if (part.type === 'checkbox') {
              selections[part.key] = []
            } else if (part.type === 'radio') {
              selections[part.key] = ''
            }
          })
        })
      this.previewSelections = selections
    },

    openTemplatePreview(item) {
      const source = item || this.templateForm
      const normalized = source.formTitle !== undefined || source.longTextJson !== undefined
        ? this.normalizeTemplateDetail(source)
        : source
      const tableRows = (normalized.tableRows || []).map(row => Object.assign({}, row))
      this.previewTemplate = {
        id: normalized.id,
        name: normalized.name,
        title: normalized.title,
        shortFields: (normalized.shortFields || []).map(field => Object.assign({}, field)),
        tableRows: tableRows,
        imageTitle: normalized.imageTitle || "",
        imageUrl: normalized.imageUrl || "",
        longFields: (normalized.longFields || []).map(field => Object.assign({}, field)),
        customerSignatureUrl: normalized.customerSignatureUrl || "",
        engineerSignatureUrl: normalized.engineerSignatureUrl || "",
      }
      this.initPreviewSelections(tableRows)
      this.templatePreviewShow = true
      this.openMask()
    },

    closeTemplatePreview() {
      this.templatePreviewShow = false
      this.previewTemplate = {}
      this.previewSelections = {}
      if(!this.templateDialogShow){
        this.closeMask()
      }

    },

    openDeleteDialog(item, index) {
      if(!this.functionList.includes('workorderEdit')||this.$store.state.isLook) return
      this.deleteType = "template"
      this.deleteTarget = item
      this.deleteIndex = index
      this.deleteDialogShow = true
      this.openMask()
    },

    /* ==========================================================
     * 删除
     * ========================================================== */
    closeDeleteDialog() {
      this.deleteDialogShow = false
      this.deleteType = ""
      this.deleteTarget = {}
      this.deleteIndex = null
      this.closeMask()
    },

    doDelete() {
      if (this.deleteType === "template" && this.deleteIndex !== null) {
        const id = this.deleteTarget && this.deleteTarget.id
        if (!id) {
          this.$message.warning("模板ID不存在，无法删除")
          return
        }

        this.postNoJson("/template/removeTemplate", {
          id: id,
        }).then(res => {
          if (res.success) {
            this.$message.success("模板删除成功")
            this.closeDeleteDialog()
            this.filterTemplates()
          } else {
            this.$message({
              message: `删除模板失败：${res.message || "请求失败"}`,
              type: "warning"
            })
          }
        }).catch(() => {
          this.$message({
            message: "删除模板失败",
            type: "warning"
          })
        })
        return
      }

      if (this.deleteType === "customer" && this.deleteIndex !== null) {
        const id = this.deleteTarget && this.deleteTarget.id
        if (!id) {
          this.$message.warning("客户ID不存在，无法删除")
          return
        }
        this.postNoJson("/customer/removeCustomer", { id: id }).then(res => {
          if (res.success) {
            this.$message.success("客户删除成功")
            this.closeDeleteDialog()
            this.filterCustomers()
            this.getWorkorderCustomerList(true)
          } else {
            this.$message({
              message: "删除客户失败：" + (res.message || "请求失败"),
              type: "warning"
            })
          }
        }).catch(() => {
          this.$message.warning("删除客户失败")
        })
        return
      }

      if (this.deleteType === "workorder" && this.deleteIndex !== null) {
        const id = this.deleteTarget && this.deleteTarget.id
        if (!id) {
          this.$message.warning("工单ID不存在，无法删除")
          return
        }
        this.postNoJson("/workorder/removeWorkorder", {
          requestId: "",
          id: id,
        }).then(res => {
          if (res && res.success) {
            this.$message.success("工单删除成功")
            this.closeDeleteDialog()
            this.getWorkorders()
          } else {
            this.$message.warning("删除工单失败：" + ((res && res.message) || "请求失败"))
          }
        }).catch(() => this.$message.warning("删除工单失败"))
        return
      }

      this.$message.success("删除成功")
      this.closeDeleteDialog()
    },
  },
}
</script>

<style scoped>
#workorder {
  position: relative;
  height: 100%;
  min-height: 620px;
  color: #2f3a4e;
  font-size: 14px;
  text-align: left;
  padding-left: 16px;
  box-sizing: border-box;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.tabs-box {
  float: left;
  text-align: center;
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  border: 1px solid #d2d2d2;
}

.tabs-box div {
  float: left;
  padding: 9px 0;
}

.tabs-box span {
  display: inline-block;
  width: 110px;
  font-size: 14px;
  line-height: 22px;
  border-left: 1px solid #e2e2e2;
  cursor: pointer;
  float: left;
}

.tabs-box>div:first-child span {
  border: none;
}

.tabs-box .active {
  background: #5087e4;
  color: #fff;
}

.tabs-box .active>span {
  border: 0;
}

.workorder-body {
  position: absolute;
  left: 16px;
  right: 16px;
  top: 42px;
  bottom: 16px;
  background: #fff;
}

.toolbar {
  position: relative;
  height: 74px;
  padding: 26px 0 0 26px;
  box-sizing: border-box;
}

.add-btn {
  float: left;
  line-height: 34px !important;
  padding: 0 15px !important;
}

.search-box {
  float: right;
  display: flex;
  align-items: center;
  gap: 8px;
  padding-right: 20px;
  color: #636363;
}

.search-box .el-select {
  width: 100px;
}

.search-box .keyword-input {
  width: 178px;
  margin-left: 12px;
}

.simple-search {
  float: right;
  display: flex;
  align-items: center;
  padding-right: 20px;
}

.simple-search .keyword-input {
  width: 178px;
  margin-right: 8px;
}

.company-list {
  overflow: hidden;
  margin-bottom: 16px;
  height: calc(100% - 150px);
}

.scroll {
  overflow: auto;
  width: 97.6%;
  max-height: 92% !important;
  height: 92%;
  margin: 0 16px;
  box-sizing: border-box;
  border: 1px solid #f2f2f2;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
}

.list-title,
.list-details {
  display: flex;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  list-style: none;
  line-height: 44px;
  font-size: 14px;
  color: #636363;
}

.list-title {
  margin: 0 16px;
  width: 97.6%;
  background: #eeeeee;
}

.list-title li,
.list-details li {
  margin: 0 12px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.list-details {
  border-top: 1px solid #f2f2f2;
}

.list-details:last-child {
  border-bottom: 1px solid #f2f2f2;
}

.list-details a,
.operate span,
.add-row-link,
.operate-link {
  color: #5087e4;
  cursor: pointer;
}

.operate span {
  margin: 0 4px;
}
.operate span.disabled{
  color: #a0cfff !important;
  cursor: not-allowed !important;
}

.nullDataBox {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #999;
}

.nullDataBox span {
  position: initial;
}

.nullData {
  width: 83px;
}

.col-code {
  width: 12% !important;
}

.col-name {
  width: 14% !important;
}

.col-time {
  width: 16% !important;
}

.col-remark {
  width: 28% !important;
}

.col-operate {
  min-width: 120px;
  text-align: center !important;
}

.workorder-list-title li,
.workorder-row li {
  flex-shrink: 0;
}

.wo-code {
  width: 7%;
}

.wo-customer {
  width: 10%;
}

.wo-type {
  width: 7%;
}

.wo-subject {
  width: 11%;
}

.wo-status {
  width: 8%;
}

.wo-duration {
  width: 11%;
}

.wo-user {
  width: 7%;
}

.wo-operate {
  width: 18%;
  min-width: 180px;
  text-align: left !important;
}

.status-pendingApproval,
.status-0 {
  color: #ffce00;
}


.status-executing,
.status-2,
.status-completed,
.status-4 {
  color: #00cc33;
}

.status-suspended,
.status-3 {
  color: #ff0000;
}

.customer-list-title li,
.customer-row li {
  width: 10%;
  flex-shrink: 0;
}

.customer-list-title li:nth-child(1),
.customer-row li:nth-child(1) {
  width: 7%;
}

.customer-list-title li:nth-child(2),
.customer-row li:nth-child(2) {
  width: 10%;
}

.customer-list-title li:nth-child(3),
.customer-row li:nth-child(3) {
  width: 10%;
}

.customer-list-title li:nth-child(4),
.customer-row li:nth-child(4) {
  width: 8%;
}

.customer-list-title li:nth-child(5),
.customer-row li:nth-child(5) {
  width: 8%;
}

.customer-list-title li:nth-child(6),
.customer-row li:nth-child(6) {
  width: 10%;
}

.customer-list-title li:nth-child(7),
.customer-row li:nth-child(7) {
  width: 10%;
}

.customer-operate {
  width: 16% !important;
  min-width: 150px;
  text-align: center !important;
}

.service-expired {
  color: #f5222d;
}

.popup>div {
  position: fixed;
  left: 50%;
  top: 50%;
  z-index: 999;
  padding: 0 28px 30px;
  box-sizing: border-box;
  background: #fff;
  transform: translate(-50%, -50%);
  box-shadow: 0 2px 12px rgba(0, 0, 0, .18);
}

.popup-title {
  height: 64px;
  line-height: 64px;
  margin-bottom: 18px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
}

i.close {
  float: right;
  margin-top: 22px;
  font-size: 20px;
  cursor: pointer;
}

.popup-workorder {
  width: 886px !important;
  height: 724px;
  padding: 20px 28px 35px !important;
}

.popup-customer {
  width: 886px !important;
  min-height: 650px;
  padding: 20px 28px 35px !important;
}

.popup-device,
.popup-maintenance {
  width: 600px !important;
  padding: 20px 28px 35px !important;
}

.popup-detail,
.popup-device-detail,
.popup-assign,
.popup-form,
.popup-print,
.popup-template-builder {
  width: 920px !important;
  height: 82vh !important;
  margin-top: -50px;
  max-height: 88vh;
  overflow: hidden;
  padding: 20px 28px 35px !important;
}

.popup-large {
  min-height: 650px;
}

.popup-assign {
  width: 780px !important;
}

.popup-form {
  width: 960px !important;
}

.popup-print {
  width: 920px !important;
}

.template-preview-dialog {
  width: 920px !important;
}

.popup-delete {
  width: 520px !important;
}

.popup-lab {
  min-height: 76px;
  line-height: 30px;
  font-size: 14px;
}

.workorder-form,
.customer-form {
  overflow: hidden;
}

.form-column {
  float: left;
  width: 370px;
}

.right-column {
  margin-left: 52px;
}

.customer-column {
  width: 390px;
}

.execute-item {
  position: relative;
}

.execute-tip {
  position: absolute;
  left: 70px;
  top: 10px;
  color: #606266;
  cursor: pointer;
  z-index: 2;
}

.media-help {
  color: #999;
  line-height: 20px;
  margin-bottom: 8px;
  font-size: 12px;
}

.media-list {
  overflow: hidden;
  padding-top: 3px;
}

.media-thumb {
  position: relative;
  float: left;
  width: 72px;
  height: 72px;
  margin: 0 12px 16px 0;
  border: 4px solid #c9c9c9;
  box-sizing: border-box;
  background: #f7f7f7;
  overflow: visible;
}

.media-thumb img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.media-thumb .el-icon-video-camera {
  position: absolute;
  left: 18px;
  top: 18px;
  font-size: 28px;
  color: #159bd5;
}

.media-remove {
  position: absolute;
  right: -8px;
  top: -8px;
  width: 16px;
  height: 16px;
  line-height: 15px;
  text-align: center;
  border-radius: 50%;
  background: #df1f2d;
  color: #fff;
  cursor: pointer;
  z-index: 2;
}

.add-media {
  display: inline-block;
  color: #5087e4;
  cursor: pointer;
}

.inline-upload {
  display: inline-block;
}

.popup-btn-box {
  margin: 28px 0 0;
  text-align: center;
}

.popup-workorder .popup-btn-box,
.popup-customer .popup-btn-box,
.popup-detail .popup-btn-box,
.popup-device-detail .popup-btn-box,
.popup-form .popup-btn-box,
.popup-template-builder .popup-btn-box {
  position: absolute;
  left: 0;
  bottom: 34px;
  width: 100%;
}

.popup-btn-box .el-button {
  min-width: 96px;
  margin: 0 8px;
  padding: 0 24px !important;
  line-height: 34px !important;
}

.detail-tabs {
  height: 42px;
  border-bottom: 1px solid #e5e5e5;
  margin-bottom: 20px;
}

.detail-tabs span {
  display: inline-block;
  height: 42px;
  line-height: 42px;
  padding: 0 28px;
  cursor: pointer;
}

.detail-tabs span.active {
  color: #fff;
  background: #5087e4;
}

.detail-content {
  min-height: 480px;
  overflow: auto;
}
.detail-box{
  height: calc( 100% - 150px);
  overflow: auto;
}

.detail-grid,
.device-info-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  row-gap: 22px;
  column-gap: 40px;
  padding: 8px 12px;
}

.detail-grid>div,
.device-info-grid>div {
  display: flex;
  line-height: 22px;
}

.detail-grid label,
.device-info-grid label {
  width: 110px;
  color: #777;
  flex-shrink: 0;
}

.detail-grid span,
.device-info-grid span {
  color: #333;
}

.device-spec-detail {
  display: block !important;
}

.device-spec-title {
  display: block;
  width: auto !important;
  margin-bottom: 8px;
  color: #777;
}

.device-spec-table {
  width: 90%;
  border: 1px solid #999;
  box-sizing: border-box;
}

.device-spec-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  min-height: 32px;
  border-top: 1px solid #999;
  box-sizing: border-box;
}

.device-spec-row:first-child {
  border-top: 0;
}

.device-spec-name,
.device-spec-value {
  display: flex;
  align-items: center;
  min-height: 32px;
  padding: 4px 8px;
  box-sizing: border-box;
  color: #333;
  font-size: 12px;
  line-height: 18px;
  word-break: break-all;
}


.device-spec-value {
  justify-content: flex-end;
}

.device-spec-empty {
  color: #999;
  line-height: 32px;
  padding-left: 8px;
  border: 1px solid #999;
  box-sizing: border-box;
}

.detail-section-title {
  margin: 20px 0 12px;
  font-size: 14px;
  color: #333;
  font-weight: bold;
}

.detail-media-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 18px;
}

.detail-media-item {
  width: 150px;
  height: 115px;
  border: 2px solid #c9c9c9;
  background: #f6f6f6;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
}

.detail-media-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.detail-media-item i {
  font-size: 40px;
  color: #159bd5;
}

.sub-toolbar {
  margin-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.sub-search {
  width: 220px;
  margin-left: auto;
}

.inner-table {
  border: 1px solid #eee;
}

.inner-table-head,
.inner-table-row {
  display: grid;
  grid-template-columns: 1fr 1.3fr 1.4fr 1fr 1.1fr 1.1fr 1.8fr;
  margin: 0;
  padding: 0;
  list-style: none;
  min-height: 42px;
  align-items: center;
}

.inner-table-head {
  background: #eee;
}

.w-120{
  width: 140px;
}

.inner-table-row {
  border-top: 1px solid #eee;
}

.inner-table-head li,
.inner-table-row li {
  padding: 0 10px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.inner-table-row li a{
  color: #5087e4;
}

.inner-empty {
  padding: 20px 0 40px;
  text-align: center;
  color: #999;
}

.device-form-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  column-gap: 20px;
}

.device-form-grid .el-date-editor,
.device-form-grid .el-select {
  width: 100%;
}

.device-detail-body {
  height: auto;
  overflow: auto;
}

.assign-toolbar {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  margin-bottom: 12px;
}

.assign-toolbar .el-select {
  width: 100px;
}

.assign-panel {
  height: 570px;
  display: flex;
  border: 1px solid #ddd;
}

.assign-left {
  width: 52%;
  padding: 8px;
  box-sizing: border-box;
  border-right: 1px solid #ddd;
}

.assign-right {
  flex: 1;
  overflow: auto;
}

.user-tree {
  height: 515px;
  margin-top: 8px;
  overflow: auto;
}

.group-name,
.user-item {
  line-height: 34px;
  border-bottom: 1px dotted #eee;
}

.user-item {
  padding-left: 28px;
}

.group-name i,
.user-item i {
  margin-right: 5px;
  color: #777;
}

.assign-right-title {
  height: 34px;
  line-height: 34px;
  padding-left: 12px;
  background: #eee;
}

.selected-user {
  display: flex;
  align-items: center;
  gap: 8px;
  height: 36px;
  padding: 0 12px;
  border-bottom: 1px solid #eee;
}

.selected-user .el-icon-delete {
  margin-left: auto;
  cursor: pointer;
  color: #999;
}

.assign-empty {
  text-align: center;
  padding-top: 80px;
  color: #999;
}

.form-meta {
  display: flex;
  gap: 30px;
  padding: 10px 0 18px;
  border-bottom: 1px solid #eee;
}

.dynamic-form {
  height: 475px;
  overflow: auto;
  padding: 10px;
}

.dynamic-field {
  display: flex;
  align-items: flex-start;
  min-height: 54px;
  padding: 0 0 10px;
}

.dynamic-field>label {
  width: 130px;
  line-height: 34px;
  color: #666;
  flex-shrink: 0;
}

.dynamic-field>.el-input,
.dynamic-field>.el-date-editor,
.dynamic-field>.el-radio-group,
.dynamic-field>.el-checkbox-group {
  flex: 1;
}

.required-star {
  color: #f56c6c;
}

.field-image-box {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.field-image-item {
  position: relative;
  width: 70px;
  height: 54px;
}

.field-image-item img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.field-image-item i {
  position: absolute;
  right: 2px;
  top: 2px;
  color: #fff;
  background: rgba(0, 0, 0, .5);
  cursor: pointer;
}

.field-upload {
  width: 70px;
  height: 54px;
  line-height: 54px;
  text-align: center;
  border: 1px dashed #c9c9c9;
  color: #5087e4;
}


.inspection-static-cell {
  min-height: 34px;
  line-height: 22px;
  white-space: pre-wrap;
  word-break: break-word;
}

.template-form-preview-dialog {
  width: 900px !important;
}

.template-preview-image-box {
  min-height: 54px;
}

.template-preview-empty {
  width: 100%;
  height: 54px;
  line-height: 54px;
  text-align: center;
  border: 1px dashed #c9c9c9;
  color: #999;
}

.workorder-detail-form-section {
  margin-top: 18px;
}

.workorder-detail-form-print-area {
  background: #fff;
}

.inspection-table,
.template-table,
.print-table {
  width: 100%;
  border-collapse: collapse;
}

.inspection-table th,
.inspection-table td,
.template-table th,
.template-table td,
.print-table th,
.print-table td {
  border: 1px solid #999;
  padding: 6px 8px;
}
.inspection-table th,.print-table th{
  min-width: 80px;
}
.inspection-table th,
.template-table th {
  background: #f6f6f6;
  text-align: center;
}

.link-danger {
  color: #5087e4;
  cursor: pointer;
}

.add-row-link {
  display: inline-block;
  margin-top: 10px;
}

.signature-table {
  margin-top: 20px;
  display: flex;
  width: 100%;
  border: 1px solid #999;
}

.signature-table>div {
  flex: 1;
  height: 70px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  border-right: 1px solid #999;
}

.signature-table>div:last-child {
  border-right: none;
}

.signature-link {
  color: #5087e4;
  cursor: pointer;
  text-decoration: none;
}

.signature-preview {
  width: 110px;
  height: 52px;
  object-fit: contain;
  border: 1px solid #eee;
  background: #fff;
}

.popup-signature {
  width: 700px !important;
}

.signature-canvas-wrap {
  position: relative;
  width: 620px;
  height: 360px;
  margin: 20px auto 10px;
  border: 1px solid #cfcfcf;
  background: #fff;
  box-sizing: content-box;
}

.signature-canvas {
  display: block;
  width: 620px;
  height: 360px;
  background: #fff;
  cursor: crosshair;
  touch-action: none;
}

.signature-hint {
  position: absolute;
  left: 0;
  right: 0;
  top: 155px;
  text-align: center;
  color: #c0c4cc;
  pointer-events: none;
  font-size: 14px;
}

.signature-table a {
  color: #5087e4;
}

.print-toolbar {
  padding: 0 0 10px;
  text-align: right;
}

.print-area {
  border: 1px solid #ddd;
  padding: 28px 35px;
  box-sizing: border-box;
  color: #333;
  background: #fff;
}

.print-area h2 {
  text-align: center;
  margin: 0 0 20px;
}

.print-base-info {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 12px;
  margin-bottom: 20px;
}

.print-fields {
  margin-top: 18px;
}

.print-fields>div {
  display: flex;
  padding: 7px 0;
}

.print-fields label {
  width: 130px;
  color: #666;
}

.print-signature {
  display: flex;
  justify-content: space-between;
  margin-top: 35px;
}

.template-basic-row {
  display: flex;
  gap: 45px;
}

.template-basic-row .el-form-item {
  flex: 1;
}

.template-scroll {
  height: 530px;
  overflow: auto;
  padding: 0 10px;
}

.template-control-title {
  margin: 18px 0 10px;
  color: #666;
}

.template-short-fields .short-field {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.short-field .el-input {
  width: 220px;
}

.short-field .el-input+.el-input {
  width: 180px;
}

.image-title-row,
.multi-title-row {
  display: flex;
  align-items: center;
  gap: 10px;
}

.image-title-row .el-input {
  width: 180px;
}

.multi-title-row .el-input {
  width: 150px;
}

.template-textarea {
  margin-top: 10px;
}

.template-signature {
  margin-bottom: 20px;
}

.template-preview-meta {
  padding-bottom: 15px;
}

.preview-field {
  display: flex;
  padding: 8px 0;
}

.preview-field label {
  min-width: 100px;
  text-align: right;
  color: #666;
}

.preview-image-title {
  margin: 20px 0 8px;
  font-weight: bold;
}

.preview-multiline {
  margin-top: 20px;
}

.preview-text-box {
  margin-top: 8px;
  padding: 8px;
  background: #fff;
  border: 1px solid #bbb;
  overflow: auto;
}
</style>

<style>
#workorder .el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
}

#workorder .el-form-item__label {
  color: #2f3a4e !important;
}

#workorder .popup-workorder .el-form-item {
  width: 100% !important;
  margin-bottom: 16px !important;
}

#workorder .popup-workorder .el-form-item__label {
  width: 100% !important;
  padding: 0 !important;
  text-align: left !important;
  line-height: 14px !important;
  margin-bottom: 8px;
}

#workorder .popup-workorder .el-form-item__content {
  margin-left: 0 !important;
  line-height: 34px !important;
}

#workorder .popup-workorder .el-input__inner,
#workorder .popup-workorder .el-autocomplete {
  width: 370px !important;
}

#workorder .popup-workorder .el-select,
#workorder .popup-workorder .el-date-editor {
  width: 370px !important;
}

#workorder .popup-workorder .el-radio-group {
  width: 100%;
}

#workorder .popup-workorder .el-radio {
  margin-right: 28px;
}

#workorder .workorder-remark textarea {
  width: 370px !important;
  height: 76px !important;
  border: 1px solid #dedede !important;
  resize: none !important;
  padding: 5px !important;
  box-sizing: border-box;
  line-height: 20px !important;
  overflow: hidden;
}

#workorder .el-textarea__inner {
  resize: none;
}

#workorder .popup-customer .el-input__inner,
#workorder .popup-customer .el-select,
#workorder .popup-customer .el-date-editor {
  width: 100% !important;
}

#workorder .popup-customer .el-form-item {
  margin-bottom: 14px;
}

#workorder .popup-device .el-input__inner,
#workorder .popup-device .el-select,
#workorder .popup-device .el-date-editor,
#workorder .popup-maintenance .el-input__inner,
#workorder .popup-maintenance .el-select,
#workorder .popup-maintenance .el-date-editor {
  width: 100% !important;
}

#workorder .popup-detail .el-button,
#workorder .popup-form .el-button,
#workorder .popup-template-builder .el-button {
  line-height: 34px !important;
}

#workorder .popup-delete {
  z-index: 1002;
}

#workorder .el-upload {
  vertical-align: top;
}

/* ==========================================================
 * 新建客户弹窗：严格按原型调整为 2 列布局
 * ========================================================== */
#workorder .popup-customer {
  width: 886px !important;
  height: 830px !important;
  min-height: 0 !important;
  padding: 20px 28px 35px !important;
}

#workorder .popup-customer .popup-title {
  height: 44px;
  line-height: 44px;
  margin-bottom: 20px;
}

#workorder .popup-customer .popup-title .close {
  margin-top: 12px;
}

#workorder .customer-form-prototype {
  overflow: visible;
}

#workorder .customer-form-grid {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: space-between;
}

#workorder .customer-form-col {
  width: 286px;
  flex: 0 0 286px;
  box-sizing: border-box;
}

#workorder .customer-form-right {
  margin-left: 34px;
}

#workorder .customer-form-prototype .el-form-item {
  margin-bottom: 14px;
}

#workorder .customer-form-prototype .el-form-item__label {
  width: 72px !important;
  padding-right: 8px;
  line-height: 34px;
  color: #606266;
  font-size: 12px;
}

#workorder .customer-form-prototype .el-form-item__content {
  margin-left: 72px !important;
  line-height: 34px;
}

#workorder .customer-form-prototype .el-input,
#workorder .customer-form-prototype .el-select,
#workorder .customer-form-prototype .el-date-editor {
  width: 100% !important;
}

#workorder .customer-form-prototype .el-input__inner,
#workorder .customer-form-prototype .el-date-editor .el-input__inner {
  height: 34px;
  line-height: 34px;
  font-size: 12px;
}

#workorder .customer-form-prototype .customer-introduction-item .el-form-item__label {
  line-height: 20px;
  padding-top: 7px;
}

#workorder .customer-form-prototype .customer-introduction-item .el-form-item__content {
  line-height: 20px;
}

#workorder .customer-form-prototype .customer-introduction-item .el-textarea__inner {
  height: 76px !important;
  min-height: 76px !important;
  padding: 8px 10px;
  font-size: 12px;
}

#workorder .customer-form-prototype .customer-introduction-item .el-input__count {
  font-size: 10px;
  bottom: 2px;
  right: 8px;
}

#workorder .customer-media-item {
  margin-top: 2px;
}

#workorder .customer-media-item .el-form-item__label {
  line-height: 20px;
  padding-top: 3px;
}

#workorder .customer-media-item .el-form-item__content {
  line-height: 20px;
}

#workorder .customer-media-prototype {
  min-height: 92px;
  padding-top: 0;
}

#workorder .customer-media-prototype .media-thumb {
  width: 68px;
  height: 68px;
  margin: 0 8px 10px 0;
  border-width: 3px;
}

#workorder .customer-media-prototype .media-thumb .el-icon-video-camera {
  left: 17px;
  top: 17px;
}

#workorder .customer-media-help {
  position: absolute;
  left: 0;
  top: 82px;
  width: 270px;
  margin: 0;
  line-height: 18px;
  font-size: 12px;
  color: #999;
}

#workorder .customer-media-item .el-form-item__content {
  position: relative;
  min-height: 118px;
}

#workorder .customer-media-item .add-media {
  display: inline-block;
  margin: 2px 0 0 2px;
  color: #5087e4;
  font-size: 12px;
}

#workorder .customer-popup-btn-box {
  bottom: 24px !important;
  margin: 0 !important;
}

#workorder .customer-popup-btn-box .el-button {
  min-width: 54px;
  height: 34px;
  line-height: 32px !important;
  padding: 0 22px !important;
  font-size: 12px;
}
</style>

<!-- 客户弹窗最终样式：与“编辑工单”弹窗保持同一套表单布局规范 -->
<style>
/* ==========================================================
 * 新建 / 编辑客户
 * 参照编辑工单弹窗：标题、双列宽度、标签位置、输入框高度、按钮位置统一
 * ========================================================== */
#workorder .popup-customer {
  width: 886px !important;
  height: 824px !important;
  min-height: 0 !important;
  padding: 20px 28px 35px !important;
  box-sizing: border-box;
}
#workorder .el-form-item  .el-date-editor .el-input__inner{
  padding-left: 34px !important;
}

#workorder .popup-customer .popup-title {
  height: 44px;
  line-height: 44px;
  margin-bottom: 18px;
  font-size: 16px;
}

#workorder .popup-customer .popup-title .close {
  margin-top: 12px;
}

/* 与编辑工单一致：左右 370px，中间 52px */
#workorder .popup-customer .customer-form-grid {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 52px;
  box-sizing: border-box;
}

#workorder .popup-customer .customer-form-col {
  float: none;
  width: 370px !important;
  flex: 0 0 370px;
  box-sizing: border-box;
}

#workorder .popup-customer .customer-form-right {
  margin-left: 0 !important;
}

/* 与编辑工单一致：标签在输入框上方，而不是左侧 */
#workorder .popup-customer .customer-form-prototype .el-form-item {
  width: 100% !important;
  margin-bottom: 16px !important;
  box-sizing: border-box;
}

#workorder .popup-customer .customer-form-prototype .el-form-item__label {
  display: block;
  width: 100% !important;
  height: 14px;
  line-height: 14px !important;
  padding: 0 !important;
  margin: 0 0 8px;
  text-align: left !important;
  color: #2f3a4e !important;
  font-size: 14px;
  box-sizing: border-box;
}

#workorder .popup-customer .customer-form-prototype .el-form-item__content {
  width: 100%;
  margin-left: 0 !important;
  line-height: 34px !important;
  box-sizing: border-box;
}

/* 输入框 / 下拉 / 日期控件与编辑工单完全同宽 */
#workorder .popup-customer .customer-form-prototype .el-input,
#workorder .popup-customer .customer-form-prototype .el-autocomplete,
#workorder .popup-customer .customer-form-prototype .el-select,
#workorder .popup-customer .customer-form-prototype .el-date-editor {
  width: 370px !important;
}

#workorder .popup-customer .customer-form-prototype .el-input__inner,
#workorder .popup-customer .customer-form-prototype .el-date-editor .el-input__inner {
  width: 370px !important;
  height: 34px !important;
  line-height: 34px !important;
  font-size: 14px;
  box-sizing: border-box;
}

/* 必填项红色星号保持 Element UI 原有表现 */
#workorder .popup-customer .customer-form-prototype .is-required>.el-form-item__label:before {
  margin-right: 4px;
}

/* 客户简介：保持编辑工单“详细描述”的尺寸和风格 */
#workorder .popup-customer .customer-introduction-item .el-form-item__label {
  height: 14px;
  line-height: 14px !important;
  padding: 0 !important;
  margin-bottom: 8px;
}

#workorder .popup-customer .customer-introduction-item .el-form-item__content {
  line-height: 20px !important;
}

#workorder .popup-customer .customer-introduction-item .el-textarea__inner {
  width: 370px !important;
  height: 76px !important;
  min-height: 76px !important;
  padding: 8px 10px !important;
  border: 1px solid #dedede !important;
  resize: none !important;
  box-sizing: border-box;
  line-height: 20px !important;
  font-size: 14px;
  overflow: hidden;
}

#workorder .popup-customer .customer-introduction-item .el-input__count {
  right: 8px;
  bottom: 2px;
  font-size: 12px;
}

/* 图片 / 视频区域：标签也在上方，与编辑工单右侧“相关图片及视频”一致 */
#workorder .popup-customer .customer-media-item {
  margin-top: 0 !important;
  margin-bottom: 0 !important;
}

#workorder .popup-customer .customer-media-item .el-form-item__label {
  height: 14px;
  line-height: 14px !important;
  padding: 0 !important;
  margin-bottom: 8px;
}

#workorder .popup-customer .customer-media-item .el-form-item__content {
  position: relative;
  min-height: 125px;
  line-height: 20px !important;
}

#workorder .popup-customer .customer-media-list {
  width: 370px;
  min-height: 86px;
  padding-top: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 6px 0;
}

#workorder .popup-customer .customer-media-list .media-thumb {
  width: 72px;
  height: 72px;
  margin: 0 10px 12px 0;
  border: 2px solid #c9c9c9;
  box-sizing: border-box;
}

#workorder .popup-customer .customer-media-list .media-thumb .el-icon-video-camera {
  left: 18px;
  top: 18px;
  width: auto;
  font-size: 28px;
}

#workorder .popup-customer .customer-media-list .add-media {
  display: inline-block;
  margin: 3px 0 0 0;
  color: #5087e4;
  font-size: 14px;
  line-height: 20px;
  cursor: pointer;
}

#workorder .popup-customer .customer-media-help {
  position: static;
  width: auto;
  margin: 0;
  line-height: 20px;
  font-size: 12px;
  color: #999;
}

/* 图片提示放到图片区域下面，避免把“继续添加”挤到右边 */
#workorder .popup-customer .customer-media-item .customer-media-help {
  margin-top: 0;
}

/* 底部按钮：与编辑工单保持一致 */
#workorder .popup-customer .customer-popup-btn-box {
  position: absolute;
  left: 0;
  bottom: 24px !important;
  width: 100%;
  margin: 0 !important;
  text-align: center;
}

#workorder .popup-customer .customer-popup-btn-box .el-button {
  min-width: 96px;
  height: 34px;
  margin: 0 8px;
  padding: 0 24px !important;
  line-height: 34px !important;
  font-size: 14px;
}


/* ==========================================================
 * 新建 / 编辑设备弹窗：按原型与编辑工单统一布局
 * ========================================================== */
#workorder .popup-device {
  width: 886px !important;
  height: 830px !important;
  min-height: 0 !important;
  padding: 20px 28px 35px !important;
  box-sizing: border-box;
}

#workorder .popup-device .popup-title {
  height: 44px;
  line-height: 44px;
  margin-bottom: 20px;
}

#workorder .popup-device .popup-title .close {
  margin-top: 12px;
}

#workorder .device-form-prototype {
  overflow: visible;
}

#workorder .device-form-prototype-grid {
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 52px;
}

#workorder .device-form-prototype .device-form-col {
  width: 370px;
  flex: 0 0 370px;
  box-sizing: border-box;
}

#workorder .device-form-prototype .el-form-item {
  width: 100%;
  margin-bottom: 14px;
  box-sizing: border-box;
}

#workorder .device-form-prototype .el-form-item__label {
  display: block;
  width: 100% !important;
  height: 14px;
  line-height: 14px !important;
  padding: 0 !important;
  margin: 0 0 8px;
  text-align: left;
  color: #2f3a4e;
  font-size: 12px;
}

#workorder .device-form-prototype .el-form-item__content {
  width: 100%;
  margin-left: 0 !important;
  line-height: 34px;
}

#workorder .device-form-prototype .el-input,
#workorder .device-form-prototype .el-select,
#workorder .device-form-prototype .el-date-editor {
  width: 100% !important;
}

#workorder .device-form-prototype .el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
  font-size: 12px;
  box-sizing: border-box;
}

#workorder .device-key-item .el-form-item__content {
  height: 34px;
  line-height: 34px;
}

#workorder .device-key-text {
  display: inline-block;
  height: 34px;
  line-height: 34px;
  padding-left: 10px;
  color: #606266;
  font-size: 12px;
}

#workorder .device-remark-item .el-textarea__inner {
  width: 370px !important;
  height: 76px !important;
  min-height: 76px !important;
  padding: 8px 10px !important;
  border: 1px solid #dedede !important;
  resize: none !important;
  box-sizing: border-box;
  line-height: 20px !important;
  font-size: 12px;
}

#workorder .device-remark-item .el-input__count {
  right: 8px;
  bottom: 2px;
  font-size: 10px;
}

#workorder .device-params-item .el-form-item__content {
  line-height: 34px;
}

#workorder .device-params-list {
  width: 370px;
  max-height: 618px;
  overflow: auto;
}

#workorder .device-param-row {
  display: flex;
  align-items: center;
  width: 100%;
  height: 34px;
  margin-bottom: 20px;
}

#workorder .device-param-row .el-input:first-child {
  width: 168px !important;
  margin-right: 10px;
}

#workorder .device-param-row .el-input:nth-child(2) {
  width: 168px !important;
  margin-right: 10px;
}

#workorder .device-param-row .device-param-delete {
  flex: 0 0 auto;
  color: #5087e4;
  font-size: 12px;
  line-height: 34px;
  cursor: pointer;
}

#workorder .add-device-param {
  display: inline-block;
  margin-top: 0;
  color: #5087e4;
  font-size: 12px;
  line-height: 20px;
  cursor: pointer;
}

#workorder .device-media-item {
  margin-top: 0;
  margin-bottom: 0 !important;
}

#workorder .device-media-item .el-form-item__content {
  position: relative;
  min-height: 125px;
  line-height: 20px;
}

#workorder .device-media-list {
  width: 370px;
  /* min-height: 86px; */
  padding-top: 0;
  overflow: hidden;
  box-sizing: border-box;
  padding: 6px 0;
}

#workorder .device-media-list .media-thumb {
  width: 72px;
  height: 72px;
  margin: 0 10px 12px 0;
  border: 2px solid #c9c9c9;
  box-sizing: border-box;
}

#workorder .device-media-list .media-thumb .el-icon-video-camera {
  left: 18px;
  top: 18px;
  font-size: 28px;
}

#workorder .device-media-list .add-media {
  display: inline-block;
  margin: 3px 0 0;
  color: #5087e4;
  font-size: 12px;
  line-height: 20px;
}

#workorder .device-media-help {
  position: static;
  width: auto;
  margin: 0;
  line-height: 20px;
  font-size: 12px;
  color: #999;
}

#workorder .popup-device .popup-btn-box {
  position: absolute;
  left: 0;
  bottom: 18px;
  width: 100%;
  margin: 0;
  text-align: center;
}

#workorder .popup-device .popup-btn-box .el-button {
  min-width: 54px;
  height: 34px;
  margin: 0 8px;
  padding: 0 22px !important;
  line-height: 32px !important;
  font-size: 12px;
}


/* 模板预览：短文本输入框显示为下划线，不显示“文本输入框”占位文字 */
.preview-short-input-line {
  display: inline-block;
  flex: 1;
  height: 27px;
  margin-left: 20px;
  /* border-bottom: 1px solid #555; */
  vertical-align: middle;
}

/* 模板预览：{{文本:N}} 按 N * 2 个下划线显示 */
.preview-result-underline {
  display: inline-block;
  min-width: 12px;
  color: #555;
  letter-spacing: 1px;
  white-space: pre;
  line-height: 1;
  vertical-align: baseline;
}

/* 模板预览：解析结果字段中的单选/复选控件 */
.preview-result-cell {
  vertical-align: middle;
  line-height: 32px;
}

.preview-option-group {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  vertical-align: middle;
  margin: 0 2px;
}

.preview-option-group .el-checkbox,
.preview-option-group .el-radio {
  margin-right: 18px;
  margin-bottom: 0;
  line-height: 32px;
}

.preview-option-group .el-checkbox__label,
.preview-option-group .el-radio__label {
  font-size: 13px;
  color: #333;
}

.form-table-result-cell {
  vertical-align: middle;
  line-height: 32px;
}

.form-result-option-group {
  display: inline-flex;
  flex-wrap: wrap;
}

.form-result-text-input {
  display: inline-block;
  vertical-align: middle;
  margin: 0 4px;
}

.workorder-preview-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 24px;
  padding: 8px 0 14px;
}

.preview-submitted-value {
  flex: 1;
  margin-left: 20px;
  word-break: break-all;
}

.preview-submitted-text {
  display: inline-block;
  min-width: 80px;
  margin: 0 4px;
  padding: 0 8px;
  border-bottom: 1px solid #555;
}

.preview-image-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin: 10px 0 16px;
}

.preview-image-item img {
  width: 180px;
  height: 130px;
  object-fit: contain;
  border: 1px solid #ddd;
}

.print-signature-preview {
  max-width: 220px;
  max-height: 100px;
  object-fit: contain;
  margin-left: 10px;
}

/* ==========================================================
 * 工单预览打印
 * 使用当前窗口打印，不打开新标签页。
 * 打印时使用预览区域的 DOM 副本，避免 v-show / 弹窗 fixed / overflow
 * 导致浏览器打印结果为空白。
 * ========================================================== */
@media print {
  html,
  body {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    min-width: 0 !important;
    background: #fff !important;
  }

  /*
   * 原页面全部隐藏，只显示临时打印容器。
   * 使用 visibility 而不是 display，避免父级布局变化影响打印副本。
   */
  body.workorder-printing > * {
    visibility: hidden !important;
  }

  body.workorder-printing #workorder-print-container {
    visibility: visible !important;
    display: block !important;
    position: static !important;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #fff !important;
  }

  body.workorder-printing #workorder-print-container,
  body.workorder-printing #workorder-print-container * {
    visibility: visible !important;
  }

  body.workorder-printing #workorder-print-container #workorder-print-root,
  body.workorder-printing #workorder-print-container #workorder {
    display: block !important;
    position: static !important;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    margin: 0 !important;
    padding: 0 !important;
    overflow: visible !important;
    background: #fff !important;
    transform: none !important;
    box-shadow: none !important;
  }

  body.workorder-printing #workorder-print-container #workorder-preview-print-area-print-copy {
    display: block !important;
    position: static !important;
    width: 100% !important;
    height: auto !important;
    min-height: 0 !important;
    max-height: none !important;
    margin: 0 !important;
    padding: 28px 35px !important;
    overflow: visible !important;
    box-sizing: border-box !important;
    border: 0 !important;
    background: #fff !important;
  }

  /* 打印副本中保留预览原本的标题、字段、表格、图片、长文本、签名布局。 */
  body.workorder-printing #workorder-print-container .print-table {
    width: 100% !important;
    border-collapse: collapse !important;
    page-break-inside: auto !important;
  }

  body.workorder-printing #workorder-print-container .print-table tr {
    page-break-inside: avoid !important;
    page-break-after: auto !important;
  }

  body.workorder-printing #workorder-print-container .preview-multiline,
  body.workorder-printing #workorder-print-container .signature-table,
  body.workorder-printing #workorder-print-container .preview-image-item {
    page-break-inside: avoid !important;
  }

  body.workorder-printing #workorder-print-container img {
    max-width: 100% !important;
  }

  /* 不打印任何按钮、弹窗标题等交互元素。 */
  body.workorder-printing #workorder-print-container .popup-title,
  body.workorder-printing #workorder-print-container .popup-btn-box,
  body.workorder-printing #workorder-print-container .el-button {
    display: none !important;
  }
}
</style>

<style>
/* ==========================================================
 * Workorder UI 样式统一
 * 参考 FormsList.vue 的列表、表单、弹窗、按钮视觉规范
 * 仅覆盖 CSS，不修改任何 template / script / 业务逻辑
 * ========================================================== */

/* ---------- 页面基础 ---------- */
#workorder.workorder-page {
  font-size: 14px;
  color: #2f3a4e;
}

#workorder .workorder-body {
  background: #fff;
}

/* ---------- 顶部 Tabs：与 FormsList.vue 对齐 ---------- */
#workorder>.tabs-box {
  height: 40px;
  overflow: hidden;
  background-color: #fff;
  border: 1px solid #d2d2d2;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

#workorder>.tabs-box div {
  padding: 9px 0;
}

#workorder>.tabs-box span {
  display: inline-block;
  width: 110px;
  height: 22px;
  line-height: 22px;
  font-size: 14px;
  border-left: 1px solid #e2e2e2;
}

#workorder>.tabs-box>div:first-child span {
  border-left: none;
}

#workorder>.tabs-box .active {
  background: #5087e4;
  color: #fff;
}

/* ---------- 顶部工具栏：参考 FormsList 的 list-top ---------- */
#workorder .toolbar {
  height: 74px;
  padding: 24px 16px 15px;
  box-sizing: border-box;
}

#workorder .add-btn {
  float: left;
  height: 34px;
  line-height: 32px !important;
  padding: 0 15px !important;
  border-radius: 4px;
}

#workorder .search-box,
#workorder .simple-search {
  height: 34px;
  padding-right: 0;
}

#workorder .search-box {
  gap: 10px;
}

#workorder .search-box .el-select {
  width: 120px;
}

#workorder .search-box .keyword-input,
#workorder .simple-search .keyword-input {
  width: 180px;
}

#workorder .search-box .keyword-input {
  margin-left: 0;
}

#workorder .simple-search .keyword-input {
  margin-right: 10px;
}

/* Element UI 输入框统一为 FormsList 的 34px */
#workorder .el-input__inner,
#workorder .el-select .el-input__inner,
#workorder .el-date-editor .el-input__inner {
  height: 34px !important;
  line-height: 34px !important;
  padding: 0 10px !important;
  box-sizing: border-box;
}

#workorder .el-input__icon {
  line-height: 34px !important;
}

#workorder .pagination {
  text-align: center;
}

#workorder .pagination .el-input .el-input__inner {
  height: 26px !important;
  line-height: 26px !important;
}

#workorder .pagination .el-input__icon {
  line-height: 26px !important;
}

/* ---------- 列表：完全采用 FormsList 的基础视觉 ---------- */
#workorder .company-list {
  overflow: hidden;
  margin-bottom: 32px;
  height: calc(100% - 150px);
}

#workorder .list-title,
#workorder .list-details {
  display: flex;
  justify-content: space-around;
  margin: 0;
  padding: 0;
  line-height: 44px;
  font-size: 14px;
  color: #636363;
  list-style: none;
  box-sizing: border-box;
}

#workorder .underline-input .el-input__inner {
  border: none;
  border-bottom: 1px solid #555;
  border-radius: 0;
}

#workorder .list-title {
  margin: 0 16px;
  width: 97.6%;
  background: #eeeeee;
}

#workorder .list-title li,
#workorder .list-details li {
  margin: 0 12px;
  text-align: left;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: border-box;
}

#workorder .list-details {
  min-height: 44px;
  border-top: 1px solid #f2f2f2;
}

#workorder .list-details:last-child {
  border-bottom: 1px solid #f2f2f2;
}

/* 工单列表列宽 */
#workorder .workorder-list-title li,
#workorder .workorder-row li {
  flex-shrink: 0;
}

#workorder .workorder-list-title .wo-code,
#workorder .workorder-row .wo-code {
  width: 6%;
}

#workorder .workorder-list-title .wo-customer,
#workorder .workorder-row .wo-customer {
  width: 10%;
}

#workorder .workorder-list-title .wo-type,
#workorder .workorder-row .wo-type {
  width: 6%;
}

#workorder .workorder-list-title .wo-subject,
#workorder .workorder-row .wo-subject {
  width: 10%;
}

#workorder .workorder-list-title .wo-status,
#workorder .workorder-row .wo-status {
  width: 6%;
}

#workorder .workorder-list-title .wo-duration,
#workorder .workorder-row .wo-duration {
  width: 10%;
}

#workorder .workorder-list-title .wo-user,
#workorder .workorder-row .wo-user {
  width: 6%;
}

#workorder .workorder-list-title .wo-operate,
#workorder .workorder-row .wo-operate {
  width: 18%;
  min-width: 180px;
  text-align: left !important;
}

#workorder .customer-list-title li,
#workorder .customer-row li {
  margin: 0 20px;
}

/* 操作文字与 FormsList.vue 对齐 */
#workorder .operate span,
#workorder .list-details a {
  margin: 0 4px;
  color: #5087e4;
  cursor: pointer;
}

#workorder .operate span:hover,
#workorder .list-details a:hover {
  color: #3d70c5;
}

/* 状态颜色保留原业务含义，仅统一视觉 */
#workorder .status-pendingApproval,
#workorder .status-0 {
  color: #ffce00;
}


#workorder .status-executing,
#workorder .status-2,
#workorder .status-completed,
#workorder .status-4 {
  color: #00cc33;
}

#workorder .status-suspended,
#workorder .status-3 {
  color: #ff0000;
}

/* 列表滚动区域 */
#workorder .scroll {
  overflow: auto;
  width: 97.6%;
  max-height: 88% !important;
  height: 88%;
  margin: 0 16px;
  border: 1px solid #f2f2f2;
  border-bottom-left-radius: 5px;
  border-bottom-right-radius: 5px;
  box-sizing: border-box;
}

/* 空数据 */
#workorder .nullDataBox {
  color: #999;
}

/* ---------- 弹窗公共样式：参考 FormsList.vue ---------- */
#workorder .popup>div {
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px rgba(0, 0, 0, .18);
}

#workorder .popup-title {
  height: 64px;
  line-height: 64px;
  margin-bottom: 12px;
  border-bottom: 1px solid #e5e5e5;
  font-size: 16px;
  color: #2f3a4e;
}

#workorder .popup-title .close {
  margin-top: 22px;
  font-size: 20px;
  cursor: pointer;
}

#workorder .popup-lab {
  font-size: 14px;
  line-height: 30px;
}

/* ---------- 弹窗表单：标签、输入框统一 ---------- */
#workorder .popup .el-form-item {
  box-sizing: border-box;
}

#workorder .popup .el-form-item__label {
  color: #2f3a4e !important;
}

#workorder .popup .el-form-item__content {
  box-sizing: border-box;
}

/* 新建/编辑工单 */
#workorder .popup-workorder {
  width: 886px !important;
  height: 724px !important;
  padding: 20px 28px 35px !important;
}

#workorder .popup-workorder .workorder-form {
  padding-bottom: 34px;
  padding-left: 14px;
  overflow: hidden;
}

#workorder .popup-workorder .form-column {
  width: 370px;
  float: left;
}

#workorder .popup-workorder .right-column {
  margin-left: 52px;
}

#workorder .popup-workorder .el-form-item {
  width: 100% !important;
  margin-bottom: 11px !important;
}

#workorder .popup-workorder .el-form-item__label {
  width: 100% !important;
  padding: 0 !important;
  margin-top: 10px;
  margin-bottom: 5px;
  line-height: 14px !important;
  text-align: left !important;
}

#workorder .popup-workorder .el-form-item__content {
  width: 100%;
  margin-left: 0 !important;
  line-height: 34px !important;
}

#workorder .popup-workorder .el-input,
#workorder .popup-workorder .el-autocomplete,
#workorder .popup-workorder .el-select,
#workorder .popup-workorder .el-date-editor {
  width: 370px !important;
}

#workorder .popup-workorder .el-input__inner {
  width: 370px !important;
}

#workorder .popup-workorder .el-radio-group {
  line-height: 34px;
}

#workorder .popup-workorder .el-radio {
  margin-right: 28px;
}

#workorder .popup-workorder .workorder-remark textarea,
#workorder .popup-workorder .el-textarea__inner {
  width: 370px !important;
  height: 95px !important;
  min-height: 95px !important;
  border: 1px solid #dedede !important;
  border-radius: 5px;
  padding: 5px 10px !important;
  resize: none !important;
  box-sizing: border-box;
  line-height: 20px !important;
}

/* 客户 / 设备 / 维保表单 */
#workorder .popup-customer .el-form-item,
#workorder .popup-device .el-form-item,
#workorder .popup-maintenance .el-form-item {
  margin-bottom: 11px !important;
}

#workorder .popup-customer .el-form-item__label,
#workorder .popup-device .el-form-item__label,
#workorder .popup-maintenance .el-form-item__label {
  padding: 0 !important;
  color: #2f3a4e !important;
}

#workorder .popup-customer .el-input__inner,
#workorder .popup-customer .el-select,
#workorder .popup-customer .el-date-editor,
#workorder .popup-device .el-input__inner,
#workorder .popup-device .el-select,
#workorder .popup-device .el-date-editor,
#workorder .popup-maintenance .el-input__inner,
#workorder .popup-maintenance .el-select,
#workorder .popup-maintenance .el-date-editor {
  height: 34px !important;
  line-height: 34px !important;
}

/* 详情 / 指派 / 表单 / 打印 / 模板等大弹窗 */
#workorder .popup-detail,
#workorder .popup-device-detail,
#workorder .popup-assign,
#workorder .popup-form,
#workorder .popup-print,
#workorder .popup-template-builder {
  padding: 20px 28px 35px !important;
}
#workorder img.tree-icon{
    width: 16px !important;
    position: relative;
    top: 3px;
    left: -2px;
}

#workorder .popup-detail .popup-title,
#workorder .popup-device-detail .popup-title,
#workorder .popup-assign .popup-title,
#workorder .popup-form .popup-title,
#workorder .popup-print .popup-title,
#workorder .popup-template-builder .popup-title {
  margin-bottom: 12px;
}

#workorder .popup-device-detail,#workorder .offset-dialog{
  top: 53%;
  left: 52%;

}

/* ---------- 弹窗底部按钮：与 FormsList.vue 统一 ---------- */
#workorder .popup-btn-box,
#workorder .btn-box {
  text-align: center;
}

#workorder .popup-btn-box .el-button,
#workorder .btn-box .el-button {
  min-width: 0;
  height: 34px;
  padding: 0 34px !important;
  line-height: 34px !important;
  margin: 0 20px;
  border-radius: 4px;
  box-sizing: border-box;
}

/* 弹窗中非底部区域的小按钮 */
#workorder .popup .el-button--small {
  height: 34px;
  line-height: 34px;
  padding: 0 15px;
}

/* ---------- 客户详情内部 Tab ---------- */
#workorder .detail-tabs {
  height: 42px;
  margin-bottom: 20px;
  border-bottom: 1px solid #e5e5e5;
}

#workorder .detail-tabs span {
  height: 42px;
  line-height: 42px;
  padding: 0 28px;
  font-size: 14px;
}

#workorder .detail-tabs span.active {
  background: #5087e4;
  color: #fff;
}

/* ---------- 内部表格：统一 FormsList 灰色表头 ---------- */
#workorder .inner-table {
  border: 1px solid #f2f2f2;
  border-radius: 5px;
  overflow: hidden;
}

#workorder .inner-table-head {
  min-height: 44px;
  line-height: 44px;
  background: #eeeeee;
  color: #636363;
  font-size: 14px;
}

#workorder .inner-table-row {
  min-height: 44px;
  line-height: 44px;
  border-bottom: 1px solid #f2f2f2;
  color: #636363;
  font-size: 14px;
}

#workorder .inner-table-head li,
#workorder .inner-table-row li {
  box-sizing: border-box;
}

/* ---------- 查询区域按钮统一 ---------- */
#workorder .toolbar .el-button,
#workorder .search-box>.el-button,
#workorder .simple-search>.el-button,
#workorder .sub-toolbar>.el-button {
  border-radius: 4px;
}

#workorder .search-box>.el-button,
#workorder .simple-search>.el-button {
  height: 34px;
  line-height: 32px !important;
  padding: 0 15px !important;
}

/* ---------- 上传区域 ---------- */
#workorder .add-media {
  color: #5087e4;
}

#workorder .media-help {
  color: #999;
  font-size: 12px;
}

/* ---------- 分页区域保持 FormsList 的留白节奏 ---------- */
#workorder .workorder-body>.pagination,
#workorder .workorder-body>.Pagination {
  margin-top: 0;
}

/* 防止弹窗中的 el-form 默认 margin 造成不同模块间距不一致 */
#workorder .popup .el-form-item:last-child {
  margin-bottom: 11px;
}

/* 模板管理：多行文本控件可重复添加 */
.template-long-fields {
  width: 100%;
}

.long-field {
  margin-bottom: 14px;
  padding: 12px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  background: #fafafa;
  box-sizing: border-box;
}

.long-field-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 10px;
  color: #606266;
  font-size: 13px;
}

.long-field-index {
  font-weight: 600;
}

.long-field-config {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.long-field-config label,
.template-url-row label {
  flex: 0 0 auto;
  color: #606266;
  font-size: 12px;
}

.long-field-config label {
  width: 38px;
}

.long-field-config .el-input {
  width: 250px;
}

.long-field-config .el-input-number {
  width: 120px;
}

.long-field .template-textarea {
  margin-top: 0;
}

.long-field .el-input-number.el-input-number--small .el-input{
  width:auto;
}

.template-url-row {
  display: flex;
  align-items: center;
  gap: 10px;
  margin: 8px 0;
}

.template-url-row label {
  width: 88px;
}

.template-url-row .el-input {
  flex: 1;
}

.template-signature-fields {
  margin-bottom: 12px;
}

.preview-image-url {
  margin: 4px 0 12px;
  color: #999;
  word-break: break-all;
  font-size: 12px;
}

.preview-multiline-title {
  margin-bottom: 8px;
  font-weight: bold;
}

.preview-text-box {
  min-height: 80px;
  height: auto;
  padding: 8px 10px;
  background: #f7f7f7;
  border: 1px solid #ddd;
  box-sizing: border-box;
  white-space: pre-wrap;
  word-break: break-word;
}

.preview-signature-image {
  max-width: 140px;
  max-height: 50px;
  object-fit: contain;
}


/* 工单表单选择弹窗：沿用现有弹窗及 userList 选择角色弹窗结构 */
#workorder .popup-form-select { width: 600px !important; height: 300px !important; padding: 20px 28px 35px !important; box-sizing: border-box; }
#workorder .form-select-content, #workorder .assign-user-content-box { height: 418px; border: 1px solid #d2d2d2; display: flex; margin-bottom: 34px;}
#workorder .form-select-column { width: 50%; height: 100%; border-right: 1px solid #d2d2d2; box-sizing: border-box; }
#workorder .form-select-column:last-child { border-right: 0; }
#workorder .form-select-column-title, #workorder .assign-user-column-title { text-align: center; line-height: 28px; height: 28px; margin: 0; color: #fff; font-size: 14px; background-color: #5087e4; }
#workorder .form-select-list { height: 390px; overflow: auto; padding: 8px 12px; box-sizing: border-box; }
#workorder .form-select-option { min-height: 36px; line-height: 36px; border-bottom: 1px solid #f2f2f2; color: #606060; font-size: 14px; }
#workorder .form-select-option .el-checkbox, #workorder .form-select-option .el-radio { width: 100%; margin-right: 0; }
#workorder .form-select-empty { padding: 30px 10px; text-align: center; color: #999; font-size: 14px; }

/* 工单指派弹窗：三列结构与 userList.vue 选择角色弹窗一致 */
#workorder .popup-assign { width: 893px !important; height: 620px !important; margin-top: -50px; padding: 20px 28px 35px !important; box-sizing: border-box; }
#workorder .assign-user-column { width: 33.3333%; height: 100%; border-right: 1px solid #d2d2d2; box-sizing: border-box; }
#workorder .assign-user-column:last-child { border-right: 0; }
#workorder .assign-user-tree-box { height: 390px; overflow: auto; }
#workorder .assign-user-tree-box .el-tree { height: 100%; }
#workorder .assign-tree-node { line-height: 28px; font-size: 14px; color: #606060; }
#workorder .assign-tree-node .el-icon-office-building { margin-right: 5px; color: #5087e4; }
#workorder .assign-user-search { padding: 8px 10px 4px; box-sizing: border-box; }
#workorder .assign-user-list, #workorder .assign-selected-list { height: 390px; overflow: auto; padding: 0 10px; box-sizing: border-box; }
#workorder .assign-user-option, #workorder .assign-selected-option { position: relative; min-height: 36px; line-height: 36px; padding: 0 28px 0 10px; border-bottom: 1px solid #f2f2f2; color: #606060; font-size: 14px; cursor: pointer; box-sizing: border-box; }
#workorder .assign-user-option:hover, #workorder .assign-selected-option:hover { background-color: #f5f5f5; }
#workorder .assign-user-option .el-icon-user, #workorder .assign-selected-option .el-icon-user { margin-right: 6px; }
#workorder .assign-user-added { position: absolute; right: 10px; color: #999; font-size: 12px; }
#workorder .assign-user-add-icon, #workorder .assign-user-del-icon { position: absolute; right: 10px; top: 10px; color: #5087e4; }
#workorder .assign-user-del-icon { color: #999; cursor: pointer; }
#workorder .assign-user-empty { padding: 30px 10px; text-align: center; color: #999; font-size: 14px; }


#workorder .tree .is-current>.el-tree-node__content{
    background-color: #dfdfdf !important;
}
/* 修改ele-ui 默认样式 */
#workorder .tree .el-tree-node__content .custom-tree-node{
    font-size: 14px !important;
    margin-left: 10px;
    position: relative;
    justify-content:stretch !important;
}
#workorder .tree .el-tree-node__children .custom-tree-node{
    font-size: 14px !important;
    padding-right: 10px;
}
#workorder .el-tree-node>.el-tree-node__children {
    overflow: unset !important;
}
#workorder .tree .el-tree > .el-tree-node:after {
    border-top: none;
}
#workorder .tree .el-tree-node {
    position: relative;
    padding-left: 16px;
}
#workorder .tree .el-tree-node__content {
    background: #fff;
}
/* //节点有间隙，隐藏掉展开按钮就好了,如果觉得空隙没事可以删掉 */
#workorder .tree .el-tree-node__expand-icon.is-leaf{
    display: none;
}
#workorder .tree .el-tree-node__children {
    padding-left: 16px;
}
#workorder .tree .el-tree-node :last-child:before {
    height: 18px;
}
#workorder .tree .el-tree > .el-tree-node:before {
    border-left: none;
}
#workorder .tree .el-tree > .el-tree-node:after {
    border-top: none;
}
#workorder .tree .el-tree-node:before {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
}
#workorder .tree .el-tree-node:after {
    content: "";
    left: -4px;
    position: absolute;
    right: auto;
    border-width: 1px;
}
#workorder .tree .el-tree-node:before {
    border-left: 1px dashed #dedede;
    bottom: 0px;
    height: 100%;
    top: -7px;
    width: 1px;
}
#workorder .tree .el-tree-node:after {
    border-top: 1px dashed #dedede;
    height: 20px;
    top: 12px;
    width: 24px;
}


/* ==================== 图片/视频上传进度与预览增强 ==================== */
#workorder .media-upload-item {
  cursor: default;
}

#workorder .field-image-upload-item {
  position: relative;
}

#workorder .media-progress-mask {
  position: absolute;
  left: 3px;
  right: 3px;
  bottom: 3px;
  z-index: 3;
  padding: 3px 4px;
  background: rgba(0, 0, 0, 0.62);
  border-radius: 2px;
}

#workorder .media-progress-mask .el-progress {
  width: 100%;
}

#workorder .media-upload-status {
  position: absolute;
  left: 2px;
  right: 2px;
  bottom: -19px;
  z-index: 4;
  font-size: 11px;
  line-height: 16px;
  text-align: center;
  color: #159bd5;
  background: rgba(255,255,255,.92);
  white-space: nowrap;
}

#workorder .detail-media-clickable,
#workorder .preview-media-clickable {
  position: relative;
  cursor: pointer;
}

#workorder .detail-media-item video,
#workorder .preview-image-item video {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

#workorder .detail-video-play {
  position: absolute;
  left: 50%;
  top: 50%;
  width: 42px;
  height: 42px;
  margin-left: -21px;
  margin-top: -21px;
  border-radius: 50%;
  background: rgba(0,0,0,.55);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  pointer-events: none;
}

#workorder .detail-video-play i {
  color: #fff;
  font-size: 24px;
}

#workorder .popup-media-preview {
  position: fixed;
  z-index: 3000;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  width: min(900px, 88vw);
  max-height: 90vh;
  background: #fff;
  box-shadow: 0 4px 24px rgba(0,0,0,.25);
}

#workorder .media-preview-content {
  height: calc(90vh - 112px);
  min-height: 360px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  box-sizing: border-box;
  background: #111;
  overflow: hidden;
}

#workorder .media-preview-image,
#workorder .media-preview-video {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

#workorder .media-preview-video {
  width: 100%;
  height: 100%;
}

#workorder .media-preview-unsupported {
  color: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}

#workorder .media-preview-unsupported i {
  font-size: 52px;
}

#workorder .preview-media-clickable {
  overflow: hidden;
  max-width: 182px;
  max-height: 132px;
  padding: 5px;
  box-sizing: border-box;
  border: 1px solid #ddd;
}


/* 相关图片及视频：标题独占一行，媒体列表及上传按钮放在标题下方 */
#workorder .media-upload-stacked .el-form-item__label {
  display: block;
  float: none;
  width: 100% !important;
  text-align: left;
  line-height: 24px;
  padding: 0 0 8px;
}
#workorder .media-upload-stacked .el-form-item__content {
  margin-left: 0 !important;
  width: 100%;
}
#workorder .media-upload-stacked .media-list {
  display: flex;
  flex-wrap: wrap;
  align-items: flex-start;
}
</style>



// WEBPACK FOOTER //
// src/components/WorkOrder/workorder.vue